import React, { useState, useEffect } from "react";
import { db, auth } from "../firebase";
import { collection, query, where, getDocs, addDoc, updateDoc, deleteDoc, doc, getDoc, onSnapshot } from "firebase/firestore";
import { onAuthStateChanged } from "firebase/auth";
import DashboardBase from "../DashboardBase";
import { getRolDisplay, hasSupeRadminPrivileges } from "../utils/roles";
import { debugSupervisorRelations } from "../utils/debugSupervisorRelations";

const EvaluacionesManager = () => {
  const [userData, setUserData] = useState(null);
  const [empleados, setEmpleados] = useState([]);
  const [plantillas, setPlantillas] = useState([]);
  const [competencias, setCompetencias] = useState([]);
  const [evaluaciones, setEvaluaciones] = useState([]);
  const [categorias, setCategorias] = useState([]);
  const [escalasLikert, setEscalasLikert] = useState([
    {
      id: "escala_5_puntos",
      nombre: "Escala 5 puntos",
      niveles: 5,
      etiquetas: [
        { valor: 1, etiqueta: "Totalmente en desacuerdo" },
        { valor: 2, etiqueta: "En desacuerdo" },
        { valor: 3, etiqueta: "Ni de acuerdo ni en desacuerdo" },
        { valor: 4, etiqueta: "De acuerdo" },
        { valor: 5, etiqueta: "Totalmente de acuerdo" }
      ]
    },
    {
      id: "escala_4_puntos",
      nombre: "Escala 4 puntos",
      niveles: 4,
      etiquetas: [
        { valor: 1, etiqueta: "Nunca" },
        { valor: 2, etiqueta: "A veces" },
        { valor: 3, etiqueta: "Frecuentemente" },
        { valor: 4, etiqueta: "Siempre" }
      ]
    }
  ]);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState("plantillas");
  const [showNewCompetenciaModal, setShowNewCompetenciaModal] = useState(false);
  const [showNewPlantillaModal, setShowNewPlantillaModal] = useState(false);
  const [showCreatePlantillaModal, setShowCreatePlantillaModal] = useState(false);
  const [showViewPlantillaModal, setShowViewPlantillaModal] = useState(false);
  const [showEditPlantillaModal, setShowEditPlantillaModal] = useState(false);
  const [selectedPlantilla, setSelectedPlantilla] = useState(null);
  const [newCompetencia, setNewCompetencia] = useState({
    nombre: '',
    descripcion: '',
    categoria: '',
    tipoCompetencia: '', // comportamental, funcional, liderazgo
    cargoEspecifico: '', // Para competencias funcionales
    requiereLiderazgo: false, // Para competencias de liderazgo
    esComportamental: false // Para competencias comportamentales
  });
  const [newPlantilla, setNewPlantilla] = useState({
    nombre: '',
    descripcion: '',
    competenciasSeleccionadas: [],
    escalaLikert: '',
    activa: false,
    // Nuevos campos para evaluación y autoevaluación
    porcentajeEvaluacion: 70,
    porcentajeAutoevaluacion: 30,
    competenciasDetalle: {} // { competenciaId: { preguntas: [{ primera_persona: '', tercera_persona: '', editada: false }], porcentaje: 0 } }
  });
  const [editPlantilla, setEditPlantilla] = useState({
    nombre: '',
    descripcion: '',
    competenciasSeleccionadas: [],
    escalaLikert: '',
    activa: false,
    porcentajeEvaluacion: 70,
    porcentajeAutoevaluacion: 30,
    competenciasDetalle: {}
  });
  const [showCompetenciaFormModal, setShowCompetenciaFormModal] = useState(false);
  const [selectedCompetenciaForForm, setSelectedCompetenciaForForm] = useState(null);
  const [currentPregunta, setCurrentPregunta] = useState({
    primera_persona: '',
    tercera_persona: '',
    editada: false
  });
  const [cargos, setCargos] = useState([]);

  // Estados para formularios inline de nueva competencia
  const [showNewCompetenciaComportamental, setShowNewCompetenciaComportamental] = useState(false);
  const [showNewCompetenciaFuncional, setShowNewCompetenciaFuncional] = useState(false);
  const [showNewCompetenciaLiderazgo, setShowNewCompetenciaLiderazgo] = useState(false);
  const [newCompetenciaInline, setNewCompetenciaInline] = useState({
    nombre: '',
    descripcion: '',
    cargoEspecifico: '',
    tipoCompetencia: '',
    empresaId: 'bemovil' // Por defecto bemovil para competencias funcionales
  });

  // Estados para el dropdown de posiciones
  const [posiciones, setPosiciones] = useState([]);
  const [filteredPosiciones, setFilteredPosiciones] = useState([]);
  const [showPosicionesDropdown, setShowPosicionesDropdown] = useState(false);
  const [posicionSearchText, setPosicionSearchText] = useState('');

  // Estados para gestión de empresas y asignación de evaluaciones
  const [empresas, setEmpresas] = useState([]);
  const [selectedEmpresa, setSelectedEmpresa] = useState(null);
  const [areas, setAreas] = useState([]);
  const [departamentos, setDepartamentos] = useState([]);
  
  // Estados para el modal de asignación de evaluaciones
  const [showAsignacionModal, setShowAsignacionModal] = useState(false);
  const [asignacionData, setAsignacionData] = useState({
    plantillaId: '',
    plantillaNombre: '',
    tipoAsignacion: 'empresa',
    empresaId: '',
    empresaNombre: '',
    departamentoId: '',
    departamentoNombre: '',
    empleadosSeleccionados: [],
    fechaInicio: '',
    fechaFin: '',
    nombre: '',
    descripcion: ''
  });

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        loadUserData(user);
      }
    });
    return () => unsubscribe();
  }, []);

  // useEffect para cerrar dropdown al hacer clic fuera
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (showPosicionesDropdown && !event.target.closest('.posiciones-dropdown-container')) {
        setShowPosicionesDropdown(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showPosicionesDropdown]);

  // useEffect para hacer scroll al formulario cuando se abre en modo edición
  useEffect(() => {
    if (selectedCompetenciaForForm) {
      console.log('📍 Formulario abierto para edición, buscando elemento para scroll...');
      
      setTimeout(() => {
        let formElement = null;
        
        if (showNewCompetenciaComportamental) {
          formElement = document.querySelector('[data-form-comportamental="true"]');
          console.log('📍 Elemento [data-form-comportamental] encontrado:', !!formElement);
        } else if (showNewCompetenciaFuncional) {
          formElement = document.querySelector('[data-form-funcional="true"]');
          console.log('📍 Elemento [data-form-funcional] encontrado:', !!formElement);
        } else if (showNewCompetenciaLiderazgo) {
          formElement = document.querySelector('[data-form-liderazgo="true"]');
          console.log('📍 Elemento [data-form-liderazgo] encontrado:', !!formElement);
        }
        
        if (formElement) {
          console.log('📍 Haciendo scroll al formulario de edición...');
          formElement.scrollIntoView({ 
            behavior: 'smooth', 
            block: 'center' 
          });
          
          // Agregar un indicador visual temporal
          const originalBorder = formElement.style.border;
          formElement.style.border = '3px solid #10b981';
          formElement.style.boxShadow = '0 0 15px rgba(16, 185, 129, 0.4)';
          
          setTimeout(() => {
            formElement.style.border = originalBorder;
            formElement.style.boxShadow = '';
          }, 2000);
          
          console.log('✅ Scroll completado y formulario resaltado');
        } else {
          console.log('❌ No se encontró el elemento del formulario');
        }
      }, 200); // Esperar a que se renderice completamente
    }
  }, [selectedCompetenciaForForm, showNewCompetenciaComportamental, showNewCompetenciaFuncional, showNewCompetenciaLiderazgo]);

  const loadUserData = async (user) => {
    try {
      console.log("🔍 Usuario Firebase:", user.email);
      
      // Si es uno de los usuarios con privilegios especiales de superadmin
      if (hasSupeRadminPrivileges(user.email)) {
        console.log("🎯 Detectado ADMIN PRINCIPAL - Forzando rol superadmin");
        const adminData = {
          uid: user.uid,
          email: user.email,
          nombre: user.email === "db@ossinnovation.com" ? "basededatos" : "Administrador",
          apellido: user.email === "db@ossinnovation.com" ? "datos" : "Sistema", 
          rol: "superadmin",
          estado: "activo",
          fechaCreacion: new Date(),
          empresa_id: "default_empresa"
        };
        console.log("✅ ACCESO AUTORIZADO - Admin principal con rol superadmin");
        setUserData(adminData);
        
        // Cargar datos de evaluaciones
        console.log('📊 Iniciando carga de datos...');
        await Promise.all([
          loadPlantillas(),
          loadCompetencias(),
          loadEvaluaciones(),
          loadEmpleados(),
          loadCargos(),
          loadEmpresas(),
          loadAreas(),
          loadDepartamentos()
        ]);
        console.log('📊 Carga de datos completada');
        return;
      }
      
      const q = query(collection(db, "usuarios"), where("uid", "==", user.uid));
      const querySnapshot = await getDocs(q);
      
      if (!querySnapshot.empty) {
        const userDoc = querySnapshot.docs[0];
        const userData = { id: userDoc.id, ...userDoc.data() };
        
        if (!userData.empresa_id) {
          userData.empresa_id = "default_empresa";
        }
        
        setUserData(userData);
        
        console.log('👤 Usuario cargado:', userData);
        
        // Cargar datos de evaluaciones
        console.log('📊 Iniciando carga de datos...');
        await Promise.all([
          loadPlantillas(),
          loadCompetencias(),
          loadEvaluaciones(),
          loadEmpleados(),
          loadCargos(),
          loadEmpresas(),
          loadAreas(),
          loadDepartamentos()
        ]);
        console.log('📊 Carga de datos completada');
      }
    } catch (error) {
      console.error("Error al cargar datos del usuario:", error);
    } finally {
      setLoading(false);
    }
  };

  const loadPlantillas = async () => {
    try {
      console.log('🔍 Intentando conectar a Firebase...');
      console.log('🔍 Base de datos:', db);
      
      const querySnapshot = await getDocs(collection(db, "plantillas_evaluacion"));
      console.log('🔍 QuerySnapshot obtenido:', querySnapshot);
      console.log('🔍 QuerySnapshot empty:', querySnapshot.empty);
      console.log('🔍 QuerySnapshot size:', querySnapshot.size);
      
      const plantillasData = querySnapshot.docs.map(doc => {
        console.log('📄 Documento encontrado:', doc.id, doc.data());
        return {
          id: doc.id,
          ...doc.data()
        };
      });
      
      console.log('📋 Plantillas cargadas:', plantillasData);
      console.log('📋 Número total de plantillas:', plantillasData.length);
      
      // Buscar específicamente la plantilla mencionada
      const plantillaEspecifica = plantillasData.find(p => p.id === 'n6AHqLWeR4qTAsapAZsx');
      if (plantillaEspecifica) {
        console.log('🎯 Plantilla específica encontrada:', plantillaEspecifica);
      } else {
        console.log('❌ Plantilla específica n6AHqLWeR4qTAsapAZsx NO encontrada');
        console.log('📋 IDs de plantillas encontradas:', plantillasData.map(p => p.id));
      }
      
      setPlantillas(plantillasData);
    } catch (error) {
      console.error("❌ Error al cargar plantillas:", error);
      console.error("❌ Error details:", error.message);
      console.error("❌ Error code:", error.code);
    }
  };

  const createTestPlantilla = async () => {
    try {
      console.log('🧪 Creando plantilla de prueba...');
      const testPlantilla = {
        nombre: 'Plantilla de Prueba',
        descripcion: 'Esta es una plantilla de prueba para verificar la funcionalidad',
        competenciasSeleccionadas: [],
        escalaLikert: 'escala_5_puntos',
        activa: true,
        fechaCreacion: new Date(),
        creadoPor: userData?.uid || 'test',
        empresa_id: userData?.empresa_id || 'default_empresa'
      };
      
      const docRef = await addDoc(collection(db, "plantillas_evaluacion"), testPlantilla);
      console.log('✅ Plantilla de prueba creada con ID:', docRef.id);
      
      // Recargar plantillas
      await loadPlantillas();
    } catch (error) {
      console.error('❌ Error al crear plantilla de prueba:', error);
    }
  };

  const testFirebaseConnection = async () => {
    try {
      console.log('🔧 Probando conexión a Firebase...');
      
      // Probar conexión básica listando colecciones
      console.log('🔧 Intentando acceder a colección usuarios...');
      const usuariosSnapshot = await getDocs(collection(db, "usuarios"));
      console.log('✅ Usuarios encontrados:', usuariosSnapshot.size);
      
      console.log('🔧 Intentando acceder a colección competencias...');
      const competenciasSnapshot = await getDocs(collection(db, "competencias"));
      console.log('✅ Competencias encontradas:', competenciasSnapshot.size);
      
      console.log('🔧 Intentando acceder a colección plantillas_evaluacion...');
      const plantillasSnapshot = await getDocs(collection(db, "plantillas_evaluacion"));
      console.log('✅ Plantillas encontradas:', plantillasSnapshot.size);
      
      console.log('🔧 Listando todas las plantillas:');
      plantillasSnapshot.docs.forEach(doc => {
        console.log('📄', doc.id, ':', doc.data());
      });
      
    } catch (error) {
      console.error('❌ Error en test de conexión:', error);
    }
  };

  // Función para actualizar competencias existentes como comportamentales
  const actualizarCompetenciasComportamentales = async () => {
    try {
      console.log('🔄 Actualizando competencias existentes como comportamentales...');
      
      const competenciasSnapshot = await getDocs(collection(db, "competencias"));
      let actualizadas = 0;
      
      for (const docSnapshot of competenciasSnapshot.docs) {
        const competencia = docSnapshot.data();
        
        // Solo actualizar si no tiene tipo definido o no es comportamental
        if (!competencia.tipo || competencia.tipo !== 'Comportamental') {
          await updateDoc(doc(db, "competencias", docSnapshot.id), {
            tipo: 'Comportamental',
            tipoCompetencia: 'comportamental', // Para consistencia con el nuevo sistema
            esComportamental: true,
            fechaActualizacion: new Date()
          });
          actualizadas++;
          console.log(`✅ Competencia actualizada: ${competencia.nombre} -> Comportamental`);
        }
      }
      
      console.log(`🎉 ${actualizadas} competencias actualizadas como comportamentales`);
      alert(`Se actualizaron ${actualizadas} competencias como comportamentales`);
      
      // Recargar competencias para ver los cambios
      await loadCompetencias();
      
    } catch (error) {
      console.error('❌ Error al actualizar competencias:', error);
      alert('Error al actualizar competencias: ' + error.message);
    }
  };

  // Función para asignar empresa bemovil a competencias funcionales
  const asignarEmpresaBemovilAFuncionales = async () => {
    try {
      console.log('🏢 Asignando empresa bemovil a competencias funcionales...');
      
      const competenciasSnapshot = await getDocs(collection(db, "competencias"));
      let actualizadas = 0;
      
      for (const docSnapshot of competenciasSnapshot.docs) {
        const competencia = docSnapshot.data();
        
        // Solo actualizar competencias funcionales que no tengan empresa_id o tengan una empresa diferente
        if ((competencia.tipoCompetencia === 'funcional' || competencia.tipo === 'Funcional') && 
            (!competencia.empresa_id || competencia.empresa_id !== 'bemovil')) {
          await updateDoc(doc(db, "competencias", docSnapshot.id), {
            empresa_id: 'bemovil',
            fechaActualizacion: new Date()
          });
          actualizadas++;
          console.log(`✅ Competencia funcional asignada a bemovil: ${competencia.nombre}`);
        }
      }
      
      console.log(`🎉 ${actualizadas} competencias funcionales asignadas a bemovil`);
      alert(`Se asignaron ${actualizadas} competencias funcionales a bemovil`);
      
      // Recargar competencias para ver los cambios
      await loadCompetencias();
      
    } catch (error) {
      console.error('❌ Error al asignar empresa a competencias funcionales:', error);
      alert('Error al asignar empresa: ' + error.message);
    }
  };

  // Función para crear evaluaciones de prueba
  const crearEvaluacionesPrueba = async () => {
    try {
      console.log('🚀 Creando evaluaciones de prueba...');
      
      if (plantillas.length === 0) {
        alert('No hay plantillas disponibles. Crea una plantilla primero.');
        return;
      }
      
      if (empleados.length === 0) {
        alert('No hay empleados disponibles.');
        return;
      }
      
      const plantillaBase = plantillas[0];
      const empleadosPrueba = empleados.slice(0, 3);
      let evaluacionesCreadas = 0;
      
      for (const empleado of empleadosPrueba) {
        // Crear autoevaluación
        const autoevaluacion = {
          empleadoId: empleado.id,
          empleadoNombre: empleado.nombres || empleado.nombre || 'Sin nombre',
          empleadoCedula: empleado.cedula || 'sin-cedula',
          empleadoEmail: empleado.email || 'sin-email@ejemplo.com',
          plantillaId: plantillaBase.id,
          plantillaNombre: plantillaBase.nombre,
          competenciasDetalle: plantillaBase.competenciasDetalle || {},
          escalaLikert: plantillaBase.escalaLikert || 'escala_5_puntos',
          tipoEvaluacion: 'autoevaluacion',
          esAutoevaluacion: true,
          estado: 'pendiente',
          activa: true,
          fechaCreacion: new Date(),
          fechaInicio: new Date(),
          fechaFin: new Date(Date.now() + 30 * 24 * 60 * 60 * 1000),
          fecha_evaluacion: new Date(), // Nueva fecha para tracking de cuándo se realizó la evaluación
          evaluacionNombre: `Autoevaluación - ${empleado.nombres || empleado.nombre}`,
          evaluacionDescripcion: `Autoevaluación basada en ${plantillaBase.nombre}`,
          empresa_id: empleado.empresa_id || 'bemovil',
          progreso: 0,
          respuestas: {},
          version: '2.0',
          creadoPor: userData?.uid || 'sistema-prueba'
        };
        
        const autoevaluacionRef = await addDoc(collection(db, "evaluaciones_asignadas"), autoevaluacion);
        console.log(`✅ Autoevaluación creada: ${autoevaluacionRef.id}`);
        evaluacionesCreadas++;
      }
      
      console.log(`🎉 ${evaluacionesCreadas} evaluaciones de prueba creadas`);
      alert(`✅ Se crearon ${evaluacionesCreadas} evaluaciones de prueba`);
      
    } catch (error) {
      console.error('❌ Error creando evaluaciones de prueba:', error);
      alert('Error: ' + error.message);
    }
  };

  // Función optimizada para corregir campos evaluadorCedula faltantes en evaluaciones_asignadas
  const corregirEvaluadorCedulaFaltantes = async () => {
    try {
      console.log('🔧 Iniciando corrección optimizada de campos evaluadorCedula...');
      
      // 1. Usar consulta filtrada para obtener solo evaluaciones que necesitan corrección
      console.log('📊 Cargando evaluaciones que necesitan corrección...');
      const evaluacionesQuery = query(
        collection(db, "evaluaciones_asignadas"),
        where("evaluadorCedula", "==", null),
        where("tipoEvaluacion", "!=", "autoevaluacion")
      );
      
      let evaluacionesSnapshot;
      try {
        evaluacionesSnapshot = await getDocs(evaluacionesQuery);
      } catch (queryError) {
        // Si la consulta compuesta falla, usar consulta simple
        console.log('⚠️ Consulta compuesta no soportada, usando consulta simple...');
        const evaluacionesTodasSnapshot = await getDocs(collection(db, "evaluaciones_asignadas"));
        const evaluacionesFiltradas = evaluacionesTodasSnapshot.docs.filter(doc => {
          const data = doc.data();
          return !data.evaluadorCedula && 
                 data.tipoEvaluacion !== 'autoevaluacion' && 
                 !data.esAutoevaluacion;
        });
        evaluacionesSnapshot = { docs: evaluacionesFiltradas };
      }
      
      const evaluaciones = evaluacionesSnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      
      console.log('📋 Evaluaciones que necesitan corrección:', evaluaciones.length);
      
      if (evaluaciones.length === 0) {
        console.log('✅ No hay evaluaciones que requieran corrección');
        alert('✅ No hay evaluaciones que requieran corrección');
        return;
      }
      
      // 2. Obtener solo las cédulas de empleados que necesitamos
      const cedulasNecesarias = new Set();
      evaluaciones.forEach(evaluacion => {
        if (evaluacion.empleadoCedula) {
          cedulasNecesarias.add(evaluacion.empleadoCedula);
        }
      });
      
      console.log('📊 Cargando solo empleados necesarios...');
      
      // 3. Cargar empleados en lotes para evitar consultas muy grandes
      const empleados = [];
      const cedulasArray = Array.from(cedulasNecesarias);
      const batchSize = 10; // Firestore permite hasta 10 elementos en consultas 'in'
      
      for (let i = 0; i < cedulasArray.length; i += batchSize) {
        const batch = cedulasArray.slice(i, i + batchSize);
        const empleadosQuery = query(
          collection(db, "empleados"),
          where("cedula", "in", batch)
        );
        const empleadosBatchSnapshot = await getDocs(empleadosQuery);
        empleados.push(...empleadosBatchSnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        })));
      }
      
      console.log('� Empleados cargados:', empleados.length);
      
      // 4. Crear mapa de empleados por cédula para búsqueda rápida
      const empleadosPorCedula = new Map();
      empleados.forEach(emp => {
        if (emp.cedula) {
          empleadosPorCedula.set(emp.cedula, emp);
        }
      });
      
      // 5. Obtener supervisores necesarios
      const cedulasSupervisores = new Set();
      empleados.forEach(emp => {
        if (emp.supervisor_cedula) {
          cedulasSupervisores.add(emp.supervisor_cedula);
        }
      });
      
      console.log('📊 Cargando supervisores...');
      const supervisores = [];
      const supervisoresArray = Array.from(cedulasSupervisores);
      
      for (let i = 0; i < supervisoresArray.length; i += batchSize) {
        const batch = supervisoresArray.slice(i, i + batchSize);
        const supervisoresQuery = query(
          collection(db, "empleados"),
          where("cedula", "in", batch)
        );
        const supervisoresBatchSnapshot = await getDocs(supervisoresQuery);
        supervisores.push(...supervisoresBatchSnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        })));
      }
      
      // 6. Crear mapa de supervisores por cédula
      const supervisoresPorCedula = new Map();
      supervisores.forEach(sup => {
        if (sup.cedula) {
          supervisoresPorCedula.set(sup.cedula, sup);
        }
      });
      
      console.log('👥 Supervisores cargados:', supervisores.length);
      
      // 7. Procesar evaluaciones y preparar actualizaciones en lote
      let evaluacionesActualizadas = 0;
      const actualizacionesLote = [];
      
      for (const evaluacion of evaluaciones) {
        console.log('\n🔍 Procesando evaluación:', evaluacion.id);
        
        const empleado = empleadosPorCedula.get(evaluacion.empleadoCedula);
        if (!empleado) {
          console.log('❌ No se encontró empleado con cédula:', evaluacion.empleadoCedula);
          continue;
        }
        
        if (!empleado.supervisor_cedula) {
          console.log('❌ Empleado no tiene supervisor_cedula definido');
          continue;
        }
        
        const supervisor = supervisoresPorCedula.get(empleado.supervisor_cedula);
        if (!supervisor) {
          console.log('❌ No se encontró supervisor con cédula:', empleado.supervisor_cedula);
          continue;
        }
        
        // Preparar datos de actualización
        const updateData = {
          evaluadorId: supervisor.id,
          evaluadorNombre: supervisor.nombres ? (supervisor.nombres + ' ' + (supervisor.apellidos || '')) : (supervisor.nombre || 'Sin nombre'),
          evaluadorEmail: supervisor.email || '',
          evaluadorCedula: supervisor.cedula
        };
        
        actualizacionesLote.push({
          id: evaluacion.id,
          data: updateData
        });
        
        console.log('✅ Preparada actualización para:', supervisor.nombre || supervisor.nombres);
      }
      
      // 8. Ejecutar actualizaciones en lotes más pequeños para evitar timeouts
      const updateBatchSize = 5;
      for (let i = 0; i < actualizacionesLote.length; i += updateBatchSize) {
        const batch = actualizacionesLote.slice(i, i + updateBatchSize);
        
        console.log(`🔄 Actualizando lote ${Math.floor(i/updateBatchSize) + 1}/${Math.ceil(actualizacionesLote.length/updateBatchSize)}...`);
        
        const updatePromises = batch.map(item => 
          updateDoc(doc(db, "evaluaciones_asignadas", item.id), item.data)
        );
        
        await Promise.all(updatePromises);
        evaluacionesActualizadas += batch.length;
        
        // Pequeña pausa entre lotes para no sobrecargar
        if (i + updateBatchSize < actualizacionesLote.length) {
          await new Promise(resolve => setTimeout(resolve, 100));
        }
      }
      
      console.log('\n🎉 Proceso completado!');
      console.log('📊 Total evaluaciones actualizadas:', evaluacionesActualizadas);
      alert(`✅ Proceso completado!\n📊 Total evaluaciones actualizadas: ${evaluacionesActualizadas}`);
      
    } catch (error) {
      console.error('❌ Error durante la corrección:', error);
      alert('❌ Error durante la corrección: ' + error.message);
    }
  };

  // Función para calcular porcentajes automáticamente
  const calcularPorcentajesCompetencias = (competenciasSeleccionadas) => {
    if (competenciasSeleccionadas.length === 0) return {};
    
    const porcentajeBase = Math.floor(100 / competenciasSeleccionadas.length);
    const resto = 100 - (porcentajeBase * competenciasSeleccionadas.length);
    
    const porcentajes = {};
    competenciasSeleccionadas.forEach((id, index) => {
      porcentajes[id] = porcentajeBase + (index < resto ? 1 : 0);
    });
    
    return porcentajes;
  };

  // Función para convertir primera persona a tercera persona automáticamente
  const convertirASegundaPersona = (textoPrimera) => {
    if (!textoPrimera) return '';
    
    let textoTercera = textoPrimera
      .replace(/\byo\b/gi, 'él/ella')
      .replace(/\bmi\b/gi, 'su')
      .replace(/\bmis\b/gi, 'sus')
      .replace(/\bme\b/gi, 'le')
      .replace(/\bconmigo\b/gi, 'con él/ella')
      .replace(/\bsoy\b/gi, 'es')
      .replace(/\bestoy\b/gi, 'está')
      .replace(/\btengo\b/gi, 'tiene')
      .replace(/\bhago\b/gi, 'hace')
      .replace(/\bpuedo\b/gi, 'puede')
      .replace(/\bquiero\b/gi, 'quiere')
      .replace(/\bdebo\b/gi, 'debe')
      .replace(/\bvoy\b/gi, 'va')
      .replace(/\bvengo\b/gi, 'viene')
      .replace(/\bdoy\b/gi, 'da')
      .replace(/\bveo\b/gi, 've')
      .replace(/\bsé\b/gi, 'sabe')
      .replace(/\bcreo\b/gi, 'cree')
      .replace(/\bpienso\b/gi, 'piensa')
      .replace(/\bsiento\b/gi, 'siente')
      .replace(/\bescucho\b/gi, 'escucha')
      .replace(/\bhablo\b/gi, 'habla')
      .replace(/\btrabajo\b/gi, 'trabaja')
      .replace(/\bmanejo\b/gi, 'maneja')
      .replace(/\blídero\b/gi, 'lidera')
      .replace(/\bcolaboró\b/gi, 'colabora')
      .replace(/\bparticipo\b/gi, 'participa')
      .replace(/\bapoyo\b/gi, 'apoya')
      .replace(/\bayudo\b/gi, 'ayuda')
      .replace(/\bresuelvo\b/gi, 'resuelve')
      .replace(/\btomo\b/gi, 'toma')
      .replace(/\bplanifico\b/gi, 'planifica')
      .replace(/\borganizo\b/gi, 'organiza')
      .replace(/\bcoordino\b/gi, 'coordina')
      .replace(/\bsuperviso\b/gi, 'supervisa')
      .replace(/\bevalúo\b/gi, 'evalúa')
      .replace(/\bdesarrollo\b/gi, 'desarrolla')
      .replace(/\bimplemento\b/gi, 'implementa')
      .replace(/\bgestiono\b/gi, 'gestiona')
      .replace(/\bcomunico\b/gi, 'comunica')
      .replace(/\bnegoció\b/gi, 'negocia')
      .replace(/\binfluyo\b/gi, 'influye')
      .replace(/\bmotivo\b/gi, 'motiva')
      .replace(/\binspiro\b/gi, 'inspira')
      .replace(/\bdelego\b/gi, 'delega')
      .replace(/\bcontrolo\b/gi, 'controla')
      .replace(/\bmonitoreo\b/gi, 'monitorea')
      .replace(/\bseguimiento\b/gi, 'da seguimiento')
      .replace(/\badapto\b/gi, 'adapta')
      .replace(/\binnovobo/gi, 'innova')
      .replace(/\bmejoro\b/gi, 'mejora')
      .replace(/\boptimizo\b/gi, 'optimiza')
      .replace(/\banálizo\b/gi, 'analiza')
      .replace(/\binterpreto\b/gi, 'interpreta')
      .replace(/\bcomprendo\b/gi, 'comprende')
      .replace(/\baprendo\b/gi, 'aprende')
      .replace(/\benseño\b/gi, 'enseña')
      .replace(/\bformo\b/gi, 'forma')
      .replace(/\bcapacito\b/gi, 'capacita')
      .replace(/\bentrego\b/gi, 'entrega')
      .replace(/\bcumplo\b/gi, 'cumple')
      .replace(/\balcanzo\b/gi, 'alcanza')
      .replace(/\blogro\b/gi, 'logra')
      .replace(/\bobtengo\b/gi, 'obtiene')
      .replace(/\bconsigo\b/gi, 'consigue')
      .replace(/\bproduzco\b/gi, 'produce')
      .replace(/\bgenero\b/gi, 'genera')
      .replace(/\bcreo\b/gi, 'crea')
      .replace(/\bconstruyo\b/gi, 'construye')
      .replace(/\bedifícou/gi, 'edifica')
      .replace(/\bestablezco\b/gi, 'establece')
      .replace(/\bdefino\b/gi, 'define')
      .replace(/\bdetermino\b/gi, 'determina')
      .replace(/\bdecido\b/gi, 'decide')
      .replace(/\belijo\b/gi, 'elige')
      .replace(/\bselecciono\b/gi, 'selecciona')
      .replace(/\bescojo\b/gi, 'escoge')
      .replace(/\bacepto\b/gi, 'acepta')
      .replace(/\brechazo\b/gi, 'rechaza')
      .replace(/\bagruebo\b/gi, 'aprueba')
      .replace(/\bdesapruebu/gi, 'desaprueba')
      .replace(/\bconfirmo\b/gi, 'confirma')
      .replace(/\bniego\b/gi, 'niega')
      .replace(/\bafirmo\b/gi, 'afirma')
      .replace(/\bdeclaro\b/gi, 'declara')
      .replace(/\bmanifiesto\b/gi, 'manifiesta')
      .replace(/\bexpreso\b/gi, 'expresa')
      .replace(/\btransmito\b/gi, 'transmite')
      .replace(/\bcomparto\b/gi, 'comparte')
      .replace(/\bdifundo\b/gi, 'difunde')
      .replace(/\bpropago\b/gi, 'propaga')
      .replace(/\bextiendo\b/gi, 'extiende')
      .replace(/\bamplio\b/gi, 'amplía')
      .replace(/\bexpando\b/gi, 'expande')
      .replace(/\bincremento\b/gi, 'incrementa')
      .replace(/\baumento\b/gi, 'aumenta')
      .replace(/\breduzco\b/gi, 'reduce')
      .replace(/\bdisminuyo\b/gi, 'disminuye')
      .replace(/\blimito\b/gi, 'limita')
      .replace(/\brestrínjo/gi, 'restringe')
      .replace(/\bcontrolo\b/gi, 'controla')
      .replace(/\bregulo\b/gi, 'regula')
      .replace(/\badministro\b/gi, 'administra')
      .replace(/\bdiríjo/gi, 'dirige')
      .replace(/\bguío\b/gi, 'guía')
      .replace(/\boriento\b/gi, 'orienta')
      .replace(/\bencamino\b/gi, 'encamina')
      .replace(/\bconduzco\b/gi, 'conduce')
      .replace(/\bllevo\b/gi, 'lleva')
      .replace(/\btraigo\b/gi, 'trae')
      .replace(/\benvío\b/gi, 'envía')
      .replace(/\bmando\b/gi, 'manda')
      .replace(/\bordeno\b/gi, 'ordena')
      .replace(/\binstruyo\b/gi, 'instruye')
      .replace(/\bindico\b/gi, 'indica')
      .replace(/\bseñalo\b/gi, 'señala')
      .replace(/\bmarco\b/gi, 'marca')
      .replace(/\bdestachu/gi, 'destaca')
      .replace(/\bresalto\b/gi, 'resalta')
      .replace(/\bsubrayo\b/gi, 'subraya')
      .replace(/\benfatizo\b/gi, 'enfatiza')
      .replace(/\bacentúo\b/gi, 'acentúa')
      .replace(/\brefuerzo\b/gi, 'refuerza')
      .replace(/\bfortalezcó/gi, 'fortalece')
      .replace(/\bconsolido\b/gi, 'consolida')
      .replace(/\bafianzo\b/gi, 'afianza')
      .replace(/\baseguro\b/gi, 'asegura')
      .replace(/\bgarantizo\b/gi, 'garantiza')
      .replace(/\bprotejo\b/gi, 'protege')
      .replace(/\bcuido\b/gi, 'cuida')
      .replace(/\bmantengo\b/gi, 'mantiene')
      .replace(/\bpreservo\b/gi, 'preserva')
      .replace(/\bconservo\b/gi, 'conserva')
      .replace(/\bguardo\b/gi, 'guarda')
      .replace(/\balmaceno\b/gi, 'almacena')
      .replace(/\barchivo\b/gi, 'archiva')
      .replace(/\bregistro\b/gi, 'registra')
      .replace(/\bdocumento\b/gi, 'documenta')
      .replace(/\breporto\b/gi, 'reporta')
      .replace(/\binformo\b/gi, 'informa')
      .replace(/\baviso\b/gi, 'avisa')
      .replace(/\bnotificó/gi, 'notifica')
      .replace(/\badvierto\b/gi, 'advierte')
      .replace(/\balertu/gi, 'alerta')
      .replace(/\bprevengo\b/gi, 'previene')
      .replace(/\bevitu/gi, 'evita')
      .replace(/\beludu/gi, 'elude')
      .replace(/\besquivo\b/gi, 'esquiva')
      .replace(/\bhuyo\b/gi, 'huye')
      .replace(/\bescapo\b/gi, 'escapa')
      .replace(/\bme libero\b/gi, 'se libera')
      .replace(/\bme desprendo\b/gi, 'se desprende')
      .replace(/\bme separo\b/gi, 'se separa')
      .replace(/\bme alejo\b/gi, 'se aleja')
      .replace(/\bme distancio\b/gi, 'se distancia')
      .replace(/\bme acerco\b/gi, 'se acerca')
      .replace(/\bme aproximo\b/gi, 'se aproxima')
      .replace(/\bme dirijo\b/gi, 'se dirige')
      .replace(/\bme encamino\b/gi, 'se encamina')
      .replace(/\bme muevo\b/gi, 'se mueve')
      .replace(/\bme desplazo\b/gi, 'se desplaza')
      .replace(/\bme traslado\b/gi, 'se traslada')
      .replace(/\bme ubico\b/gi, 'se ubica')
      .replace(/\bme sitúo\b/gi, 'se sitúa')
      .replace(/\bme coloco\b/gi, 'se coloca')
      .replace(/\bme pongo\b/gi, 'se pone')
      .replace(/\bme quito\b/gi, 'se quita')
      .replace(/\bme retiro\b/gi, 'se retira')
      .replace(/\bme voy\b/gi, 'se va')
      .replace(/\bme quedo\b/gi, 'se queda')
      .replace(/\bme mantengo\b/gi, 'se mantiene')
      .replace(/\bme sostengo\b/gi, 'se sostiene')
      .replace(/\bme apoyo\b/gi, 'se apoya')
      .replace(/\bme baso\b/gi, 'se basa')
      .replace(/\bme fundamento\b/gi, 'se fundamenta')
      .replace(/\bme centro\b/gi, 'se centra')
      .replace(/\bme concentro\b/gi, 'se concentra')
      .replace(/\bme enfoco\b/gi, 'se enfoca')
      .replace(/\bme especializo\b/gi, 'se especializa')
      .replace(/\bme dedico\b/gi, 'se dedica')
      .replace(/\bme entrego\b/gi, 'se entrega')
      .replace(/\bme comprometo\b/gi, 'se compromete')
      .replace(/\bme obligo\b/gi, 'se obliga')
      .replace(/\bme responsabilizo\b/gi, 'se responsabiliza')
      .replace(/\bme encargo\b/gi, 'se encarga')
      .replace(/\bme ocupo\b/gi, 'se ocupa')
      .replace(/\bme preocupo\b/gi, 'se preocupa')
      .replace(/\bme intereso\b/gi, 'se interesa')
      .replace(/\bme motivo\b/gi, 'se motiva')
      .replace(/\bme inspiro\b/gi, 'se inspira')
      .replace(/\bme emociono\b/gi, 'se emociona')
      .replace(/\bme alegro\b/gi, 'se alegra')
      .replace(/\bme entusiasmo\b/gi, 'se entusiasma')
      .replace(/\bme animo\b/gi, 'se anima')
      .replace(/\bme desanimo\b/gi, 'se desanima')
      .replace(/\bme desaliento\b/gi, 'se desalienta')
      .replace(/\bme decepciono\b/gi, 'se decepciona')
      .replace(/\bme frustu/gi, 'se frustra')
      .replace(/\bme molesto\b/gi, 'se molesta')
      .replace(/\bme enojo\b/gi, 'se enoja')
      .replace(/\bme irrito\b/gi, 'se irrita')
      .replace(/\bme disgusto\b/gi, 'se disgusta')
      .replace(/\bme incomodo\b/gi, 'se incomoda')
      .replace(/\bme tranquilizo\b/gi, 'se tranquiliza')
      .replace(/\bme calmo\b/gi, 'se calma')
      .replace(/\bme relajo\b/gi, 'se relaja')
      .replace(/\bme sereno\b/gi, 'se serena')
      .replace(/\bme aquieto\b/gi, 'se aquieta')
      .replace(/\bme pacificar/gi, 'se pacifica')
      .replace(/\bme adapto\b/gi, 'se adapta')
      .replace(/\bme ajusto\b/gi, 'se ajusta')
      .replace(/\bme acomodo\b/gi, 'se acomoda')
      .replace(/\bme adecuo\b/gi, 'se adecua')
      .replace(/\bme conformo\b/gi, 'se conforma')
      .replace(/\bme resignó/gi, 'se resigna')
      .replace(/\bme acepto\b/gi, 'se acepta')
      .replace(/\bme asumo\b/gi, 'se asume')
      .replace(/\bme reconozco\b/gi, 'se reconoce')
      .replace(/\bme identifico\b/gi, 'se identifica')
      .replace(/\bme relaciono\b/gi, 'se relaciona')
      .replace(/\bme vinculo\b/gi, 'se vincula')
      .replace(/\bme conecto\b/gi, 'se conecta')
      .replace(/\bme uno\b/gi, 'se une')
      .replace(/\bme integro\b/gi, 'se integra')
      .replace(/\bme incorporo\b/gi, 'se incorpora')
      .replace(/\bme incluyo\b/gi, 'se incluye')
      .replace(/\bme sumo\b/gi, 'se suma')
      .replace(/\bme adhiero\b/gi, 'se adhiere')
      .replace(/\bme afilio\b/gi, 'se afilia')
      .replace(/\bme asocio\b/gi, 'se asocia')
      .replace(/\bme aliado\b/gi, 'se alía')
      .replace(/\bme confedero\b/gi, 'se confedera');

    return textoTercera;
  };

  // Función para manejar la selección de competencias con cálculo automático
  const handleCompetenciaSelection = (competenciaId, isCreatingNew = true) => {
    const plantillaState = isCreatingNew ? newPlantilla : editPlantilla;
    const setPlantillaState = isCreatingNew ? setNewPlantilla : setEditPlantilla;

    const isSelected = plantillaState.competenciasSeleccionadas.includes(competenciaId);
    let nuevasCompetenciasSeleccionadas;
    let nuevoDetalle = { ...plantillaState.competenciasDetalle };

    if (isSelected) {
      // Remover competencia
      nuevasCompetenciasSeleccionadas = plantillaState.competenciasSeleccionadas.filter(id => id !== competenciaId);
      delete nuevoDetalle[competenciaId];
    } else {
      // Agregar competencia
      nuevasCompetenciasSeleccionadas = [...plantillaState.competenciasSeleccionadas, competenciaId];
      nuevoDetalle[competenciaId] = {
        preguntas: [],
        porcentaje: 0
      };
    }

    // Calcular nuevos porcentajes
    const porcentajes = calcularPorcentajesCompetencias(nuevasCompetenciasSeleccionadas);
    
    // Actualizar porcentajes en el detalle
    nuevasCompetenciasSeleccionadas.forEach(id => {
      if (nuevoDetalle[id]) {
        nuevoDetalle[id].porcentaje = porcentajes[id] || 0;
      }
    });

    setPlantillaState({
      ...plantillaState,
      competenciasSeleccionadas: nuevasCompetenciasSeleccionadas,
      competenciasDetalle: nuevoDetalle
    });
  };

  // Estado para controlar qué competencia está siendo editada
  const [competenciaEnEdicion, setCompetenciaEnEdicion] = useState(null);
  
  // Función para abrir/cerrar formulario de creación de preguntas inline
  const openCompetenciaForm = (competencia) => {
    if (competenciaEnEdicion === competencia.id) {
      // Si ya está abierta, cerrar
      setCompetenciaEnEdicion(null);
      setCurrentPregunta({
        primera_persona: '',
        tercera_persona: '',
        editada: false
      });
    } else {
      // Abrir nueva
      setCompetenciaEnEdicion(competencia.id);
      setSelectedCompetenciaForForm(competencia);
      setCurrentPregunta({
        primera_persona: '',
        tercera_persona: '',
        editada: false
      });
    }
  };

  // Función para manejar cambio en pregunta de primera persona
  const handlePrimeraPersonaChange = (texto) => {
    const terceraPersona = convertirASegundaPersona(texto);
    setCurrentPregunta({
      primera_persona: texto,
      tercera_persona: terceraPersona,
      editada: false
    });
  };

  // Función mejorada para crear plantilla con toda la nueva funcionalidad

  // Función para agregar pregunta a competencia
  const addPreguntaToCompetencia = () => {
    if (!currentPregunta.primera_persona.trim() || !selectedCompetenciaForForm) return;

    const nuevaPregunta = {
      primera_persona: currentPregunta.primera_persona.trim(),
      tercera_persona: currentPregunta.tercera_persona.trim(),
      porcentaje: 0 // Se calculará automáticamente
    };

    setNewPlantilla(prev => {
      const competenciasDetalle = { ...prev.competenciasDetalle };
      
      if (!competenciasDetalle[selectedCompetenciaForForm.id]) {
        competenciasDetalle[selectedCompetenciaForForm.id] = {
          competenciaId: selectedCompetenciaForForm.id,
          porcentaje: 0,
          preguntas: []
        };
      }
      
      competenciasDetalle[selectedCompetenciaForForm.id].preguntas.push(nuevaPregunta);
      
      // Recalcular porcentajes automáticamente
      const totalPreguntas = competenciasDetalle[selectedCompetenciaForForm.id].preguntas.length;
      const porcentajePorPregunta = totalPreguntas > 0 ? Math.floor(100 / totalPreguntas) : 0;
      const remainder = totalPreguntas > 0 ? 100 % totalPreguntas : 0;
      
      competenciasDetalle[selectedCompetenciaForForm.id].preguntas.forEach((pregunta, index) => {
        pregunta.porcentaje = porcentajePorPregunta + (index < remainder ? 1 : 0);
      });
      
      return {
        ...prev,
        competenciasDetalle
      };
    });

    // Limpiar formulario
    setCurrentPregunta({
      primera_persona: '',
      tercera_persona: '',
      editada: false
    });
  };

  // Funciones para manejar creación de competencias inline
  const openNewCompetenciaForm = (tipo) => {
    console.log('🚀 Abriendo formulario de competencia tipo:', tipo);
    console.log('📝 Estado de edición actual:', selectedCompetenciaForForm ? 'EDITANDO' : 'CREANDO');
    
    // Si NO estamos editando, resetear formulario
    if (!selectedCompetenciaForForm) {
      console.log('🆕 Modo creación - reseteando formulario');
      setNewCompetenciaInline({
        nombre: '',
        descripcion: '',
        cargoEspecifico: '',
        tipoCompetencia: tipo,
        empresaId: 'bemovil' // Por defecto bemovil para competencias funcionales
      });
    } else {
      console.log('✏️ Modo edición - conservando datos del formulario');
    }

    // Abrir el formulario correspondiente
    switch(tipo) {
      case 'comportamental':
        console.log('🧠 Abriendo formulario comportamental');
        setShowNewCompetenciaComportamental(true);
        setShowNewCompetenciaFuncional(false);
        setShowNewCompetenciaLiderazgo(false);
        break;
      case 'funcional':
        console.log('⚙️ Abriendo formulario funcional');
        setShowNewCompetenciaComportamental(false);
        setShowNewCompetenciaFuncional(true);
        setShowNewCompetenciaLiderazgo(false);
        break;
      case 'liderazgo':
        console.log('👑 Abriendo formulario liderazgo');
        setShowNewCompetenciaComportamental(false);
        setShowNewCompetenciaFuncional(false);
        setShowNewCompetenciaLiderazgo(true);
        break;
    }
    
    console.log('✅ Formularios configurados correctamente');
  };

  const closeNewCompetenciaForms = () => {
    setShowNewCompetenciaComportamental(false);
    setShowNewCompetenciaFuncional(false);
    setShowNewCompetenciaLiderazgo(false);
    setNewCompetenciaInline({
      nombre: '',
      descripcion: '',
      cargoEspecifico: '',
      tipoCompetencia: '',
      empresaId: 'bemovil' // Por defecto bemovil para competencias funcionales
    });
    // Limpiar estados del dropdown de posiciones
    setPosicionSearchText('');
    setShowPosicionesDropdown(false);
    setSelectedCompetenciaForForm(null); // CORREGIDO: Limpiar estado de edición
    // CORREGIDO: Aplicar filtro de empresa al resetear
    const posicionesFiltradas = selectedEmpresa?.id 
      ? posiciones.filter(posicion => posicion.empresa_id === selectedEmpresa.id)
      : posiciones;
    setFilteredPosiciones(posicionesFiltradas);
  };

  // Funciones para el dropdown de posiciones
  const handlePosicionSearch = (searchText) => {
    setPosicionSearchText(searchText);
    
    // CORREGIDO: Filtrar posiciones por empresa seleccionada
    let posicionesFiltradas = posiciones;
    
    // Primero filtrar por empresa si hay una seleccionada
    if (selectedEmpresa?.id) {
      posicionesFiltradas = posiciones.filter(posicion => 
        posicion.empresa_id === selectedEmpresa.id
      );
    }
    
    if (searchText.trim() === '') {
      setFilteredPosiciones(posicionesFiltradas);
    } else {
      const filtered = posicionesFiltradas.filter(posicion =>
        posicion.nombre?.toLowerCase().includes(searchText.toLowerCase()) ||
        posicion.departamento?.toLowerCase().includes(searchText.toLowerCase())
      );
      setFilteredPosiciones(filtered);
    }
    
    setShowPosicionesDropdown(true);
  };

  const selectPosicion = (posicion) => {
    setNewCompetenciaInline({
      ...newCompetenciaInline,
      cargoEspecifico: posicion.nombre
    });
    setPosicionSearchText(posicion.nombre);
    setShowPosicionesDropdown(false);
  };

  const handleCreateCompetenciaInline = async () => {
    // Si estamos editando, usar la función de actualización
    if (selectedCompetenciaForForm?.id) {
      return await handleUpdateCompetencia();
    }

    try {
      // Validaciones básicas
      if (!newCompetenciaInline.nombre.trim()) {
        alert('El nombre de la competencia es requerido');
        return;
      }
      
      if (!newCompetenciaInline.descripcion.trim()) {
        alert('La descripción es requerida');
        return;
      }

      // Validación específica para competencias funcionales
      if (newCompetenciaInline.tipoCompetencia === 'funcional' && !newCompetenciaInline.cargoEspecifico.trim()) {
        alert('El cargo específico es requerido para competencias funcionales');
        return;
      }

      // NUEVA VALIDACIÓN: Verificar que hay una empresa seleccionada para competencias funcionales
      if (newCompetenciaInline.tipoCompetencia === 'funcional' && !newCompetenciaInline.empresaId) {
        alert('Debe seleccionar una empresa antes de crear competencias funcionales');
        return;
      }

      const nuevaCompetencia = {
        nombre: newCompetenciaInline.nombre.trim(),
        descripcion: newCompetenciaInline.descripcion.trim(),
        tipoCompetencia: newCompetenciaInline.tipoCompetencia,
        tipo: newCompetenciaInline.tipoCompetencia === 'comportamental' ? 'Comportamental' :
              newCompetenciaInline.tipoCompetencia === 'funcional' ? 'Funcional' : 'Liderazgo',
        fechaCreacion: new Date(),
        fechaModificacion: new Date(),
        creadoPor: userData?.uid || 'sistema',
        // CORREGIDO: Para competencias funcionales usar empresa seleccionada, para otras usar empresa del usuario
        empresa_id: newCompetenciaInline.tipoCompetencia === 'funcional' 
          ? (newCompetenciaInline.empresaId || 'bemovil')
          : (userData?.empresa_id || 'default_empresa'),
        activa: true
      };

      // Campos específicos según el tipo
      if (newCompetenciaInline.tipoCompetencia === 'comportamental') {
        nuevaCompetencia.esComportamental = true;
        nuevaCompetencia.categoria = 'Comportamental';
      } else if (newCompetenciaInline.tipoCompetencia === 'funcional') {
        nuevaCompetencia.cargo = newCompetenciaInline.cargoEspecifico.trim();
        nuevaCompetencia.cargoEspecifico = newCompetenciaInline.cargoEspecifico.trim();
      } else if (newCompetenciaInline.tipoCompetencia === 'liderazgo') {
        nuevaCompetencia.requiereLiderazgo = true;
        nuevaCompetencia.cargo = 'Posiciones de Liderazgo';
      }

      console.log('🚀 Creando competencia inline:', nuevaCompetencia);
      console.log('🏢 Empresa seleccionada para competencia funcional:', selectedEmpresa?.id, selectedEmpresa?.nombre);

      const docRef = await addDoc(collection(db, "competencias"), nuevaCompetencia);
      console.log('✅ Competencia creada con ID:', docRef.id);

      // Recargar competencias para que aparezca inmediatamente
      await loadCompetencias();

      // Cerrar formularios
      closeNewCompetenciaForms();
      setSelectedCompetenciaForForm(null); // CORREGIDO: Limpiar estado de edición

      alert('✅ Competencia creada exitosamente');

    } catch (error) {
      console.error('❌ Error al crear competencia:', error);
      alert('Error al crear la competencia: ' + error.message);
    }
  };

  // Funciones para editar y eliminar competencias
  const handleEditCompetencia = (competencia, e) => {
    console.log('�🔴🔴 BOTÓN EDITAR CLICADO 🔴🔴🔴');
    console.log('📋 Datos de la competencia:', competencia);
    e.stopPropagation(); // Evitar que se active la selección
    
    try {
      console.log('🔄 PASO 1: Cargando datos en newCompetencia...');
      // CAMBIO FUNDAMENTAL: Usar el modal principal de crear competencias
      // Cargar todos los datos de la competencia en el estado del modal principal
      setNewCompetencia({
        nombre: competencia.nombre || '',
        descripcion: competencia.descripcion || '',
        categoria: competencia.categoria || '',
        tipoCompetencia: competencia.tipoCompetencia || (
          competencia.tipo === 'Comportamental' ? 'comportamental' :
          competencia.tipo === 'Funcional' ? 'funcional' : 'liderazgo'
        ),
        cargoEspecifico: competencia.cargoEspecifico || competencia.cargo || '',
        requiereLiderazgo: competencia.requiereLiderazgo || false,
        esComportamental: competencia.esComportamental || false
      });
      console.log('✅ PASO 1 COMPLETADO: Datos cargados');
      
      console.log('🔄 PASO 2: Marcando para edición...');
      // Marcar que estamos editando (para cambiar el comportamiento del botón guardar)
      setSelectedCompetenciaForForm(competencia);
      console.log('✅ PASO 2 COMPLETADO: Marcado para edición');
      
      console.log('🔄 PASO 3: Cambiando a tab competencias...');
      // Cambiar a la pestaña de competencias
      setActiveTab('competencias');
      console.log('✅ PASO 3 COMPLETADO: Tab cambiado');
      
      console.log('🔄 PASO 4: Abriendo modal...');
      // Abrir el modal principal
      setShowNewCompetenciaModal(true);
      console.log('✅ PASO 4 COMPLETADO: Modal abierto');
      
      console.log('🔄 PASO 5: Programando scroll...');
      // Hacer scroll automático al modal después de que se renderice
      setTimeout(() => {
        console.log('🔍 Buscando modal en el DOM...');
        const modal = document.querySelector('[style*="position: fixed"][style*="z-index: 1000"]');
        console.log('🎯 Modal encontrado:', !!modal);
        if (modal) {
          console.log('📍 Haciendo scroll al modal de edición');
          modal.scrollIntoView({ 
            behavior: 'smooth', 
            block: 'center' 
          });
          
          // Resaltar visualmente el modal
          const originalBorder = modal.style.border;
          modal.style.border = '5px solid #ff0000'; // ROJO SÚPER VISIBLE
          modal.style.boxShadow = '0 0 30px rgba(255, 0, 0, 0.8)';
          
          setTimeout(() => {
            modal.style.border = originalBorder;
            modal.style.boxShadow = '';
          }, 3000);
          
          console.log('✅ PASO 5 COMPLETADO: Modal resaltado y scroll completado');
        } else {
          console.log('❌ PASO 5 FALLÓ: No se encontró el modal');
          // Intentar encontrar cualquier modal
          const allModals = document.querySelectorAll('[style*="position: fixed"]');
          console.log('🔍 Todos los elementos fixed encontrados:', allModals.length);
          allModals.forEach((el, i) => {
            console.log(`Modal ${i}:`, el);
          });
        }
      }, 500); // Más tiempo para asegurar render
      
      console.log('🟢🟢🟢 FUNCIÓN HANDLEEDITCOMPETENCIA COMPLETADA 🟢🟢🟢');
      
    } catch (error) {
      console.error('💥💥💥 ERROR EN HANDLEEDITCOMPETENCIA:', error);
    }
  };

  const handleUpdateCompetencia = async () => {
    if (!selectedCompetenciaForForm?.id) return;
    
    try {
      // Validaciones básicas
      if (!newCompetenciaInline.nombre.trim()) {
        alert('El nombre de la competencia es requerido');
        return;
      }
      
      if (!newCompetenciaInline.descripcion.trim()) {
        alert('La descripción es requerida');
        return;
      }

      // Validación específica para competencias funcionales
      if (newCompetenciaInline.tipoCompetencia === 'funcional' && !newCompetenciaInline.cargoEspecifico.trim()) {
        alert('El cargo específico es requerido para competencias funcionales');
        return;
      }

      const competenciaActualizada = {
        nombre: newCompetenciaInline.nombre.trim(),
        descripcion: newCompetenciaInline.descripcion.trim(),
        tipoCompetencia: newCompetenciaInline.tipoCompetencia,
        tipo: newCompetenciaInline.tipoCompetencia === 'comportamental' ? 'Comportamental' :
              newCompetenciaInline.tipoCompetencia === 'funcional' ? 'Funcional' : 'Liderazgo',
        fechaModificacion: new Date(),
        modificadoPor: userData?.uid || 'sistema'
      };

      // Campos específicos según el tipo
      if (newCompetenciaInline.tipoCompetencia === 'comportamental') {
        competenciaActualizada.esComportamental = true;
        competenciaActualizada.categoria = 'Comportamental';
      } else if (newCompetenciaInline.tipoCompetencia === 'funcional') {
        competenciaActualizada.cargo = newCompetenciaInline.cargoEspecifico.trim();
        competenciaActualizada.cargoEspecifico = newCompetenciaInline.cargoEspecifico.trim();
      } else if (newCompetenciaInline.tipoCompetencia === 'liderazgo') {
        competenciaActualizada.requiereLiderazgo = true;
        competenciaActualizada.cargo = 'Posiciones de Liderazgo';
      }

      console.log('🔄 Actualizando competencia:', selectedCompetenciaForForm.id, competenciaActualizada);

      await updateDoc(doc(db, "competencias", selectedCompetenciaForForm.id), competenciaActualizada);
      console.log('✅ Competencia actualizada con ID:', selectedCompetenciaForForm.id);

      // Recargar competencias para que aparezcan los cambios
      await loadCompetencias();

      // Cerrar formularios y limpiar estado
      closeNewCompetenciaForms();
      setSelectedCompetenciaForForm(null);

      alert('✅ Competencia actualizada exitosamente');

    } catch (error) {
      console.error('❌ Error al actualizar competencia:', error);
      alert('Error al actualizar la competencia: ' + error.message);
    }
  };

  const handleDeleteCompetencia = async (competencia, e) => {
    e.stopPropagation(); // Evitar que se active la selección
    
    if (window.confirm(`¿Estás seguro de eliminar la competencia "${competencia.nombre}"?`)) {
      try {
        console.log('🗑️ Eliminando competencia:', competencia.id, competencia.nombre);
        
        await deleteDoc(doc(db, "competencias", competencia.id));
        console.log('✅ Competencia eliminada con ID:', competencia.id);

        // Recargar competencias para actualizar la lista
        await loadCompetencias();
        
        alert('✅ Competencia eliminada exitosamente');

      } catch (error) {
        console.error('❌ Error al eliminar competencia:', error);
        alert('Error al eliminar la competencia: ' + error.message);
      }
    }
  };

  const handleCreatePlantillaComplete = async () => {
    try {
      // Validaciones
      if (!newPlantilla.nombre.trim()) {
        alert('El nombre de la plantilla es requerido');
        return;
      }
      
      if (!newPlantilla.descripcion.trim()) {
        alert('La descripción es requerida');
        return;
      }
      
      if (!newPlantilla.escalaLikert) {
        alert('La escala de calificación es requerida');
        return;
      }
      
      if (newPlantilla.competenciasSeleccionadas.length === 0) {
        alert('Debe seleccionar al menos una competencia');
        return;
      }

      // Validar que todas las competencias tengan preguntas
      const competenciasSinPreguntas = newPlantilla.competenciasSeleccionadas.filter(
        competenciaId => !newPlantilla.competenciasDetalle[competenciaId]?.preguntas?.length
      );

      if (competenciasSinPreguntas.length > 0) {
        alert('Todas las competencias seleccionadas deben tener al menos una afirmación creada');
        return;
      }

      // Validar porcentajes
      if (newPlantilla.porcentajeEvaluacion + newPlantilla.porcentajeAutoevaluacion !== 100) {
        alert('Los porcentajes de evaluación y autoevaluación deben sumar 100%');
        return;
      }

      const plantillaCompleta = {
        nombre: newPlantilla.nombre,
        descripcion: newPlantilla.descripcion,
        competenciasSeleccionadas: newPlantilla.competenciasSeleccionadas,
        competenciasDetalle: newPlantilla.competenciasDetalle,
        escalaLikert: newPlantilla.escalaLikert,
        activa: newPlantilla.activa,
        porcentajeEvaluacion: newPlantilla.porcentajeEvaluacion,
        porcentajeAutoevaluacion: newPlantilla.porcentajeAutoevaluacion,
        fechaModificacion: new Date(),
        version: '2.0'
      };

      // Verificar si estamos editando una plantilla existente o creando una nueva
      if (selectedPlantilla) {
        // EDITANDO plantilla existente
        console.log('🔄 Actualizando plantilla existente:', selectedPlantilla.id, plantillaCompleta);
        
        await updateDoc(doc(db, "plantillas_evaluacion", selectedPlantilla.id), plantillaCompleta);
        console.log('✅ Plantilla actualizada con ID:', selectedPlantilla.id);
        
        alert('✅ Plantilla de evaluación actualizada exitosamente');
      } else {
        // CREANDO nueva plantilla
        plantillaCompleta.fechaCreacion = new Date();
        plantillaCompleta.creadoPor = userData?.uid || 'sistema';
        
        console.log('🚀 Creando plantilla nueva:', plantillaCompleta);
        
        const docRef = await addDoc(collection(db, "plantillas_evaluacion"), plantillaCompleta);
        console.log('✅ Plantilla creada con ID:', docRef.id);
        
        alert('✅ Plantilla de evaluación creada exitosamente');
      }

      // Recargar plantillas
      await loadPlantillas();

      // Resetear formulario y estado
      setNewPlantilla({
        nombre: '',
        descripcion: '',
        competenciasSeleccionadas: [],
        competenciasDetalle: {},
        escalaLikert: '',
        activa: false,
        porcentajeEvaluacion: 70,
        porcentajeAutoevaluacion: 30
      });
      
      setSelectedPlantilla(null); // Limpiar plantilla seleccionada
      setCompetenciaEnEdicion(null); // Cerrar cualquier formulario de competencia abierto

      // Cerrar modal
      setShowCreatePlantillaModal(false);

    } catch (error) {
      console.error('❌ Error al procesar plantilla:', error);
      alert('Error al procesar la plantilla: ' + error.message);
    }
  };

  const loadCompetencias = async () => {
    try {
      const querySnapshot = await getDocs(collection(db, "competencias"));
      const competenciasData = querySnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      
      console.log('📊 Competencias cargadas:', competenciasData.length);
      competenciasData.forEach(comp => {
        console.log(`📝 ${comp.nombre}: tipo=${comp.tipo || 'sin tipo'}, tipoCompetencia=${comp.tipoCompetencia || 'sin tipoCompetencia'}`);
      });
      
      setCompetencias(competenciasData);
      
      // TEMPORAL: Asignar bemovil a competencias funcionales una sola vez
      const funcionalesNeedUpdate = competenciasData.filter(comp => 
        (comp.tipoCompetencia === 'funcional' || comp.tipo === 'Funcional') && 
        (!comp.empresa_id || comp.empresa_id !== 'bemovil')
      );
      
      if (funcionalesNeedUpdate.length > 0) {
        console.log(`🏢 Encontradas ${funcionalesNeedUpdate.length} competencias funcionales sin empresa bemovil. Actualizando...`);
        await asignarEmpresaBemovilAFuncionales();
      }
    } catch (error) {
      console.error("Error al cargar competencias:", error);
    }
  };

  const loadEvaluaciones = async () => {
    try {
      const querySnapshot = await getDocs(collection(db, "evaluaciones"));
      const evaluacionesData = querySnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      setEvaluaciones(evaluacionesData);
    } catch (error) {
      console.error("Error al cargar evaluaciones:", error);
    }
  };

  const loadEmpleados = async () => {
    try {
      const querySnapshot = await getDocs(collection(db, "empleados"));
      const empleadosData = querySnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      setEmpleados(empleadosData);
      
      // Ejecutar debug de relaciones supervisor-subordinado
      console.log('🔧 Ejecutando debug de relaciones supervisor-subordinado...');
      await debugSupervisorRelations();
      
    } catch (error) {
      console.error("Error al cargar empleados:", error);
    }
  };

  const loadCargos = async () => {
    try {
      const querySnapshot = await getDocs(collection(db, "posiciones"));
      const cargosData = querySnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      setCargos(cargosData);
      setPosiciones(cargosData); // También cargar en el estado de posiciones para el dropdown
      setFilteredPosiciones(cargosData); // Inicializar lista filtrada
    } catch (error) {
      console.error("Error al cargar posiciones:", error);
    }
  };

  const loadEmpresas = async () => {
    try {
      const querySnapshot = await getDocs(collection(db, "empresas"));
      const empresasData = querySnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      setEmpresas(empresasData);
      console.log('🏢 Empresas cargadas:', empresasData.length);
    } catch (error) {
      console.error("Error al cargar empresas:", error);
    }
  };

  const loadAreas = async () => {
    try {
      if (selectedEmpresa) {
        const querySnapshot = await getDocs(
          query(collection(db, "areas"), where("empresa_id", "==", selectedEmpresa.id))
        );
        const areasData = querySnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));
        setAreas(areasData);
        console.log('🏢 Áreas cargadas:', areasData.length);
      }
    } catch (error) {
      console.error("Error al cargar áreas:", error);
    }
  };

  const loadDepartamentos = async () => {
    try {
      const querySnapshot = await getDocs(collection(db, "departamentos"));
      const departamentosData = querySnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      setDepartamentos(departamentosData);
      console.log('🏢 Departamentos cargados:', departamentosData.length);
    } catch (error) {
      console.error("Error al cargar departamentos:", error);
    }
  };

  // Funciones de filtrado eliminadas ya que el modal ahora es una nueva ventana independiente

  const handleCreateCompetencia = async () => {
    if (!newCompetencia.nombre.trim() || !newCompetencia.descripcion.trim() || !newCompetencia.tipoCompetencia) {
      alert('Por favor, completa todos los campos obligatorios');
      return;
    }

    // Validaciones específicas por tipo
    if (newCompetencia.tipoCompetencia === 'funcional' && !newCompetencia.cargoEspecifico) {
      alert('Las competencias funcionales requieren especificar una posición');
      return;
    }

    // NUEVA VALIDACIÓN: Verificar que hay una empresa seleccionada para competencias funcionales
    if (newCompetencia.tipoCompetencia === 'funcional' && !selectedEmpresa?.id) {
      alert('Debe seleccionar una empresa antes de crear competencias funcionales');
      return;
    }

    try {
      // DETECTAR SI ESTAMOS EDITANDO O CREANDO
      if (selectedCompetenciaForForm?.id) {
        console.log('🔄 MODO EDICIÓN - Actualizando competencia:', selectedCompetenciaForForm.id);
        
        // MODO EDICIÓN - Actualizar competencia existente
        const competenciaActualizada = {
          nombre: newCompetencia.nombre.trim(),
          descripcion: newCompetencia.descripcion.trim(),
          tipoCompetencia: newCompetencia.tipoCompetencia,
          tipo: newCompetencia.tipoCompetencia === 'comportamental' ? 'Comportamental' :
                newCompetencia.tipoCompetencia === 'funcional' ? 'Funcional' : 'Liderazgo',
          fechaModificacion: new Date(),
          modificadoPor: userData?.uid || 'sistema'
        };

        // Campos específicos según el tipo
        if (newCompetencia.tipoCompetencia === 'comportamental') {
          competenciaActualizada.esComportamental = true;
          competenciaActualizada.categoria = 'Comportamental';
        } else if (newCompetencia.tipoCompetencia === 'funcional') {
          competenciaActualizada.cargo = newCompetencia.cargoEspecifico.trim();
          competenciaActualizada.cargoEspecifico = newCompetencia.cargoEspecifico.trim();
          competenciaActualizada.empresa_id = selectedEmpresa?.id || 'bemovil';
        } else if (newCompetencia.tipoCompetencia === 'liderazgo') {
          competenciaActualizada.requiereLiderazgo = true;
          competenciaActualizada.cargo = 'Posiciones de Liderazgo';
        }

        await updateDoc(doc(db, "competencias", selectedCompetenciaForForm.id), competenciaActualizada);
        console.log('✅ Competencia actualizada exitosamente');
        alert('✅ Competencia actualizada exitosamente');
        
      } else {
        console.log('🆕 MODO CREACIÓN - Creando nueva competencia');
        
        // MODO CREACIÓN - Crear nueva competencia
        const competenciaData = {
          ...newCompetencia,
          fechaCreacion: new Date(),
          creadoPor: userData.uid,
          // CORREGIDO: Para competencias funcionales usar empresa seleccionada, para otras usar empresa del usuario
          empresa_id: newCompetencia.tipoCompetencia === 'funcional' 
            ? (selectedEmpresa?.id || userData.empresa_id || 'default_empresa')
            : (userData.empresa_id || 'default_empresa'),
          
          // Campos específicos por tipo
          esComportamental: newCompetencia.tipoCompetencia === 'comportamental',
          esFuncional: newCompetencia.tipoCompetencia === 'funcional',
          esLiderazgo: newCompetencia.tipoCompetencia === 'liderazgo',
          
          // Configuración de visibilidad
          aplicaATodos: newCompetencia.tipoCompetencia === 'comportamental',
          aplicaSoloASupervizadosConCargo: newCompetencia.tipoCompetencia === 'liderazgo',
          posicionEspecifica: newCompetencia.tipoCompetencia === 'funcional' ? newCompetencia.cargoEspecifico : null
        };

        await addDoc(collection(db, "competencias"), competenciaData);
        console.log('✅ Competencia creada exitosamente');
      }
      
      // Recargar competencias
      await loadCompetencias();
      
      // Resetear formulario y cerrar modal
      setNewCompetencia({
        nombre: '',
        descripcion: '',
        categoria: '',
        tipoCompetencia: '',
        cargoEspecifico: '',
        requiereLiderazgo: false,
        esComportamental: false
      });
      setSelectedCompetenciaForForm(null); // IMPORTANTE: Limpiar el estado de edición
      setShowNewCompetenciaModal(false);
      
      console.log('✅ Operación completada exitosamente');
    } catch (error) {
      console.error("Error al gestionar competencia:", error);
      alert('Error al gestionar la competencia. Inténtalo de nuevo.');
    }
  };

  const handleCreatePlantilla = async () => {
    if (!newPlantilla.nombre.trim() || !newPlantilla.descripcion.trim()) {
      alert('Por favor, completa todos los campos obligatorios');
      return;
    }

    if (newPlantilla.competenciasSeleccionadas.length === 0) {
      alert('Debes seleccionar al menos una competencia');
      return;
    }

    try {
      const plantillaData = {
        ...newPlantilla,
        fechaCreacion: new Date(),
        creadoPor: userData.uid,
        empresa_id: userData.empresa_id || 'default_empresa'
      };

      await addDoc(collection(db, "plantillas_evaluacion"), plantillaData);
      
      // Recargar plantillas
      await loadPlantillas();
      
      // Resetear formulario y cerrar modal
      setNewPlantilla({
        nombre: '',
        descripcion: '',
        competenciasSeleccionadas: [],
        escalaLikert: '',
        activa: false
      });
      setShowNewPlantillaModal(false);
      
      console.log('✅ Plantilla creada exitosamente');
    } catch (error) {
      console.error("Error al crear plantilla:", error);
      alert('Error al crear la plantilla. Inténtalo de nuevo.');
    }
  };

  const handleViewPlantilla = (plantilla) => {
    setSelectedPlantilla(plantilla);
    setShowViewPlantillaModal(true);
  };

  const handleEditPlantilla = (plantilla) => {
    // Cargar los datos de la plantilla existente en newPlantilla para usar la vista completa
    setNewPlantilla({
      nombre: plantilla.nombre || '',
      descripcion: plantilla.descripcion || '',
      competenciasSeleccionadas: plantilla.competenciasSeleccionadas || [],
      escalaLikert: plantilla.escalaLikert || '',
      activa: plantilla.activa || false,
      porcentajeEvaluacion: plantilla.porcentajeEvaluacion || 70,
      porcentajeAutoevaluacion: plantilla.porcentajeAutoevaluacion || 30,
      competenciasDetalle: plantilla.competenciasDetalle || {}
    });
    
    // Marcar que estamos editando una plantilla existente
    setSelectedPlantilla(plantilla);
    
    // Abrir la vista completa de creación/edición
    setShowCreatePlantillaModal(true);
  };

  const handleUpdatePlantilla = async () => {
    if (!editPlantilla.nombre.trim() || !editPlantilla.descripcion.trim()) {
      alert('Por favor, completa todos los campos obligatorios');
      return;
    }

    if (editPlantilla.competenciasSeleccionadas.length === 0) {
      alert('Debes seleccionar al menos una competencia');
      return;
    }

    try {
      const plantillaRef = doc(db, "plantillas_evaluacion", selectedPlantilla.id);
      await updateDoc(plantillaRef, {
        ...editPlantilla,
        fechaModificacion: new Date(),
        modificadoPor: userData.uid
      });
      
      // Recargar plantillas
      await loadPlantillas();
      
      // Cerrar modal
      setShowEditPlantillaModal(false);
      setSelectedPlantilla(null);
      
      console.log('✅ Plantilla actualizada exitosamente');
    } catch (error) {
      console.error("Error al actualizar plantilla:", error);
      alert('Error al actualizar la plantilla. Inténtalo de nuevo.');
    }
  };

  const handleDeletePlantilla = async (plantilla) => {
    if (window.confirm(`¿Estás seguro de eliminar la plantilla "${plantilla.nombre}"?`)) {
      try {
        const plantillaRef = doc(db, "plantillas_evaluacion", plantilla.id);
        await deleteDoc(plantillaRef);
        
        // Recargar plantillas
        await loadPlantillas();
        
        console.log('✅ Plantilla eliminada exitosamente');
      } catch (error) {
        console.error("Error al eliminar plantilla:", error);
        alert('Error al eliminar la plantilla. Inténtalo de nuevo.');
      }
    }
  };

  const handleDuplicatePlantilla = async (plantilla) => {
    try {
      // Crear una copia de la plantilla con un nuevo nombre
      const plantillaDuplicada = {
        nombre: `${plantilla.nombre} - Copia`,
        descripcion: plantilla.descripcion || '',
        competenciasSeleccionadas: plantilla.competenciasSeleccionadas || [],
        escalaLikert: plantilla.escalaLikert || '',
        activa: false, // Las copias se crean como inactivas por defecto
        porcentajeEvaluacion: plantilla.porcentajeEvaluacion || 70,
        porcentajeAutoevaluacion: plantilla.porcentajeAutoevaluacion || 30,
        competenciasDetalle: plantilla.competenciasDetalle || {},
        fechaCreacion: new Date(),
        fechaModificacion: new Date(),
        creadoPor: userData?.uid || 'sistema',
        empresa_id: userData?.empresa_id || 'default_empresa',
        version: '2.0',
        duplicadaDe: plantilla.id // Referencia a la plantilla original
      };

      const docRef = await addDoc(collection(db, "plantillas_evaluacion"), plantillaDuplicada);
      
      // Recargar plantillas para mostrar la nueva
      await loadPlantillas();
      
      alert(`Plantilla duplicada exitosamente como "${plantillaDuplicada.nombre}"`);
      console.log('✅ Plantilla duplicada con ID:', docRef.id);
      
    } catch (error) {
      console.error("Error al duplicar plantilla:", error);
      alert('Error al duplicar la plantilla. Inténtalo de nuevo.');
    }
  };

  // Funciones para gestión de empresas y asignación de evaluaciones
  const handleSelectEmpresa = async (empresa) => {
    setSelectedEmpresa(empresa);
    // Cargar áreas de la empresa seleccionada
    try {
      const querySnapshot = await getDocs(
        query(collection(db, "areas"), where("empresa_id", "==", empresa.id))
      );
      const areasData = querySnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      setAreas(areasData);
    } catch (error) {
      console.error("Error al cargar áreas:", error);
    }
  };

  // Función para crear evaluaciones asignadas con lógica de negocio CORREGIDA v2
  const crearEvaluacionesSimple = async (plantilla) => {
    try {
      console.log('🚀 Creando evaluaciones para plantilla:', plantilla.nombre);
      
      if (!selectedEmpresa) {
        alert('❌ Debe seleccionar una empresa primero');
        return;
      }

      // 1. Obtener todos los empleados de la empresa
      const qEmpleados = query(collection(db, "empleados"), where("empresa_id", "==", selectedEmpresa.id));
      const empleadosSnapshot = await getDocs(qEmpleados);
      const empleados = empleadosSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      
      if (empleados.length === 0) {
        alert('❌ No se encontraron empleados en la empresa seleccionada');
        return;
      }

      console.log(`📊 Total empleados: ${empleados.length}`);

      // Crear mapa para búsqueda eficiente
      const empleadosPorCedula = new Map(empleados.map(emp => [emp.cedula, emp]));

      let evaluacionesCreadas = 0;
      const fechaInicio = new Date();
      const fechaFin = new Date();
      fechaFin.setDate(fechaFin.getDate() + 30); // 30 días para completar

      for (const empleado of empleados) {
        const cargoEmpleado = empleado.cargo || '';

        console.log(`� Creando evaluaciones para empleado: ${empleado.nombre || empleado.nombres} (cargo: ${cargoEmpleado})`);

        // 2. Crear autoevaluación con TODAS las competencias de la plantilla (sin filtrado)
        const autoevaluacion = {
          empleadoId: empleado.id,
          empleadoNombre: empleado.nombres || empleado.nombre || 'Sin nombre',
          empleadoCedula: empleado.cedula || 'sin-cedula',
          empleadoEmail: empleado.email || 'sin-email@ejemplo.com',
          empleadoCargo: cargoEmpleado,
          plantillaId: plantilla.id,
          plantillaNombre: plantilla.nombre,
          competenciasDetalle: plantilla.competenciasDetalle || {}, // TODAS las competencias sin filtrar
          escalaLikert: plantilla.escalaLikert || 'escala_5_puntos',
          evaluacionNombre: `Autoevaluación - ${plantilla.nombre}`,
          evaluacionDescripcion: `Autoevaluación basada en ${plantilla.nombre}`,
          tipoEvaluacion: 'autoevaluacion',
          esAutoevaluacion: true,
          estado: 'pendiente',
          activa: true,
          fechaCreacion: fechaInicio,
          fechaInicio: fechaInicio,
          fechaFin: fechaFin,
          fecha_evaluacion: fechaInicio, // Nueva fecha para tracking de cuándo se realizó la evaluación
          empresa_id: selectedEmpresa.id,
          empresaNombre: selectedEmpresa.nombre,
          progreso: 0,
          respuestas: {},
          version: '3.0' // Actualizada para indicar que usa filtrado dinámico
        };
        
        await addDoc(collection(db, "evaluaciones_asignadas"), autoevaluacion);
        evaluacionesCreadas++;
        console.log(`✅ Autoevaluación creada para: ${empleado.nombres || empleado.nombre} (cargo: ${cargoEmpleado})`);
        
        // 3. Crear evaluación por supervisor si tiene supervisor
        const tieneSupervisor = !!empleado.supervisor_cedula;
        if (tieneSupervisor) {
          const supervisor = empleadosPorCedula.get(empleado.supervisor_cedula);
          
          if (supervisor) {
            const evaluacionPorSupervisor = {
              empleadoId: empleado.id,
              empleadoNombre: empleado.nombres || empleado.nombre || 'Sin nombre',
              empleadoCedula: empleado.cedula || 'sin-cedula',
              empleadoEmail: empleado.email || 'sin-email@ejemplo.com',
              empleadoCargo: cargoEmpleado,
              evaluadorId: supervisor.id,
              evaluadorNombre: supervisor.nombres || supervisor.nombre || 'Sin nombre',
              evaluadorCedula: supervisor.cedula || 'sin-cedula',
              evaluadorEmail: supervisor.email || 'sin-email@ejemplo.com',
              plantillaId: plantilla.id,
              plantillaNombre: plantilla.nombre,
              competenciasDetalle: plantilla.competenciasDetalle || {}, // TODAS las competencias sin filtrar
              escalaLikert: plantilla.escalaLikert || 'escala_5_puntos',
              evaluacionNombre: `Evaluación por Supervisor - ${plantilla.nombre}`,
              evaluacionDescripcion: `Evaluación de ${empleado.nombres || empleado.nombre} por supervisor`,
              tipoEvaluacion: 'evaluacion_supervisor',
              esAutoevaluacion: false,
              estado: 'pendiente',
              activa: true,
              fechaCreacion: fechaInicio,
              fechaInicio: fechaInicio,
              fechaFin: fechaFin,
              fecha_evaluacion: fechaInicio, // Nueva fecha para tracking de cuándo se realizó la evaluación
              empresa_id: selectedEmpresa.id,
              empresaNombre: selectedEmpresa.nombre,
              progreso: 0,
              respuestas: {},
              version: '3.0' // Actualizada para indicar que usa filtrado dinámico
            };
            
            await addDoc(collection(db, "evaluaciones_asignadas"), evaluacionPorSupervisor);
            evaluacionesCreadas++;
            console.log(`✅ Evaluación por supervisor creada: ${supervisor.nombres || supervisor.nombre} evalúa a ${empleado.nombres || empleado.nombre}`);
          }
        }
      }
      
      alert(`✅ Se crearon ${evaluacionesCreadas} evaluaciones exitosamente para la empresa ${selectedEmpresa.nombre}!\n\nNota: El filtrado de competencias ahora se realiza dinámicamente en los formularios de evaluación.`);
      
    } catch (error) {
      console.error('❌ Error al crear evaluaciones:', error);
      alert('❌ Error al crear evaluaciones: ' + error.message);
    }
  };

  // Función para actualizar evaluaciones existentes (simplificada para usar filtrado dinámico)
  const actualizarEvaluacionesExistentes = async (plantilla) => {
    try {
      console.log('🔄 Actualizando evaluaciones existentes para plantilla:', plantilla.nombre);
      
      if (!selectedEmpresa) {
        alert('❌ Debe seleccionar una empresa primero');
        return;
      }

      // 1. Obtener evaluaciones existentes de esta plantilla y empresa
      const qEvaluacionesExistentes = query(
        collection(db, "evaluaciones_asignadas"),
        where("plantillaId", "==", plantilla.id),
        where("empresa_id", "==", selectedEmpresa.id),
        where("activa", "==", true)
      );
      
      const [evaluacionesSnapshot, empleadosSnapshot] = await Promise.all([
        getDocs(qEvaluacionesExistentes),
        getDocs(query(collection(db, "empleados"), where("empresa_id", "==", selectedEmpresa.id)))
      ]);

      const evaluacionesExistentes = evaluacionesSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      const empleados = empleadosSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      
      if (evaluacionesExistentes.length === 0) {
        alert('❌ No se encontraron evaluaciones existentes para actualizar');
        return;
      }

      console.log(`📊 Evaluaciones existentes: ${evaluacionesExistentes.length}, Empleados: ${empleados.length}`);

      // Crear mapa para búsqueda eficiente
      const empleadosPorCedula = new Map(empleados.map(emp => [emp.cedula, emp]));

      let evaluacionesActualizadas = 0;

      for (const evaluacionExistente of evaluacionesExistentes) {
        console.log(`🔍 Procesando evaluación: ${evaluacionExistente.id} de ${evaluacionExistente.empleadoNombre}`);
        
        // Obtener datos del empleado
        const empleado = empleadosPorCedula.get(evaluacionExistente.empleadoCedula);
        if (!empleado) {
          console.log(`⚠️ No se encontró empleado con cédula: ${evaluacionExistente.empleadoCedula}`);
          continue;
        }

        const cargoEmpleado = empleado.cargo || '';
        console.log(`   - Empleado: ${empleado.nombre || empleado.nombres} (cargo: ${cargoEmpleado})`);

        // Actualizar la evaluación con TODAS las competencias de la plantilla (sin filtrado)
        const updateData = {
          competenciasDetalle: plantilla.competenciasDetalle || {}, // TODAS las competencias sin filtrar
          empleadoCargo: cargoEmpleado, // Asegurar que el campo cargo esté presente
          fechaActualizacion: new Date(),
          version: '3.0' // Marcar como actualizada para usar filtrado dinámico
        };

        await updateDoc(doc(db, "evaluaciones_asignadas", evaluacionExistente.id), updateData);
        evaluacionesActualizadas++;
        console.log(`   ✅ Evaluación actualizada: ${evaluacionExistente.empleadoNombre} (todas las competencias asignadas)`);
      }
      
      alert(`✅ Se actualizaron ${evaluacionesActualizadas} evaluaciones existentes para la empresa ${selectedEmpresa.nombre}!\n\nNota: Todas las competencias de la plantilla han sido asignadas. El filtrado se realizará dinámicamente en los formularios de evaluación.\n\nEvaluaciones procesadas: ${evaluacionesExistentes.length}\nEvaluaciones actualizadas: ${evaluacionesActualizadas}`);
      
    } catch (error) {
      console.error('❌ Error al actualizar evaluaciones existentes:', error);
      alert('❌ Error al actualizar evaluaciones: ' + error.message);
    }
  };

  // Función para limpiar completamente la colección evaluaciones_asignadas
  const limpiarEvaluacionesAsignadas = async () => {
    const confirmacion = window.confirm('⚠️ ¿Estás seguro de que quieres eliminar TODAS las evaluaciones asignadas?\n\nEsta acción no se puede deshacer y borrará todos los datos de evaluaciones.');
    
    if (!confirmacion) {
      return;
    }

    const segundaConfirmacion = window.confirm('🚨 CONFIRMACIÓN FINAL:\n\nSe eliminarán TODAS las evaluaciones asignadas de TODAS las empresas.\n\n¿Estás completamente seguro?');
    
    if (!segundaConfirmacion) {
      return;
    }

    try {
      console.log('🧹 Iniciando limpieza de la colección evaluaciones_asignadas...');
      
      // Obtener todos los documentos de la colección
      const querySnapshot = await getDocs(collection(db, 'evaluaciones_asignadas'));
      
      console.log(`📊 Encontrados ${querySnapshot.size} documentos para eliminar`);
      
      if (querySnapshot.size === 0) {
        alert('✅ La colección ya está vacía');
        return;
      }
      
      // Eliminar cada documento
      const deletePromises = [];
      querySnapshot.forEach((documento) => {
        console.log(`🗑️ Eliminando documento: ${documento.id}`);
        deletePromises.push(deleteDoc(doc(db, 'evaluaciones_asignadas', documento.id)));
      });
      
      // Esperar a que se eliminen todos los documentos
      await Promise.all(deletePromises);
      
      alert(`✅ Limpieza completada exitosamente!\n\nSe eliminaron ${querySnapshot.size} documentos de la colección evaluaciones_asignadas`);
      
      // Recargar la lista de evaluaciones
      loadEvaluaciones();
      
    } catch (error) {
      console.error('❌ Error durante la limpieza:', error);
      alert('❌ Error durante la limpieza: ' + error.message);
    }
  };

  // Función auxiliar para calcular total de preguntas
  const calcularTotalPreguntas = (competenciasDetalle) => {
    if (!competenciasDetalle) return 0;
    
    let total = 0;
    Object.values(competenciasDetalle).forEach(competencia => {
      if (competencia.preguntas && Array.isArray(competencia.preguntas)) {
        total += competencia.preguntas.length;
      }
    });
    
    return total;
  };

  if (loading) {
    return (
      <DashboardBase 
        title="Cargando..." 
        activeNav="evaluaciones"
        userRole={userData ? getRolDisplay(userData.rol) : "Usuario"}
        userName={userData ? `${userData.nombre} ${userData.apellido}` : "Usuario"}
      >
        <div style={{ textAlign: 'center', padding: '2rem' }}>
          <div style={{
            width: '40px',
            height: '40px',
            border: '4px solid #e2e8f0',
            borderTop: '4px solid #1e40af',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite',
            margin: '0 auto 1rem'
          }}></div>
          <p>Cargando evaluaciones...</p>
        </div>
      </DashboardBase>
    );
  }

  if (!['admin', 'rrhh', 'superadmin'].includes(userData?.rol)) {
    return (
      <DashboardBase 
        title="Acceso Restringido"
        activeNav="evaluaciones"
        userRole={userData ? getRolDisplay(userData.rol) : "Usuario"}
        userName={userData ? `${userData.nombre} ${userData.apellido}` : "Usuario"}
      >
        <div style={{ textAlign: 'center', padding: '3rem' }}>
          <div style={{ fontSize: '4rem', marginBottom: '1rem' }}>🔒</div>
          <h2>Acceso Restringido</h2>
          <p>Solo administradores y personal de RRHH pueden acceder a este módulo.</p>
        </div>
      </DashboardBase>
    );
  }

  if (loading) {
    return (
      <DashboardBase 
        title="Cargando..." 
        activeNav="evaluaciones"
        userRole={userData ? getRolDisplay(userData.rol) : "Usuario"}
        userName={userData ? `${userData.nombre} ${userData.apellido}` : "Usuario"}
      >
        <div style={{ textAlign: 'center', padding: '2rem' }}>
          <div style={{
            width: '40px',
            height: '40px',
            border: '4px solid #e2e8f0',
            borderTop: '4px solid #1e40af',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite',
            margin: '0 auto 1rem'
          }}></div>
          <p>Cargando evaluaciones...</p>
        </div>
      </DashboardBase>
    );
  }

  return (
    <DashboardBase 
      title="Gestión de Evaluaciones" 
      activeNav="evaluaciones"
      userRole={userData ? getRolDisplay(userData.rol) : "Usuario"}
      userName={userData ? `${userData.nombre} ${userData.apellido}` : "Usuario"}
    >
      <div style={{ padding: '1.5rem' }}>
        {/* Header */}
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: '2rem'
        }}>
          <div>
            <h1 style={{ 
              fontSize: '2rem', 
              fontWeight: 'bold', 
              color: '#1e293b',
              marginBottom: '0.5rem'
            }}>
              Sistema de Evaluaciones 180°
            </h1>
            <p style={{ color: '#64748b', fontSize: '1.1rem' }}>
              Gestiona plantillas, competencias y configuraciones de evaluación
            </p>
          </div>
        </div>

        {/* Tabs */}
        <div style={{
          display: 'flex',
          borderBottom: '2px solid #e5e7eb',
          marginBottom: '2rem'
        }}>
          {[
            { id: 'plantillas', label: '📋 Plantillas', count: plantillas.length },
            { id: 'competencias', label: '🎯 Competencias', count: competencias.length },
            { id: 'escalas', label: '📊 Escalas Likert', count: escalasLikert.length },
            { id: 'empresas', label: '🏢 Empresas', count: empresas.length },
            { id: 'activacion_evaluaciones', label: '🚀 Activar Evaluaciones', count: 0 },
            { id: 'debug', label: '🔧 Debug', count: 0 }
          ].map(tab => (
            <button
              key={tab.id}
              onClick={() => {
                console.log("📋 Cambiando a tab:", tab.id);
                setActiveTab(tab.id);
              }}
              style={{
                padding: '1rem 1.5rem',
                border: 'none',
                borderBottom: activeTab === tab.id ? '3px solid #1e40af' : '3px solid transparent',
                backgroundColor: activeTab === tab.id ? '#eff6ff' : 'transparent',
                color: activeTab === tab.id ? '#1e40af' : '#6b7280',
                fontWeight: activeTab === tab.id ? '600' : '500',
                cursor: 'pointer',
                transition: 'all 0.2s ease',
                fontSize: '0.95rem'
              }}
            >
              {tab.label}
              {tab.count > 0 && (
                <span style={{
                  marginLeft: '0.5rem',
                  backgroundColor: activeTab === tab.id ? '#1e40af' : '#9ca3af',
                  color: 'white',
                  borderRadius: '12px',
                  padding: '0.125rem 0.5rem',
                  fontSize: '0.75rem',
                  fontWeight: '500'
                }}>
                  {tab.count}
                </span>
              )}
            </button>
          ))}
        </div>

        {/* Contenido de las pestañas */}
        {activeTab === 'plantillas' && (
          <div>
            <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginBottom: '2rem'
            }}>
              <h3 style={{ margin: 0, color: '#1e293b' }}>Plantillas de Evaluación</h3>
              <div style={{ display: 'flex', gap: '1rem' }}>
                <button
                  onClick={() => {
                    console.log('🆕 Abriendo formulario nueva plantilla...');
                    console.log('📊 Competencias disponibles:', competencias.length);
                    
                    // Limpiar cualquier estado de edición anterior
                    setSelectedPlantilla(null);
                    setCompetenciaEnEdicion(null);
                    
                    // Resetear formulario para nueva plantilla
                    setNewPlantilla({
                      nombre: '',
                      descripcion: '',
                      competenciasSeleccionadas: [],
                      competenciasDetalle: {},
                      escalaLikert: '',
                      activa: false,
                      porcentajeEvaluacion: 70,
                      porcentajeAutoevaluacion: 30
                    });
                    
                    setShowCreatePlantillaModal(true);
                  }}
                  style={{
                    backgroundColor: '#10b981',
                    color: 'white',
                    border: 'none',
                    padding: '0.75rem 1.5rem',
                    borderRadius: '8px',
                    cursor: 'pointer',
                    fontSize: '14px',
                    fontWeight: '500'
                  }}
                >
                  ➕ Nueva Plantilla
                </button>
              </div>
            </div>

            {(() => {
              console.log('🔍 Estado actual plantillas en render:', plantillas);
              console.log('🔍 Longitud del array plantillas:', plantillas.length);
              return null;
            })()}

            {!showCreatePlantillaModal && plantillas.length === 0 ? (
              <div style={{
                textAlign: 'center',
                padding: '3rem',
                backgroundColor: 'white',
                borderRadius: '8px',
                border: '1px solid #e5e7eb'
              }}>
                <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>📋</div>
                <h3 style={{ margin: '0 0 0.5rem 0', color: '#374151' }}>
                  No hay plantillas de evaluación
                </h3>
                <p style={{ margin: 0, color: '#6b7280' }}>
                  Crea tu primera plantilla para comenzar a gestionar evaluaciones
                </p>
              </div>
            ) : (
              !showCreatePlantillaModal && (
              <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
                gap: '1.5rem'
              }}>
                {(() => {
                  console.log('📄 Mapeando plantillas:', plantillas);
                  return plantillas.map((plantilla) => {
                    console.log('📄 Renderizando plantilla:', plantilla);
                    return (
                      <div
                        key={plantilla.id}
                        style={{
                          backgroundColor: 'white',
                          border: '1px solid #e5e7eb',
                          borderRadius: '8px',
                          padding: '1.5rem',
                          cursor: 'pointer',
                          transition: 'all 0.2s ease'
                        }}
                      >
                    <h5 style={{ 
                      margin: '0 0 0.5rem 0', 
                      color: '#1e293b',
                      fontSize: '1.1rem',
                      fontWeight: '600'
                    }}>
                      {plantilla.nombre}
                    </h5>
                    <p style={{ 
                      margin: '0 0 1rem 0', 
                      color: '#6b7280',
                      fontSize: '0.875rem'
                    }}>
                      {plantilla.descripcion}
                    </p>
                    <div style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      fontSize: '0.75rem',
                      color: '#6b7280'
                    }}>
                      <span>Creada: {new Date(plantilla.fechaCreacion?.seconds * 1000).toLocaleDateString()}</span>
                      <span style={{
                        backgroundColor: plantilla.activa ? '#dcfce7' : '#fee2e2',
                        color: plantilla.activa ? '#166534' : '#dc2626',
                        padding: '0.25rem 0.5rem',
                        borderRadius: '4px'
                      }}>
                        {plantilla.activa ? 'Activa' : 'Inactiva'}
                      </span>
                    </div>
                    <div style={{
                      display: 'flex',
                      gap: '0.5rem',
                      marginTop: '1rem'
                    }}>
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          handleViewPlantilla(plantilla);
                        }}
                        style={{
                          backgroundColor: '#3b82f6',
                          color: 'white',
                          border: 'none',
                          padding: '0.5rem 0.75rem',
                          borderRadius: '6px',
                          cursor: 'pointer',
                          fontSize: '12px',
                          flex: 1
                        }}
                      >
                        👁️ Ver
                      </button>
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          handleEditPlantilla(plantilla);
                        }}
                        style={{
                          backgroundColor: '#f59e0b',
                          color: 'white',
                          border: 'none',
                          padding: '0.5rem 0.75rem',
                          borderRadius: '6px',
                          cursor: 'pointer',
                          fontSize: '12px',
                          flex: 1
                        }}
                      >
                        ✏️ Editar
                      </button>
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          handleDuplicatePlantilla(plantilla);
                        }}
                        style={{
                          backgroundColor: '#8b5cf6',
                          color: 'white',
                          border: 'none',
                          padding: '0.5rem 0.75rem',
                          borderRadius: '6px',
                          cursor: 'pointer',
                          fontSize: '12px',
                          flex: 1
                        }}
                      >
                        📋 Duplicar
                      </button>
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          handleDeletePlantilla(plantilla);
                        }}
                        style={{
                          backgroundColor: '#ef4444',
                          color: 'white',
                          border: 'none',
                          padding: '0.5rem 0.75rem',
                          borderRadius: '6px',
                          cursor: 'pointer',
                          fontSize: '12px',
                          flex: 1
                        }}
                      >
                        🗑️ Eliminar
                      </button>
                    </div>
                  </div>
                    );
                  });
                })()}
              </div>
              )
            )}
          </div>
        )}

        {/* Sección Competencias por Clasificación - Solo cuando se está creando plantilla */}
        {activeTab === 'plantillas' && showCreatePlantillaModal && (
          <div className="competencias-clasificacion" style={{
            backgroundColor: 'white',
            borderRadius: '12px',
            padding: '2rem',
            marginBottom: '2rem',
            border: '1px solid #e5e7eb',
            boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)'
          }}>
            {/* Formulario de Información Básica */}
            <div style={{
              backgroundColor: '#f8fafc',
              padding: '2rem',
              borderRadius: '8px',
              marginBottom: '2rem',
              border: '1px solid #e2e8f0'
            }}>
              <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: '1.5rem'
              }}>
                <h3 style={{ 
                  margin: 0, 
                  color: '#1e293b',
                  fontSize: '1.5rem',
                  fontWeight: 'bold'
                }}>
                  📋 Información Básica de la Plantilla
                </h3>
                <button
                  onClick={() => {
                    setShowCreatePlantillaModal(false);
                    setNewPlantilla({
                      nombre: '',
                      descripcion: '',
                      competenciasSeleccionadas: [],
                      competenciasDetalle: {},
                      escalaLikert: '',
                      activa: false,
                      porcentajeEvaluacion: 70,
                      porcentajeAutoevaluacion: 30
                    });
                    setSelectedPlantilla(null); // Limpiar plantilla seleccionada
                    setCompetenciaEnEdicion(null); // Cerrar formularios de competencia
                  }}
                  style={{
                    backgroundColor: '#6b7280',
                    color: 'white',
                    border: 'none',
                    padding: '0.5rem 1rem',
                    borderRadius: '6px',
                    cursor: 'pointer',
                    fontSize: '14px',
                    fontWeight: '500'
                  }}
                >
                  ← Volver a Plantillas
                </button>
              </div>

              <div style={{
                display: 'grid',
                gridTemplateColumns: '1fr 1fr',
                gap: '1.5rem',
                marginBottom: '1rem'
              }}>
                <div>
                  <label style={{
                    display: 'block',
                    marginBottom: '0.5rem',
                    fontWeight: '500',
                    color: '#374151'
                  }}>
                    Nombre de la Plantilla *
                  </label>
                  <input
                    type="text"
                    value={newPlantilla.nombre}
                    onChange={(e) => setNewPlantilla({
                      ...newPlantilla,
                      nombre: e.target.value
                    })}
                    placeholder="Ej: Evaluación Anual 2025, Evaluación Trimestral..."
                    style={{
                      width: '100%',
                      padding: '0.75rem',
                      border: '1px solid #d1d5db',
                      borderRadius: '6px',
                      fontSize: '14px'
                    }}
                  />
                </div>

                <div>
                  <label style={{
                    display: 'block',
                    marginBottom: '0.5rem',
                    fontWeight: '500',
                    color: '#374151'
                  }}>
                    Escala de Calificación *
                  </label>
                  <select
                    value={newPlantilla.escalaLikert}
                    onChange={(e) => setNewPlantilla({
                      ...newPlantilla,
                      escalaLikert: e.target.value
                    })}
                    style={{
                      width: '100%',
                      padding: '0.75rem',
                      border: '1px solid #d1d5db',
                      borderRadius: '6px',
                      fontSize: '14px'
                    }}
                  >
                    <option value="">Seleccionar escala de calificación</option>
                    {escalasLikert.map(escala => (
                      <option key={escala.id} value={escala.id}>
                        {escala.nombre} ({escala.niveles} niveles)
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div style={{ marginBottom: '1rem' }}>
                <label style={{
                  display: 'block',
                  marginBottom: '0.5rem',
                  fontWeight: '500',
                  color: '#374151'
                }}>
                  Descripción *
                </label>
                <textarea
                  value={newPlantilla.descripcion}
                  onChange={(e) => setNewPlantilla({
                    ...newPlantilla,
                    descripcion: e.target.value
                  })}
                  placeholder="Describe el propósito y alcance de esta plantilla..."
                  rows={3}
                  style={{
                    width: '100%',
                    padding: '0.75rem',
                    border: '1px solid #d1d5db',
                    borderRadius: '6px',
                    fontSize: '14px',
                    resize: 'vertical'
                  }}
                />
              </div>

              <div>
                <label style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '0.5rem',
                  cursor: 'pointer'
                }}>
                  <input
                    type="checkbox"
                    checked={newPlantilla.activa}
                    onChange={(e) => setNewPlantilla({
                      ...newPlantilla,
                      activa: e.target.checked
                    })}
                  />
                  <span style={{ fontWeight: '500', color: '#374151' }}>
                    Activar plantilla inmediatamente
                  </span>
                </label>
                <div style={{
                  marginTop: '0.5rem',
                  fontSize: '0.75rem',
                  color: '#6b7280'
                }}>
                  Si está marcado, la plantilla estará disponible para crear evaluaciones inmediatamente.
                </div>
              </div>
            </div>

            <h3 style={{ 
              marginBottom: '1.5rem', 
              color: '#1e293b',
              fontSize: '1.5rem',
              fontWeight: 'bold'
            }}>
              💼 Competencias Disponibles por Clasificación
            </h3>
            
            {(() => {
              console.log('🔍 Renderizando competencias en formulario creación...');
              console.log('🔍 Total competencias:', competencias.length);
              console.log('🔍 Competencias seleccionadas:', newPlantilla.competenciasSeleccionadas.length);
              return null;
            })()}
            
            {/* Competencias Comportamentales */}
            <div className="clasificacion-group" style={{ marginBottom: '2rem' }}>
              <div style={{ 
                display: 'flex', 
                justifyContent: 'space-between', 
                alignItems: 'center',
                marginBottom: '0.5rem'
              }}>
                <h4 style={{ 
                  color: '#3b82f6',
                  margin: 0,
                  fontSize: '1.25rem',
                  fontWeight: '600'
                }}>
                  🧠 Competencias Comportamentales
                </h4>
                <button
                  onClick={() => openNewCompetenciaForm('comportamental')}
                  style={{
                    backgroundColor: '#3b82f6',
                    color: 'white',
                    border: 'none',
                    padding: '0.5rem 1rem',
                    borderRadius: '6px',
                    cursor: 'pointer',
                    fontSize: '0.875rem',
                    fontWeight: '500',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.5rem'
                  }}
                >
                  ➕ Nueva Competencia
                </button>
              </div>
              <p style={{ 
                color: '#6b7280',
                marginBottom: '1rem',
                fontSize: '0.875rem'
              }}>
                Aplican a todos los empleados
              </p>

              {/* Formulario inline para nueva competencia comportamental */}
              {showNewCompetenciaComportamental && (
                <div 
                  data-form-comportamental="true"
                  style={{
                    backgroundColor: '#f8fafc',
                    border: '2px solid #3b82f6',
                    borderRadius: '8px',
                    padding: '1.5rem',
                    marginBottom: '1rem'
                  }}
                onClick={(e) => e.stopPropagation()}
                >
                  <h5 style={{ 
                    margin: '0 0 1rem 0',
                    fontSize: '1rem',
                    fontWeight: '600',
                    color: '#1e293b'
                  }}>
                    {selectedCompetenciaForForm ? '✏️ Editar Competencia Comportamental' : '➕ Nueva Competencia Comportamental'}
                  </h5>
                  
                  <div style={{ marginBottom: '1rem' }}>
                    <label style={{ 
                      display: 'block',
                      marginBottom: '0.5rem',
                      fontWeight: '500',
                      color: '#374151',
                      fontSize: '0.875rem'
                    }}>
                      Nombre de la Competencia:
                    </label>
                    <input
                      type="text"
                      value={newCompetenciaInline.nombre}
                      onChange={(e) => setNewCompetenciaInline({
                        ...newCompetenciaInline,
                        nombre: e.target.value
                      })}
                      placeholder="Ej: Trabajo en equipo, Comunicación efectiva..."
                      style={{
                        width: '100%',
                        padding: '0.75rem',
                        border: '1px solid #d1d5db',
                        borderRadius: '6px',
                        fontSize: '14px',
                        fontFamily: 'inherit'
                      }}
                    />
                  </div>

                  <div style={{ marginBottom: '1rem' }}>
                    <label style={{ 
                      display: 'block',
                      marginBottom: '0.5rem',
                      fontWeight: '500',
                      color: '#374151',
                      fontSize: '0.875rem'
                    }}>
                      Descripción:
                    </label>
                    <textarea
                      value={newCompetenciaInline.descripcion}
                      onChange={(e) => setNewCompetenciaInline({
                        ...newCompetenciaInline,
                        descripcion: e.target.value
                      })}
                      placeholder="Describe en qué consiste esta competencia comportamental..."
                      style={{
                        width: '100%',
                        minHeight: '80px',
                        padding: '0.75rem',
                        border: '1px solid #d1d5db',
                        borderRadius: '6px',
                        fontSize: '14px',
                        fontFamily: 'inherit',
                        resize: 'vertical'
                      }}
                    />
                  </div>

                  <div style={{ display: 'flex', gap: '1rem' }}>
                    <button
                      onClick={handleCreateCompetenciaInline}
                      disabled={!newCompetenciaInline.nombre.trim() || !newCompetenciaInline.descripcion.trim()}
                      style={{
                        backgroundColor: newCompetenciaInline.nombre.trim() && newCompetenciaInline.descripcion.trim() ? '#10b981' : '#9ca3af',
                        color: 'white',
                        border: 'none',
                        padding: '0.75rem 1.5rem',
                        borderRadius: '6px',
                        cursor: newCompetenciaInline.nombre.trim() && newCompetenciaInline.descripcion.trim() ? 'pointer' : 'not-allowed',
                        fontSize: '14px',
                        fontWeight: '500',
                        flex: 1
                      }}
                    >
                      {selectedCompetenciaForForm?.id ? '🔄 Actualizar Competencia' : '✅ Crear Competencia'}
                    </button>
                    <button
                      onClick={closeNewCompetenciaForms}
                      style={{
                        backgroundColor: '#f3f4f6',
                        color: '#374151',
                        border: 'none',
                        padding: '0.75rem 1.5rem',
                        borderRadius: '6px',
                        cursor: 'pointer',
                        fontSize: '14px',
                        fontWeight: '500'
                      }}
                    >
                      ❌ Cancelar
                    </button>
                  </div>
                </div>
              )}

              <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
                gap: '1rem',
                marginBottom: '1rem'
              }}>
                {competencias
                  .filter(comp => comp.tipoCompetencia === 'comportamental' || comp.esComportamental === true || comp.tipo === 'Comportamental')
                  .map(competencia => (
                    <div 
                      key={competencia.id} 
                      style={{
                        border: newPlantilla.competenciasSeleccionadas.includes(competencia.id) 
                          ? '2px solid #3b82f6' : '1px solid #e5e7eb',
                        borderRadius: '8px',
                        padding: '1rem',
                        cursor: 'pointer',
                        backgroundColor: newPlantilla.competenciasSeleccionadas.includes(competencia.id) 
                          ? '#eff6ff' : 'white',
                        transition: 'all 0.2s'
                      }}
                      onClick={() => handleCompetenciaSelection(competencia.id, true)}
                    >
                      <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        marginBottom: '0.5rem'
                      }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                          <span style={{ fontSize: '1.5rem' }}>🧠</span>
                          <span style={{ fontWeight: '600', color: '#1e293b' }}>
                            {competencia.nombre}
                          </span>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                          {newPlantilla.competenciasSeleccionadas.includes(competencia.id) && (
                            <span style={{
                              backgroundColor: '#3b82f6',
                              color: 'white',
                              padding: '0.25rem 0.5rem',
                              borderRadius: '12px',
                              fontSize: '0.75rem',
                              fontWeight: '500'
                            }}>
                              {newPlantilla.competenciasDetalle[competencia.id]?.porcentaje || 0}%
                            </span>
                          )}
                          <button
                            onClick={(e) => handleEditCompetencia(competencia, e)}
                            style={{
                              backgroundColor: '#f59e0b',
                              color: 'white',
                              border: 'none',
                              padding: '0.25rem 0.5rem',
                              borderRadius: '4px',
                              cursor: 'pointer',
                              fontSize: '0.75rem',
                              fontWeight: '500'
                            }}
                            title="Editar competencia"
                          >
                            ✏️
                          </button>
                          <button
                            onClick={(e) => handleDeleteCompetencia(competencia, e)}
                            style={{
                              backgroundColor: '#ef4444',
                              color: 'white',
                              border: 'none',
                              padding: '0.25rem 0.5rem',
                              borderRadius: '4px',
                              cursor: 'pointer',
                              fontSize: '0.75rem',
                              fontWeight: '500'
                            }}
                            title="Eliminar competencia"
                          >
                            🗑️
                          </button>
                        </div>
                      </div>
                      <p style={{ 
                        color: '#6b7280',
                        fontSize: '0.875rem',
                        marginBottom: '1rem'
                      }}>
                        {competencia.descripcion}
                      </p>
                      {newPlantilla.competenciasSeleccionadas.includes(competencia.id) && (
                        <button 
                          style={{
                            backgroundColor: '#10b981',
                            color: 'white',
                            border: 'none',
                            padding: '0.5rem 1rem',
                            borderRadius: '6px',
                            cursor: 'pointer',
                            fontSize: '0.875rem',
                            fontWeight: '500',
                            width: '100%'
                          }}
                          onClick={(e) => {
                            e.stopPropagation();
                            console.log('🎯 Botón Crear Afirmaciones presionado para:', competencia.nombre);
                            console.log('🎯 ID competencia:', competencia.id);
                            openCompetenciaForm(competencia);
                          }}
                        >
                          ➕ Crear Afirmaciones ({newPlantilla.competenciasDetalle[competencia.id]?.preguntas?.length || 0})
                        </button>
                      )}
                      
                      {/* Formulario inline para crear afirmaciones - COMPORTAMENTALES */}
                      {newPlantilla.competenciasSeleccionadas.includes(competencia.id) && competenciaEnEdicion === competencia.id && (
                        <div 
                          onClick={(e) => e.stopPropagation()}
                          style={{
                            backgroundColor: '#f8fafc',
                            border: '2px solid #3b82f6',
                            borderRadius: '8px',
                            padding: '1.5rem',
                            marginTop: '1rem'
                          }}>
                          <h5 style={{ 
                            margin: '0 0 1rem 0',
                            fontSize: '1rem',
                            fontWeight: '600',
                            color: '#1e293b'
                          }}>
                            ✍️ Nueva Afirmación para: {competencia.nombre}
                          </h5>
                          
                          <div style={{ marginBottom: '1rem' }}>
                            <label style={{ 
                              display: 'block',
                              marginBottom: '0.5rem',
                              fontWeight: '500',
                              color: '#374151',
                              fontSize: '0.875rem'
                            }}>
                              👤 Afirmación en Primera Persona (Autoevaluación):
                            </label>
                            <textarea
                              value={currentPregunta.primera_persona}
                              onChange={(e) => handlePrimeraPersonaChange(e.target.value)}
                              placeholder="Ejemplo: Yo manejo situaciones difíciles con calma y profesionalismo..."
                              style={{
                                width: '100%',
                                minHeight: '60px',
                                padding: '0.75rem',
                                border: '1px solid #d1d5db',
                                borderRadius: '6px',
                                fontSize: '14px',
                                fontFamily: 'inherit',
                                resize: 'vertical'
                              }}
                            />
                          </div>

                          <div style={{ marginBottom: '1rem' }}>
                            <label style={{ 
                              display: 'block',
                              marginBottom: '0.5rem',
                              fontWeight: '500',
                              color: '#374151',
                              fontSize: '0.875rem'
                            }}>
                              👨‍💼 Afirmación en Tercera Persona:
                              <span style={{ 
                                color: '#10b981',
                                fontSize: '0.75rem',
                                marginLeft: '0.5rem'
                              }}>
                                (Generada automáticamente)
                              </span>
                            </label>
                            <textarea
                              value={currentPregunta.tercera_persona}
                              onChange={(e) => setCurrentPregunta({
                                ...currentPregunta,
                                tercera_persona: e.target.value,
                                editada: true
                              })}
                              placeholder="Se genera automáticamente..."
                              style={{
                                width: '100%',
                                minHeight: '60px',
                                padding: '0.75rem',
                                border: '1px solid #d1d5db',
                                borderRadius: '6px',
                                fontSize: '14px',
                                fontFamily: 'inherit',
                                resize: 'vertical',
                                backgroundColor: currentPregunta.editada ? 'white' : '#f9fafb'
                              }}
                            />
                          </div>

                          <button
                            onClick={addPreguntaToCompetencia}
                            disabled={!currentPregunta.primera_persona.trim()}
                            style={{
                              backgroundColor: currentPregunta.primera_persona.trim() ? '#10b981' : '#9ca3af',
                              color: 'white',
                              border: 'none',
                              padding: '0.75rem 1.5rem',
                              borderRadius: '6px',
                              cursor: currentPregunta.primera_persona.trim() ? 'pointer' : 'not-allowed',
                              fontSize: '14px',
                              fontWeight: '500',
                              width: '100%'
                            }}
                          >
                            ➕ Agregar Afirmación
                          </button>
                        </div>
                      )}
                      
                      {/* Mostrar afirmaciones existentes - COMPORTAMENTALES */}
                      {newPlantilla.competenciasSeleccionadas.includes(competencia.id) && newPlantilla.competenciasDetalle[competencia.id]?.preguntas?.length > 0 && (
                        <div style={{
                          backgroundColor: '#f8fafc',
                          border: '1px solid #e2e8f0',
                          borderRadius: '8px',
                          padding: '1rem',
                          marginTop: '1rem'
                        }}>
                          <h6 style={{ 
                            margin: '0 0 0.75rem 0',
                            fontSize: '0.875rem',
                            fontWeight: '600',
                            color: '#374151'
                          }}>
                            📝 Afirmaciones Creadas ({newPlantilla.competenciasDetalle[competencia.id]?.preguntas?.length}):
                          </h6>
                          <div style={{ maxHeight: '200px', overflowY: 'auto' }}>
                            {newPlantilla.competenciasDetalle[competencia.id]?.preguntas?.map((pregunta, index) => (
                              <div key={index} style={{
                                backgroundColor: 'white',
                                border: '1px solid #e5e7eb',
                                borderRadius: '6px',
                                padding: '0.75rem',
                                marginBottom: '0.5rem'
                              }}>
                                <div style={{ marginBottom: '0.5rem' }}>
                                  <strong style={{ color: '#374151', fontSize: '0.75rem' }}>👤 Primera persona:</strong>
                                  <p style={{ margin: '0.25rem 0', fontSize: '0.875rem', color: '#1f2937' }}>
                                    {pregunta.primera_persona}
                                  </p>
                                </div>
                                <div>
                                  <strong style={{ color: '#374151', fontSize: '0.75rem' }}>👨‍💼 Tercera persona:</strong>
                                  <p style={{ margin: '0.25rem 0', fontSize: '0.875rem', color: '#6b7280' }}>
                                    {pregunta.tercera_persona}
                                  </p>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      )}
                    </div>
                  ))
                }
              </div>
            </div>

            {/* Competencias Funcionales */}
            <div className="clasificacion-group" style={{ marginBottom: '2rem' }}>
              <div style={{ 
                display: 'flex', 
                justifyContent: 'space-between', 
                alignItems: 'center',
                marginBottom: '0.5rem'
              }}>
                <h4 style={{ 
                  color: '#f59e0b',
                  margin: 0,
                  fontSize: '1.25rem',
                  fontWeight: '600'
                }}>
                  ⚙️ Competencias Funcionales
                </h4>
                <button
                  onClick={() => openNewCompetenciaForm('funcional')}
                  style={{
                    backgroundColor: '#f59e0b',
                    color: 'white',
                    border: 'none',
                    padding: '0.5rem 1rem',
                    borderRadius: '6px',
                    cursor: 'pointer',
                    fontSize: '0.875rem',
                    fontWeight: '500',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.5rem'
                  }}
                >
                  ➕ Nueva Competencia
                </button>
              </div>
              <p style={{ 
                color: '#6b7280',
                marginBottom: '1rem',
                fontSize: '0.875rem'
              }}>
                Específicas por posición de trabajo
              </p>

              {/* Formulario inline para nueva competencia funcional */}
              {showNewCompetenciaFuncional && (
                <div 
                  data-form-funcional="true"
                  style={{
                    backgroundColor: '#fffbeb',
                    border: '2px solid #f59e0b',
                    borderRadius: '8px',
                    padding: '1.5rem',
                    marginBottom: '1rem'
                  }}
                onClick={(e) => e.stopPropagation()}
                >
                  <h5 style={{ 
                    margin: '0 0 1rem 0',
                    fontSize: '1rem',
                    fontWeight: '600',
                    color: '#1e293b'
                  }}>
                    {selectedCompetenciaForForm ? '✏️ Editar Competencia Funcional' : '➕ Nueva Competencia Funcional'}
                  </h5>
                  
                  <div style={{ marginBottom: '1rem' }}>
                    <label style={{ 
                      display: 'block',
                      marginBottom: '0.5rem',
                      fontWeight: '500',
                      color: '#374151',
                      fontSize: '0.875rem'
                    }}>
                      Nombre de la Competencia:
                    </label>
                    <input
                      type="text"
                      value={newCompetenciaInline.nombre}
                      onChange={(e) => setNewCompetenciaInline({
                        ...newCompetenciaInline,
                        nombre: e.target.value
                      })}
                      placeholder="Ej: Programación en Java, Análisis financiero..."
                      style={{
                        width: '100%',
                        padding: '0.75rem',
                        border: '1px solid #d1d5db',
                        borderRadius: '6px',
                        fontSize: '14px',
                        fontFamily: 'inherit'
                      }}
                    />
                  </div>

                  <div style={{ marginBottom: '1rem' }}>
                    <label style={{ 
                      display: 'block',
                      marginBottom: '0.5rem',
                      fontWeight: '500',
                      color: '#374151',
                      fontSize: '0.875rem'
                    }}>
                      Cargo/Posición Específica:
                    </label>
                    <div className="posiciones-dropdown-container" style={{ position: 'relative' }}>
                      <input
                        type="text"
                        value={posicionSearchText || newCompetenciaInline.cargoEspecifico}
                        onChange={(e) => {
                          handlePosicionSearch(e.target.value);
                          setNewCompetenciaInline({
                            ...newCompetenciaInline,
                            cargoEspecifico: e.target.value
                          });
                        }}
                        onFocus={() => {
                          setShowPosicionesDropdown(true);
                          if (filteredPosiciones.length === 0 && posiciones.length > 0) {
                            // CORREGIDO: Aplicar filtro de empresa al abrir dropdown
                            const posicionesFiltradas = selectedEmpresa?.id 
                              ? posiciones.filter(posicion => posicion.empresa_id === selectedEmpresa.id)
                              : posiciones;
                            setFilteredPosiciones(posicionesFiltradas);
                          }
                        }}
                        placeholder="Buscar cargo/posición..."
                        style={{
                          width: '100%',
                          padding: '0.75rem',
                          border: '1px solid #d1d5db',
                          borderRadius: '6px',
                          fontSize: '14px',
                          fontFamily: 'inherit'
                        }}
                      />
                      
                      {/* Dropdown de posiciones */}
                      {showPosicionesDropdown && filteredPosiciones.length > 0 && (
                        <div style={{
                          position: 'absolute',
                          top: '100%',
                          left: 0,
                          right: 0,
                          backgroundColor: 'white',
                          border: '1px solid #d1d5db',
                          borderTop: 'none',
                          borderRadius: '0 0 6px 6px',
                          maxHeight: '200px',
                          overflowY: 'auto',
                          zIndex: 1000,
                          boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)'
                        }}>
                          {filteredPosiciones.map((posicion) => (
                            <div
                              key={posicion.id}
                              onClick={() => selectPosicion(posicion)}
                              style={{
                                padding: '0.75rem',
                                cursor: 'pointer',
                                borderBottom: '1px solid #f3f4f6',
                                transition: 'background-color 0.2s'
                              }}
                              onMouseEnter={(e) => {
                                e.target.style.backgroundColor = '#f9fafb';
                              }}
                              onMouseLeave={(e) => {
                                e.target.style.backgroundColor = 'transparent';
                              }}
                            >
                              <div style={{ fontWeight: '500', color: '#1f2937' }}>
                                {posicion.nombre}
                              </div>
                              {posicion.departamento && (
                                <div style={{ fontSize: '0.75rem', color: '#6b7280', marginTop: '0.25rem' }}>
                                  📂 {posicion.departamento}
                                </div>
                              )}
                              {posicion.descripcion && (
                                <div style={{ fontSize: '0.75rem', color: '#9ca3af', marginTop: '0.25rem' }}>
                                  {posicion.descripcion.length > 60 
                                    ? `${posicion.descripcion.substring(0, 60)}...` 
                                    : posicion.descripcion}
                                </div>
                              )}
                            </div>
                          ))}
                        </div>
                      )}
                      
                      {/* Mensaje cuando no hay resultados */}
                      {showPosicionesDropdown && filteredPosiciones.length === 0 && posicionSearchText.trim() !== '' && (
                        <div style={{
                          position: 'absolute',
                          top: '100%',
                          left: 0,
                          right: 0,
                          backgroundColor: 'white',
                          border: '1px solid #d1d5db',
                          borderTop: 'none',
                          borderRadius: '0 0 6px 6px',
                          padding: '1rem',
                          textAlign: 'center',
                          color: '#6b7280',
                          fontSize: '0.875rem',
                          zIndex: 1000,
                          boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)'
                        }}>
                          No se encontraron posiciones que coincidan con "{posicionSearchText}"
                        </div>
                      )}
                    </div>
                  </div>

                  <div style={{ marginBottom: '1rem' }}>
                    <label style={{ 
                      display: 'block',
                      marginBottom: '0.5rem',
                      fontWeight: '500',
                      color: '#374151',
                      fontSize: '0.875rem'
                    }}>
                      Descripción:
                    </label>
                    <textarea
                      value={newCompetenciaInline.descripcion}
                      onChange={(e) => setNewCompetenciaInline({
                        ...newCompetenciaInline,
                        descripcion: e.target.value
                      })}
                      placeholder="Describe las habilidades técnicas específicas requeridas..."
                      style={{
                        width: '100%',
                        minHeight: '80px',
                        padding: '0.75rem',
                        border: '1px solid #d1d5db',
                        borderRadius: '6px',
                        fontSize: '14px',
                        fontFamily: 'inherit',
                        resize: 'vertical'
                      }}
                    />
                  </div>

                  <div style={{ marginBottom: '1rem' }}>
                    <label style={{ 
                      display: 'block',
                      marginBottom: '0.5rem',
                      fontWeight: '500',
                      color: '#374151',
                      fontSize: '0.875rem'
                    }}>
                      Empresa:
                    </label>
                    <select
                      value={newCompetenciaInline.empresaId}
                      onChange={(e) => setNewCompetenciaInline({
                        ...newCompetenciaInline,
                        empresaId: e.target.value
                      })}
                      style={{
                        width: '100%',
                        padding: '0.75rem',
                        border: '1px solid #d1d5db',
                        borderRadius: '6px',
                        fontSize: '14px',
                        fontFamily: 'inherit',
                        backgroundColor: 'white'
                      }}
                    >
                      <option value="">Seleccionar empresa...</option>
                      {empresas.map((empresa) => (
                        <option key={empresa.id} value={empresa.id}>
                          {empresa.nombre || empresa.id}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div style={{ display: 'flex', gap: '1rem' }}>
                    <button
                      onClick={handleCreateCompetenciaInline}
                      disabled={!newCompetenciaInline.nombre.trim() || !newCompetenciaInline.descripcion.trim() || !newCompetenciaInline.cargoEspecifico.trim() || !newCompetenciaInline.empresaId}
                      style={{
                        backgroundColor: (newCompetenciaInline.nombre.trim() && newCompetenciaInline.descripcion.trim() && newCompetenciaInline.cargoEspecifico.trim() && newCompetenciaInline.empresaId) ? '#10b981' : '#9ca3af',
                        color: 'white',
                        border: 'none',
                        padding: '0.75rem 1.5rem',
                        borderRadius: '6px',
                        cursor: (newCompetenciaInline.nombre.trim() && newCompetenciaInline.descripcion.trim() && newCompetenciaInline.cargoEspecifico.trim() && newCompetenciaInline.empresaId) ? 'pointer' : 'not-allowed',
                        fontSize: '14px',
                        fontWeight: '500',
                        flex: 1
                      }}
                    >
                      {selectedCompetenciaForForm?.id ? '🔄 Actualizar Competencia' : '✅ Crear Competencia'}
                    </button>
                    <button
                      onClick={closeNewCompetenciaForms}
                      style={{
                        backgroundColor: '#f3f4f6',
                        color: '#374151',
                        border: 'none',
                        padding: '0.75rem 1.5rem',
                        borderRadius: '6px',
                        cursor: 'pointer',
                        fontSize: '14px',
                        fontWeight: '500'
                      }}
                    >
                      ❌ Cancelar
                    </button>
                  </div>
                </div>
              )}

              <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
                gap: '1rem',
                marginBottom: '1rem'
              }}>
                {competencias
                  .filter(comp => comp.tipoCompetencia === 'funcional' || comp.tipo === 'Funcional')
                  .filter(comp => {
                    // CORREGIDO: Filtrar competencias funcionales por empresa seleccionada o mostrar bemovil por defecto
                    if (comp.tipoCompetencia === 'funcional' || comp.tipo === 'Funcional') {
                      return comp.empresa_id === (selectedEmpresa?.id || 'bemovil');
                    }
                    return true;
                  })
                  .map(competencia => (
                    <div 
                      key={competencia.id} 
                      style={{
                        border: newPlantilla.competenciasSeleccionadas.includes(competencia.id) 
                          ? '2px solid #f59e0b' : '1px solid #e5e7eb',
                        borderRadius: '8px',
                        padding: '1rem',
                        cursor: 'pointer',
                        backgroundColor: newPlantilla.competenciasSeleccionadas.includes(competencia.id) 
                          ? '#fffbeb' : 'white',
                        transition: 'all 0.2s'
                      }}
                      onClick={() => handleCompetenciaSelection(competencia.id, true)}
                    >
                      <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        marginBottom: '0.5rem'
                      }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                          <span style={{ fontSize: '1.5rem' }}>⚙️</span>
                          <span style={{ fontWeight: '600', color: '#1e293b' }}>
                            {competencia.nombre}
                          </span>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                          {newPlantilla.competenciasSeleccionadas.includes(competencia.id) && (
                            <span style={{
                              backgroundColor: '#f59e0b',
                              color: 'white',
                              padding: '0.25rem 0.5rem',
                              borderRadius: '12px',
                              fontSize: '0.75rem',
                              fontWeight: '500'
                            }}>
                              {newPlantilla.competenciasDetalle[competencia.id]?.porcentaje || 0}%
                            </span>
                          )}
                          <button
                            onClick={(e) => handleEditCompetencia(competencia, e)}
                            style={{
                              backgroundColor: '#f59e0b',
                              color: 'white',
                              border: 'none',
                              padding: '0.25rem 0.5rem',
                              borderRadius: '4px',
                              cursor: 'pointer',
                              fontSize: '0.75rem',
                              fontWeight: '500'
                            }}
                            title="Editar competencia"
                          >
                            ✏️
                          </button>
                          <button
                            onClick={(e) => handleDeleteCompetencia(competencia, e)}
                            style={{
                              backgroundColor: '#ef4444',
                              color: 'white',
                              border: 'none',
                              padding: '0.25rem 0.5rem',
                              borderRadius: '4px',
                              cursor: 'pointer',
                              fontSize: '0.75rem',
                              fontWeight: '500'
                            }}
                            title="Eliminar competencia"
                          >
                            🗑️
                          </button>
                        </div>
                      </div>
                      <p style={{ 
                        color: '#6b7280',
                        fontSize: '0.875rem',
                        marginBottom: '0.5rem'
                      }}>
                        {competencia.descripcion}
                      </p>
                      <p style={{ 
                        color: '#f59e0b',
                        fontSize: '0.75rem',
                        fontWeight: '500',
                        marginBottom: '1rem'
                      }}>
                        🎯 {competencia.cargo}
                      </p>
                      {newPlantilla.competenciasSeleccionadas.includes(competencia.id) && (
                        <div style={{ marginTop: '1rem' }}>
                          <button 
                            style={{
                              backgroundColor: '#10b981',
                              color: 'white',
                              border: 'none',
                              padding: '0.5rem 1rem',
                              borderRadius: '6px',
                              cursor: 'pointer',
                              fontSize: '0.875rem',
                              fontWeight: '500',
                              width: '100%',
                              marginBottom: '1rem'
                            }}
                            onClick={(e) => {
                              e.stopPropagation();
                              console.log('🎯 Botón Crear Afirmaciones (Funcional) presionado para:', competencia.nombre);
                              openCompetenciaForm(competencia);
                            }}
                          >
                            {competenciaEnEdicion === competencia.id ? '❌ Cerrar Formulario' : '➕ Crear Afirmaciones'} ({newPlantilla.competenciasDetalle[competencia.id]?.preguntas?.length || 0})
                          </button>
                          
                          {/* Formulario inline para crear afirmaciones */}
                          {competenciaEnEdicion === competencia.id && (
                            <div 
                              onClick={(e) => e.stopPropagation()}
                              style={{
                                backgroundColor: '#f8fafc',
                                border: '2px solid #3b82f6',
                                borderRadius: '8px',
                                padding: '1.5rem',
                                marginBottom: '1rem'
                              }}>
                              <h5 style={{ 
                                margin: '0 0 1rem 0',
                                fontSize: '1rem',
                                fontWeight: '600',
                                color: '#1e293b'
                              }}>
                                ✍️ Nueva Afirmación para: {competencia.nombre}
                              </h5>
                              
                              <div style={{ marginBottom: '1rem' }}>
                                <label style={{ 
                                  display: 'block',
                                  marginBottom: '0.5rem',
                                  fontWeight: '500',
                                  color: '#374151',
                                  fontSize: '0.875rem'
                                }}>
                                  👤 Afirmación en Primera Persona (Autoevaluación):
                                </label>
                                <textarea
                                  value={currentPregunta.primera_persona}
                                  onChange={(e) => handlePrimeraPersonaChange(e.target.value)}
                                  placeholder="Ejemplo: Yo manejo situaciones difíciles con calma y profesionalismo..."
                                  style={{
                                    width: '100%',
                                    minHeight: '60px',
                                    padding: '0.75rem',
                                    border: '1px solid #d1d5db',
                                    borderRadius: '6px',
                                    fontSize: '14px',
                                    fontFamily: 'inherit',
                                    resize: 'vertical'
                                  }}
                                />
                              </div>

                              <div style={{ marginBottom: '1rem' }}>
                                <label style={{ 
                                  display: 'block',
                                  marginBottom: '0.5rem',
                                  fontWeight: '500',
                                  color: '#374151',
                                  fontSize: '0.875rem'
                                }}>
                                  👨‍💼 Afirmación en Tercera Persona:
                                  <span style={{ 
                                    color: '#10b981',
                                    fontSize: '0.75rem',
                                    marginLeft: '0.5rem'
                                  }}>
                                    (Generada automáticamente)
                                  </span>
                                </label>
                                <textarea
                                  value={currentPregunta.tercera_persona}
                                  onChange={(e) => setCurrentPregunta({
                                    ...currentPregunta,
                                    tercera_persona: e.target.value,
                                    editada: true
                                  })}
                                  placeholder="Se genera automáticamente..."
                                  style={{
                                    width: '100%',
                                    minHeight: '60px',
                                    padding: '0.75rem',
                                    border: '1px solid #d1d5db',
                                    borderRadius: '6px',
                                    fontSize: '14px',
                                    fontFamily: 'inherit',
                                    resize: 'vertical',
                                    backgroundColor: currentPregunta.editada ? 'white' : '#f9fafb'
                                  }}
                                />
                              </div>

                              <button
                                onClick={addPreguntaToCompetencia}
                                disabled={!currentPregunta.primera_persona.trim()}
                                style={{
                                  backgroundColor: currentPregunta.primera_persona.trim() ? '#10b981' : '#9ca3af',
                                  color: 'white',
                                  border: 'none',
                                  padding: '0.75rem 1.5rem',
                                  borderRadius: '6px',
                                  cursor: currentPregunta.primera_persona.trim() ? 'pointer' : 'not-allowed',
                                  fontSize: '14px',
                                  fontWeight: '500',
                                  width: '100%'
                                }}
                              >
                                ➕ Agregar Afirmación
                              </button>
                            </div>
                          )}
                          
                          {/* Mostrar afirmaciones existentes */}
                          {newPlantilla.competenciasDetalle[competencia.id]?.preguntas?.length > 0 && (
                            <div style={{
                              backgroundColor: '#f8fafc',
                              border: '1px solid #e2e8f0',
                              borderRadius: '6px',
                              padding: '1rem',
                              maxHeight: '200px',
                              overflowY: 'auto'
                            }}>
                              <h5 style={{ 
                                margin: '0 0 0.75rem 0',
                                fontSize: '0.875rem',
                                fontWeight: '600',
                                color: '#374151'
                              }}>
                                📝 Afirmaciones creadas ({newPlantilla.competenciasDetalle[competencia.id].preguntas.length}):
                              </h5>
                              {newPlantilla.competenciasDetalle[competencia.id].preguntas.map((pregunta, index) => (
                                <div key={index} style={{
                                  backgroundColor: 'white',
                                  border: '1px solid #e5e7eb',
                                  borderRadius: '4px',
                                  padding: '0.75rem',
                                  marginBottom: '0.5rem',
                                  fontSize: '0.75rem'
                                }}>
                                  <div style={{ 
                                    marginBottom: '0.5rem',
                                    fontWeight: '500',
                                    color: '#1e293b'
                                  }}>
                                    Afirmación #{index + 1} ({pregunta.porcentaje}%)
                                  </div>
                                  <div style={{ marginBottom: '0.25rem' }}>
                                    <strong style={{ color: '#3b82f6' }}>👤 Autoevaluación:</strong> {pregunta.primera_persona}
                                  </div>
                                  <div style={{ color: '#6b7280' }}>
                                    <strong style={{ color: '#f59e0b' }}>👨‍💼 Evaluación:</strong> {pregunta.tercera_persona}
                                  </div>
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  ))
                }
              </div>
            </div>

            {/* Competencias de Liderazgo */}
            <div className="clasificacion-group" style={{ marginBottom: '2rem' }}>
              <div style={{ 
                display: 'flex', 
                justifyContent: 'space-between', 
                alignItems: 'center',
                marginBottom: '0.5rem'
              }}>
                <h4 style={{ 
                  color: '#8b5cf6',
                  margin: 0,
                  fontSize: '1.25rem',
                  fontWeight: '600'
                }}>
                  👑 Competencias de Liderazgo
                </h4>
                <button
                  onClick={() => openNewCompetenciaForm('liderazgo')}
                  style={{
                    backgroundColor: '#8b5cf6',
                    color: 'white',
                    border: 'none',
                    padding: '0.5rem 1rem',
                    borderRadius: '6px',
                    cursor: 'pointer',
                    fontSize: '0.875rem',
                    fontWeight: '500',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.5rem'
                  }}
                >
                  ➕ Nueva Competencia
                </button>
              </div>
              <p style={{ 
                color: '#6b7280',
                marginBottom: '1rem',
                fontSize: '0.875rem'
              }}>
                Solo para supervisores que supervisan a otros
              </p>

              {/* Formulario inline para nueva competencia de liderazgo */}
              {showNewCompetenciaLiderazgo && (
                <div 
                  data-form-liderazgo="true"
                  style={{
                    backgroundColor: '#faf5ff',
                    border: '2px solid #8b5cf6',
                    borderRadius: '8px',
                    padding: '1.5rem',
                    marginBottom: '1rem'
                  }}
                onClick={(e) => e.stopPropagation()}
                >
                  <h5 style={{ 
                    margin: '0 0 1rem 0',
                    fontSize: '1rem',
                    fontWeight: '600',
                    color: '#1e293b'
                  }}>
                    {selectedCompetenciaForForm ? '✏️ Editar Competencia de Liderazgo' : '➕ Nueva Competencia de Liderazgo'}
                  </h5>
                  
                  <div style={{ marginBottom: '1rem' }}>
                    <label style={{ 
                      display: 'block',
                      marginBottom: '0.5rem',
                      fontWeight: '500',
                      color: '#374151',
                      fontSize: '0.875rem'
                    }}>
                      Nombre de la Competencia:
                    </label>
                    <input
                      type="text"
                      value={newCompetenciaInline.nombre}
                      onChange={(e) => setNewCompetenciaInline({
                        ...newCompetenciaInline,
                        nombre: e.target.value
                      })}
                      placeholder="Ej: Gestión de equipos, Delegación efectiva..."
                      style={{
                        width: '100%',
                        padding: '0.75rem',
                        border: '1px solid #d1d5db',
                        borderRadius: '6px',
                        fontSize: '14px',
                        fontFamily: 'inherit'
                      }}
                    />
                  </div>

                  <div style={{ marginBottom: '1rem' }}>
                    <label style={{ 
                      display: 'block',
                      marginBottom: '0.5rem',
                      fontWeight: '500',
                      color: '#374151',
                      fontSize: '0.875rem'
                    }}>
                      Descripción:
                    </label>
                    <textarea
                      value={newCompetenciaInline.descripcion}
                      onChange={(e) => setNewCompetenciaInline({
                        ...newCompetenciaInline,
                        descripcion: e.target.value
                      })}
                      placeholder="Describe las habilidades de liderazgo y supervisión requeridas..."
                      style={{
                        width: '100%',
                        minHeight: '80px',
                        padding: '0.75rem',
                        border: '1px solid #d1d5db',
                        borderRadius: '6px',
                        fontSize: '14px',
                        fontFamily: 'inherit',
                        resize: 'vertical'
                      }}
                    />
                  </div>

                  <div style={{ display: 'flex', gap: '1rem' }}>
                    <button
                      onClick={handleCreateCompetenciaInline}
                      disabled={!newCompetenciaInline.nombre.trim() || !newCompetenciaInline.descripcion.trim()}
                      style={{
                        backgroundColor: (newCompetenciaInline.nombre.trim() && newCompetenciaInline.descripcion.trim()) ? '#10b981' : '#9ca3af',
                        color: 'white',
                        border: 'none',
                        padding: '0.75rem 1.5rem',
                        borderRadius: '6px',
                        cursor: (newCompetenciaInline.nombre.trim() && newCompetenciaInline.descripcion.trim()) ? 'pointer' : 'not-allowed',
                        fontSize: '14px',
                        fontWeight: '500',
                        flex: 1
                      }}
                    >
                      {selectedCompetenciaForForm?.id ? '🔄 Actualizar Competencia' : '✅ Crear Competencia'}
                    </button>
                    <button
                      onClick={closeNewCompetenciaForms}
                      style={{
                        backgroundColor: '#f3f4f6',
                        color: '#374151',
                        border: 'none',
                        padding: '0.75rem 1.5rem',
                        borderRadius: '6px',
                        cursor: 'pointer',
                        fontSize: '14px',
                        fontWeight: '500'
                      }}
                    >
                      ❌ Cancelar
                    </button>
                  </div>
                </div>
              )}

              <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
                gap: '1rem',
                marginBottom: '1rem'
              }}>
                {competencias
                  .filter(comp => comp.tipoCompetencia === 'liderazgo' || comp.tipo === 'Liderazgo')
                  .map(competencia => (
                    <div 
                      key={competencia.id} 
                      style={{
                        border: newPlantilla.competenciasSeleccionadas.includes(competencia.id) 
                          ? '2px solid #8b5cf6' : '1px solid #e5e7eb',
                        borderRadius: '8px',
                        padding: '1rem',
                        cursor: 'pointer',
                        backgroundColor: newPlantilla.competenciasSeleccionadas.includes(competencia.id) 
                          ? '#f3e8ff' : 'white',
                        transition: 'all 0.2s'
                      }}
                      onClick={() => handleCompetenciaSelection(competencia.id, true)}
                    >
                      <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        marginBottom: '0.5rem'
                      }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                          <span style={{ fontSize: '1.5rem' }}>👑</span>
                          <span style={{ fontWeight: '600', color: '#1e293b' }}>
                            {competencia.nombre}
                          </span>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                          {newPlantilla.competenciasSeleccionadas.includes(competencia.id) && (
                            <span style={{
                              backgroundColor: '#8b5cf6',
                              color: 'white',
                              padding: '0.25rem 0.5rem',
                              borderRadius: '12px',
                              fontSize: '0.75rem',
                              fontWeight: '500'
                            }}>
                              {newPlantilla.competenciasDetalle[competencia.id]?.porcentaje || 0}%
                            </span>
                          )}
                          <button
                            onClick={(e) => handleEditCompetencia(competencia, e)}
                            style={{
                              backgroundColor: '#f59e0b',
                              color: 'white',
                              border: 'none',
                              padding: '0.25rem 0.5rem',
                              borderRadius: '4px',
                              cursor: 'pointer',
                              fontSize: '0.75rem',
                              fontWeight: '500'
                            }}
                            title="Editar competencia"
                          >
                            ✏️
                          </button>
                          <button
                            onClick={(e) => handleDeleteCompetencia(competencia, e)}
                            style={{
                              backgroundColor: '#ef4444',
                              color: 'white',
                              border: 'none',
                              padding: '0.25rem 0.5rem',
                              borderRadius: '4px',
                              cursor: 'pointer',
                              fontSize: '0.75rem',
                              fontWeight: '500'
                            }}
                            title="Eliminar competencia"
                          >
                            🗑️
                          </button>
                        </div>
                      </div>
                      <p style={{ 
                        color: '#6b7280',
                        fontSize: '0.875rem',
                        marginBottom: '0.5rem'
                      }}>
                        {competencia.descripcion}
                      </p>
                      <p style={{ 
                        color: '#8b5cf6',
                        fontSize: '0.75rem',
                        fontWeight: '500',
                        marginBottom: '1rem'
                      }}>
                        👥 {competencia.cargo}
                      </p>
                      {newPlantilla.competenciasSeleccionadas.includes(competencia.id) && (
                        <div style={{ marginTop: '1rem' }}>
                          <button 
                            style={{
                              backgroundColor: '#10b981',
                              color: 'white',
                              border: 'none',
                              padding: '0.5rem 1rem',
                              borderRadius: '6px',
                              cursor: 'pointer',
                              fontSize: '0.875rem',
                              fontWeight: '500',
                              width: '100%',
                              marginBottom: '1rem'
                            }}
                            onClick={(e) => {
                              e.stopPropagation();
                              openCompetenciaForm(competencia);
                            }}
                          >
                            {competenciaEnEdicion === competencia.id ? '❌ Cerrar Formulario' : '➕ Crear Afirmaciones'} ({newPlantilla.competenciasDetalle[competencia.id]?.preguntas?.length || 0})
                          </button>
                          
                          {/* Formulario inline para crear afirmaciones */}
                          {competenciaEnEdicion === competencia.id && (
                            <div 
                              onClick={(e) => e.stopPropagation()}
                              style={{
                                backgroundColor: '#f8fafc',
                                border: '2px solid #3b82f6',
                                borderRadius: '8px',
                                padding: '1.5rem',
                                marginBottom: '1rem'
                              }}>
                              <h5 style={{ 
                                margin: '0 0 1rem 0',
                                fontSize: '1rem',
                                fontWeight: '600',
                                color: '#1e293b'
                              }}>
                                ✍️ Nueva Afirmación para: {competencia.nombre}
                              </h5>
                              
                              <div style={{ marginBottom: '1rem' }}>
                                <label style={{ 
                                  display: 'block',
                                  marginBottom: '0.5rem',
                                  fontWeight: '500',
                                  color: '#374151',
                                  fontSize: '0.875rem'
                                }}>
                                  👤 Afirmación en Primera Persona (Autoevaluación):
                                </label>
                                <textarea
                                  value={currentPregunta.primera_persona}
                                  onChange={(e) => handlePrimeraPersonaChange(e.target.value)}
                                  placeholder="Ejemplo: Yo manejo situaciones difíciles con calma y profesionalismo..."
                                  style={{
                                    width: '100%',
                                    minHeight: '60px',
                                    padding: '0.75rem',
                                    border: '1px solid #d1d5db',
                                    borderRadius: '6px',
                                    fontSize: '14px',
                                    fontFamily: 'inherit',
                                    resize: 'vertical'
                                  }}
                                />
                              </div>

                              <div style={{ marginBottom: '1rem' }}>
                                <label style={{ 
                                  display: 'block',
                                  marginBottom: '0.5rem',
                                  fontWeight: '500',
                                  color: '#374151',
                                  fontSize: '0.875rem'
                                }}>
                                  👨‍💼 Afirmación en Tercera Persona:
                                  <span style={{ 
                                    color: '#10b981',
                                    fontSize: '0.75rem',
                                    marginLeft: '0.5rem'
                                  }}>
                                    (Generada automáticamente)
                                  </span>
                                </label>
                                <textarea
                                  value={currentPregunta.tercera_persona}
                                  onChange={(e) => setCurrentPregunta({
                                    ...currentPregunta,
                                    tercera_persona: e.target.value,
                                    editada: true
                                  })}
                                  placeholder="Se genera automáticamente..."
                                  style={{
                                    width: '100%',
                                    minHeight: '60px',
                                    padding: '0.75rem',
                                    border: '1px solid #d1d5db',
                                    borderRadius: '6px',
                                    fontSize: '14px',
                                    fontFamily: 'inherit',
                                    resize: 'vertical',
                                    backgroundColor: currentPregunta.editada ? 'white' : '#f9fafb'
                                  }}
                                />
                              </div>

                              <button
                                onClick={addPreguntaToCompetencia}
                                disabled={!currentPregunta.primera_persona.trim()}
                                style={{
                                  backgroundColor: currentPregunta.primera_persona.trim() ? '#10b981' : '#9ca3af',
                                  color: 'white',
                                  border: 'none',
                                  padding: '0.75rem 1.5rem',
                                  borderRadius: '6px',
                                  cursor: currentPregunta.primera_persona.trim() ? 'pointer' : 'not-allowed',
                                  fontSize: '14px',
                                  fontWeight: '500',
                                  width: '100%'
                                }}
                              >
                                ➕ Agregar Afirmación
                              </button>
                            </div>
                          )}
                          
                          {/* Mostrar afirmaciones existentes */}
                          {newPlantilla.competenciasDetalle[competencia.id]?.preguntas?.length > 0 && (
                            <div style={{
                              backgroundColor: '#f8fafc',
                              border: '1px solid #e2e8f0',
                              borderRadius: '6px',
                              padding: '1rem',
                              maxHeight: '200px',
                              overflowY: 'auto'
                            }}>
                              <h5 style={{ 
                                margin: '0 0 0.75rem 0',
                                fontSize: '0.875rem',
                                fontWeight: '600',
                                color: '#374151'
                              }}>
                                📝 Afirmaciones creadas ({newPlantilla.competenciasDetalle[competencia.id].preguntas.length}):
                              </h5>
                              {newPlantilla.competenciasDetalle[competencia.id].preguntas.map((pregunta, index) => (
                                <div key={index} style={{
                                  backgroundColor: 'white',
                                  border: '1px solid #e5e7eb',
                                  borderRadius: '4px',
                                  padding: '0.75rem',
                                  marginBottom: '0.5rem',
                                  fontSize: '0.75rem'
                                }}>
                                  <div style={{ 
                                    marginBottom: '0.5rem',
                                    fontWeight: '500',
                                    color: '#1e293b'
                                  }}>
                                    Afirmación #{index + 1} ({pregunta.porcentaje}%)
                                  </div>
                                  <div style={{ marginBottom: '0.25rem' }}>
                                    <strong style={{ color: '#3b82f6' }}>👤 Autoevaluación:</strong> {pregunta.primera_persona}
                                  </div>
                                  <div style={{ color: '#6b7280' }}>
                                    <strong style={{ color: '#f59e0b' }}>👨‍💼 Evaluación:</strong> {pregunta.tercera_persona}
                                  </div>
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  ))
                }
              </div>
            </div>

            {/* Resumen de Configuración */}
            {newPlantilla.competenciasSeleccionadas.length > 0 && (
              <div style={{
                backgroundColor: '#f8fafc',
                border: '1px solid #e2e8f0',
                borderRadius: '8px',
                padding: '1.5rem',
                marginTop: '2rem'
              }}>
                <h4 style={{ 
                  color: '#1e293b',
                  marginBottom: '1rem',
                  fontSize: '1.125rem',
                  fontWeight: '600'
                }}>
                  📋 Resumen de Configuración
                </h4>
                
                <div style={{
                  display: 'grid',
                  gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
                  gap: '1rem',
                  marginBottom: '2rem'
                }}>
                  <div style={{
                    backgroundColor: 'white',
                    padding: '1rem',
                    borderRadius: '6px',
                    textAlign: 'center'
                  }}>
                    <div style={{ fontSize: '1.5rem', marginBottom: '0.5rem' }}>📊</div>
                    <div style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#3b82f6' }}>
                      {newPlantilla.competenciasSeleccionadas.length}
                    </div>
                    <div style={{ fontSize: '0.875rem', color: '#6b7280' }}>
                      Competencias Seleccionadas
                    </div>
                  </div>
                  
                  <div style={{
                    backgroundColor: 'white',
                    padding: '1rem',
                    borderRadius: '6px',
                    textAlign: 'center'
                  }}>
                    <div style={{ fontSize: '1.5rem', marginBottom: '0.5rem' }}>❓</div>
                    <div style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#10b981' }}>
                      {Object.values(newPlantilla.competenciasDetalle).reduce((total, detalle) => 
                        total + (detalle.preguntas?.length || 0), 0
                      )}
                    </div>
                    <div style={{ fontSize: '0.875rem', color: '#6b7280' }}>
                      Total Afirmaciones
                    </div>
                  </div>
                  
                  <div style={{
                    backgroundColor: 'white',
                    padding: '1rem',
                    borderRadius: '6px',
                    textAlign: 'center'
                  }}>
                    <div style={{ fontSize: '1.5rem', marginBottom: '0.5rem' }}>👨‍💼</div>
                    <div style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#f59e0b' }}>
                      {newPlantilla.porcentajeEvaluacion}%
                    </div>
                    <div style={{ fontSize: '0.875rem', color: '#6b7280' }}>
                      Evaluación Supervisor
                    </div>
                  </div>
                  
                  <div style={{
                    backgroundColor: 'white',
                    padding: '1rem',
                    borderRadius: '6px',
                    textAlign: 'center'
                  }}>
                    <div style={{ fontSize: '1.5rem', marginBottom: '0.5rem' }}>👤</div>
                    <div style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#8b5cf6' }}>
                      {newPlantilla.porcentajeAutoevaluacion}%
                    </div>
                    <div style={{ fontSize: '0.875rem', color: '#6b7280' }}>
                      Autoevaluación
                    </div>
                  </div>
                </div>
                
                {/* Control de Porcentajes */}
                <div style={{
                  backgroundColor: 'white',
                  padding: '1.5rem',
                  borderRadius: '8px',
                  marginTop: '1rem'
                }}>
                  <h5 style={{ 
                    color: '#1e293b',
                    marginBottom: '1rem',
                    fontSize: '1rem',
                    fontWeight: '600'
                  }}>
                    ⚖️ Distribución Evaluación vs Autoevaluación
                  </h5>
                  
                  <div style={{
                    display: 'grid',
                    gridTemplateColumns: '1fr 1fr',
                    gap: '2rem'
                  }}>
                    <div>
                      <label style={{ 
                        display: 'block',
                        marginBottom: '0.5rem',
                        fontWeight: '500',
                        color: '#374151'
                      }}>
                        👨‍💼 Evaluación del Supervisor: {newPlantilla.porcentajeEvaluacion}%
                      </label>
                      <input
                        type="range"
                        min="0"
                        max="100"
                        value={newPlantilla.porcentajeEvaluacion}
                        onChange={(e) => {
                          const valor = parseInt(e.target.value);
                          setNewPlantilla({
                            ...newPlantilla,
                            porcentajeEvaluacion: valor,
                            porcentajeAutoevaluacion: 100 - valor
                          });
                        }}
                        style={{
                          width: '100%',
                          height: '8px',
                          borderRadius: '4px',
                          background: '#e5e7eb',
                          outline: 'none',
                          opacity: '0.7',
                          transition: 'opacity 0.2s'
                        }}
                      />
                    </div>
                    
                    <div>
                      <label style={{ 
                        display: 'block',
                        marginBottom: '0.5rem',
                        fontWeight: '500',
                        color: '#374151'
                      }}>
                        👤 Autoevaluación del Empleado: {newPlantilla.porcentajeAutoevaluacion}%
                      </label>
                      <input
                        type="range"
                        min="0"
                        max="100"
                        value={newPlantilla.porcentajeAutoevaluacion}
                        onChange={(e) => {
                          const valor = parseInt(e.target.value);
                          setNewPlantilla({
                            ...newPlantilla,
                            porcentajeAutoevaluacion: valor,
                            porcentajeEvaluacion: 100 - valor
                          });
                        }}
                        style={{
                          width: '100%',
                          height: '8px',
                          borderRadius: '4px',
                          background: '#e5e7eb',
                          outline: 'none',
                          opacity: '0.7',
                          transition: 'opacity 0.2s'
                        }}
                      />
                    </div>
                  </div>
                  
                  <div style={{
                    marginTop: '1rem',
                    padding: '0.75rem',
                    backgroundColor: newPlantilla.porcentajeEvaluacion + newPlantilla.porcentajeAutoevaluacion === 100 
                      ? '#dcfce7' : '#fef2f2',
                    borderRadius: '6px',
                    textAlign: 'center',
                    fontWeight: '500'
                  }}>
                    <span style={{ color: '#374151' }}>
                      Total: {newPlantilla.porcentajeEvaluacion + newPlantilla.porcentajeAutoevaluacion}%
                    </span>
                    {newPlantilla.porcentajeEvaluacion + newPlantilla.porcentajeAutoevaluacion === 100 ? 
                      <span style={{ marginLeft: '0.5rem', color: '#16a34a' }}>✅ Perfecto</span> : 
                      <span style={{ marginLeft: '0.5rem', color: '#dc2626' }}>❌ Debe ser 100%</span>
                    }
                  </div>
                </div>
              </div>
            )}

            {/* Botón para finalizar creación de plantilla */}
            {newPlantilla.competenciasSeleccionadas.length > 0 && (
              <div style={{
                marginTop: '2rem',
                padding: '1.5rem',
                backgroundColor: 'white',
                borderRadius: '8px',
                border: '2px solid #3b82f6',
                textAlign: 'center'
              }}>
                <h4 style={{ 
                  color: '#1e293b',
                  marginBottom: '1rem',
                  fontSize: '1.125rem',
                  fontWeight: '600'
                }}>
                  🎯 ¿Listo para Crear la Plantilla?
                </h4>
                
                <div style={{
                  marginBottom: '1rem',
                  color: '#6b7280',
                  fontSize: '0.875rem'
                }}>
                  {newPlantilla.competenciasSeleccionadas.every(id => 
                    newPlantilla.competenciasDetalle[id]?.preguntas?.length > 0
                  ) ? (
                    <span style={{ color: '#16a34a' }}>
                      ✅ Todas las competencias tienen afirmaciones creadas
                    </span>
                  ) : (
                    <span style={{ color: '#dc2626' }}>
                      ⚠️ Algunas competencias aún necesitan afirmaciones
                    </span>
                  )}
                </div>
                
                <div style={{
                  display: 'flex',
                  gap: '1rem',
                  justifyContent: 'center'
                }}>
                  <button
                    onClick={() => {
                      setShowCreatePlantillaModal(false);
                      setNewPlantilla({
                        nombre: '',
                        descripcion: '',
                        competenciasSeleccionadas: [],
                        competenciasDetalle: {},
                        escalaLikert: '',
                        activa: false,
                        porcentajeEvaluacion: 70,
                        porcentajeAutoevaluacion: 30
                      });
                      setSelectedPlantilla(null); // Limpiar plantilla seleccionada
                      setCompetenciaEnEdicion(null); // Cerrar formularios de competencia
                    }}
                    style={{
                      backgroundColor: '#f3f4f6',
                      color: '#374151',
                      border: 'none',
                      padding: '0.75rem 1.5rem',
                      borderRadius: '6px',
                      cursor: 'pointer',
                      fontSize: '14px',
                      fontWeight: '500'
                    }}
                  >
                    ❌ Cancelar
                  </button>
                  
                  <button
                    onClick={handleCreatePlantillaComplete}
                    disabled={
                      !newPlantilla.competenciasSeleccionadas.every(id => 
                        newPlantilla.competenciasDetalle[id]?.preguntas?.length > 0
                      ) ||
                      newPlantilla.porcentajeEvaluacion + newPlantilla.porcentajeAutoevaluacion !== 100
                    }
                    style={{
                      backgroundColor: (
                        newPlantilla.competenciasSeleccionadas.every(id => 
                          newPlantilla.competenciasDetalle[id]?.preguntas?.length > 0
                        ) &&
                        newPlantilla.porcentajeEvaluacion + newPlantilla.porcentajeAutoevaluacion === 100
                      ) ? '#10b981' : '#9ca3af',
                      color: 'white',
                      border: 'none',
                      padding: '0.75rem 2rem',
                      borderRadius: '6px',
                      cursor: (
                        newPlantilla.competenciasSeleccionadas.every(id => 
                          newPlantilla.competenciasDetalle[id]?.preguntas?.length > 0
                        ) &&
                        newPlantilla.porcentajeEvaluacion + newPlantilla.porcentajeAutoevaluacion === 100
                      ) ? 'pointer' : 'not-allowed',
                      fontSize: '14px',
                      fontWeight: '600'
                    }}
                  >
                    {selectedPlantilla ? '🔄 Actualizar Plantilla' : '🚀 Crear Plantilla Completa'}
                  </button>
                </div>
              </div>
            )}
          </div>
        )}

        {activeTab === 'competencias' && (
          <div>
            <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginBottom: '2rem'
            }}>
              <h3 style={{ margin: 0, color: '#1e293b' }}>Gestión de Competencias</h3>
              <button
                onClick={() => {
                  console.log('🆕 CREANDO NUEVA COMPETENCIA - Limpiando selección');
                  setSelectedCompetenciaForForm(null); // Limpiar la competencia seleccionada
                  setSelectedEmpresa(null); // Limpiar la empresa seleccionada
                  setNewCompetencia({ // Limpiar el formulario
                    nombre: '',
                    descripcion: '',
                    categoria: '',
                    tipoCompetencia: 'comportamental',
                    cargoEspecifico: '',
                    requiereLiderazgo: false,
                    esComportamental: false
                  });
                  setShowNewCompetenciaModal(true);
                }}
                style={{
                  backgroundColor: '#3b82f6',
                  color: 'white',
                  border: 'none',
                  padding: '0.75rem 1.5rem',
                  borderRadius: '8px',
                  cursor: 'pointer',
                  fontSize: '14px',
                  fontWeight: '500'
                }}
              >
                ➕ Nueva Competencia
              </button>
            </div>

            {competencias.length === 0 ? (
              <div style={{
                textAlign: 'center',
                padding: '3rem',
                backgroundColor: 'white',
                borderRadius: '8px',
                border: '1px solid #e5e7eb'
              }}>
                <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>🎯</div>
                <h3 style={{ margin: '0 0 0.5rem 0', color: '#374151' }}>
                  No hay competencias definidas
                </h3>
                <p style={{ margin: 0, color: '#6b7280' }}>
                  Define competencias para crear evaluaciones más específicas
                </p>
              </div>
            ) : (
              <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
                gap: '1.5rem'
              }}>
                {competencias.map((competencia) => (
                  <div
                    key={competencia.id}
                    style={{
                      backgroundColor: 'white',
                      border: '1px solid #e5e7eb',
                      borderRadius: '8px',
                      padding: '1.5rem'
                    }}
                  >
                    <div style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'flex-start',
                      marginBottom: '1rem'
                    }}>
                      <h5 style={{ 
                        margin: 0, 
                        color: '#1e293b',
                        fontSize: '1.1rem',
                        fontWeight: '600'
                      }}>
                        {competencia.nombre}
                      </h5>
                      <div style={{ display: 'flex', gap: '0.5rem', flexDirection: 'column', alignItems: 'flex-end' }}>
                        <span style={{
                          backgroundColor: competencia.esComportamental ? '#dbeafe' : 
                                         competencia.esFuncional ? '#dcfce7' : 
                                         competencia.esLiderazgo ? '#fef3c7' : '#f3f4f6',
                          color: competencia.esComportamental ? '#1e40af' : 
                                competencia.esFuncional ? '#166534' : 
                                competencia.esLiderazgo ? '#d97706' : '#6b7280',
                          padding: '0.25rem 0.5rem',
                          borderRadius: '4px',
                          fontSize: '0.75rem',
                          fontWeight: '500'
                        }}>
                          {competencia.esComportamental ? '🧠 Comportamental' : 
                           competencia.esFuncional ? '⚙️ Funcional' : 
                           competencia.esLiderazgo ? '👑 Liderazgo' : 
                           competencia.categoria || 'General'}
                        </span>
                        {competencia.esFuncional && competencia.posicionEspecifica && (
                          <span style={{
                            backgroundColor: '#f0f9ff',
                            color: '#0284c7',
                            padding: '0.25rem 0.5rem',
                            borderRadius: '4px',
                            fontSize: '0.65rem',
                            fontWeight: '500'
                          }}>
                            📋 {cargos.find(c => c.id === competencia.posicionEspecifica)?.nombre || 'Posición específica'}
                          </span>
                        )}
                      </div>
                    </div>
                    <p style={{ 
                      margin: '0 0 1rem 0', 
                      color: '#6b7280',
                      fontSize: '0.875rem'
                    }}>
                      {competencia.descripcion}
                    </p>
                    <div style={{
                      fontSize: '0.75rem',
                      color: '#6b7280',
                      marginBottom: '0.5rem'
                    }}>
                      {competencia.esLiderazgo && (
                        <div style={{ color: '#d97706', fontWeight: '500' }}>
                          🎯 Solo para empleados supervizados con personal a cargo (Liderazgo)
                        </div>
                      )}
                      {competencia.esFuncional && (
                        <div style={{ color: '#166534', fontWeight: '500' }}>
                          🎯 Solo para empleados de la posición específica
                        </div>
                      )}
                      {competencia.esComportamental && (
                        <div style={{ color: '#1e40af', fontWeight: '500' }}>
                          🎯 Aplica a todos los empleados (Comportamental)
                        </div>
                      )}
                    </div>
                    <div style={{
                      display: 'flex',
                      gap: '0.5rem',
                      marginTop: '1rem'
                    }}>
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          console.log('Visualizar competencia:', competencia.id);
                          // Aquí implementarías la lógica para visualizar
                        }}
                        style={{
                          backgroundColor: '#3b82f6',
                          color: 'white',
                          border: 'none',
                          padding: '0.5rem 0.75rem',
                          borderRadius: '6px',
                          cursor: 'pointer',
                          fontSize: '12px',
                          flex: 1
                        }}
                      >
                        👁️ Ver
                      </button>
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          console.log('🔴🔴🔴 BOTÓN EDITAR REAL CLICADO 🔴🔴🔴');
                          console.log('📋 Competencia:', competencia);
                          handleEditCompetencia(competencia, e);
                        }}
                        style={{
                          backgroundColor: '#f59e0b',
                          color: 'white',
                          border: 'none',
                          padding: '0.5rem 0.75rem',
                          borderRadius: '6px',
                          cursor: 'pointer',
                          fontSize: '12px',
                          flex: 1
                        }}
                      >
                        ✏️ Editar
                      </button>
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          if (window.confirm(`¿Estás seguro de eliminar la competencia "${competencia.nombre}"?`)) {
                            console.log('Eliminar competencia:', competencia.id);
                            // Aquí implementarías la lógica para eliminar
                          }
                        }}
                        style={{
                          backgroundColor: '#ef4444',
                          color: 'white',
                          border: 'none',
                          padding: '0.5rem 0.75rem',
                          borderRadius: '6px',
                          cursor: 'pointer',
                          fontSize: '12px',
                          flex: 1
                        }}
                      >
                        🗑️ Eliminar
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}

        {activeTab === 'escalas' && (
          <div>
            <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginBottom: '2rem'
            }}>
              <h3 style={{ margin: 0, color: '#1e293b' }}>Escalas de Calificación Likert</h3>
              <button
                style={{
                  backgroundColor: '#f59e0b',
                  color: 'white',
                  border: 'none',
                  padding: '0.75rem 1.5rem',
                  borderRadius: '8px',
                  cursor: 'pointer',
                  fontSize: '14px',
                  fontWeight: '500'
                }}
              >
                ➕ Nueva Escala
              </button>
            </div>

            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fill, minmax(400px, 1fr))',
              gap: '1.5rem'
            }}>
              {escalasLikert.map((escala) => (
                <div
                  key={escala.id}
                  style={{
                    backgroundColor: 'white',
                    border: '1px solid #e5e7eb',
                    borderRadius: '8px',
                    padding: '1.5rem'
                  }}
                >
                  <h5 style={{ 
                    margin: '0 0 1rem 0', 
                    color: '#1e293b',
                    fontSize: '1.1rem',
                    fontWeight: '600'
                  }}>
                    {escala.nombre}
                  </h5>
                  <p style={{ 
                    margin: '0 0 1rem 0', 
                    color: '#6b7280',
                    fontSize: '0.875rem'
                  }}>
                    Escala de {escala.niveles} niveles
                  </p>
                  <div style={{ marginBottom: '1rem' }}>
                    {escala.etiquetas.map((etiqueta, index) => (
                      <div
                        key={index}
                        style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          padding: '0.5rem',
                          backgroundColor: index % 2 === 0 ? '#f8fafc' : 'white',
                          fontSize: '0.875rem'
                        }}
                      >
                        <span style={{ fontWeight: '500' }}>{etiqueta.valor}</span>
                        <span>{etiqueta.etiqueta}</span>
                      </div>
                    ))}
                  </div>
                  <div style={{
                    display: 'flex',
                    gap: '0.5rem'
                  }}>
                    <button
                      onClick={() => {
                        console.log('Visualizar escala:', escala.id);
                        // Aquí implementarías la lógica para visualizar detalles
                      }}
                      style={{
                        backgroundColor: '#3b82f6',
                        color: 'white',
                        border: 'none',
                        padding: '0.5rem 1rem',
                        borderRadius: '6px',
                        cursor: 'pointer',
                        fontSize: '12px',
                        flex: 1
                      }}
                    >
                      👁️ Ver Detalles
                    </button>
                    <button
                      onClick={() => {
                        console.log('Editar escala:', escala.id);
                        // Aquí implementarías la lógica para editar
                      }}
                      style={{
                        backgroundColor: '#f59e0b',
                        color: 'white',
                        border: 'none',
                        padding: '0.5rem 1rem',
                        borderRadius: '6px',
                        cursor: 'pointer',
                        fontSize: '12px',
                        flex: 1
                      }}
                    >
                      ✏️ Editar
                    </button>
                    <button
                      onClick={() => {
                        if (window.confirm(`¿Estás seguro de eliminar la escala "${escala.nombre}"?`)) {
                          console.log('Eliminar escala:', escala.id);
                          // Aquí implementarías la lógica para eliminar
                        }
                      }}
                      style={{
                        backgroundColor: '#ef4444',
                        color: 'white',
                        border: 'none',
                        padding: '0.5rem 1rem',
                        borderRadius: '6px',
                        cursor: 'pointer',
                        fontSize: '12px',
                        flex: 1
                      }}
                    >
                      🗑️ Eliminar
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {activeTab === 'empresas' && (
          <div>
            <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginBottom: '2rem'
            }}>
              <h3 style={{ margin: 0, color: '#1e293b' }}>Gestión de Empresas y Asignación de Evaluaciones</h3>
            </div>

            {/* Lista de empresas */}
            <div style={{ marginBottom: '2rem' }}>
              <h4 style={{ margin: '0 0 1rem 0', color: '#374151' }}>Seleccionar Empresa</h4>
              <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
                gap: '1rem'
              }}>
                {empresas.map((empresa) => (
                  <div
                    key={empresa.id}
                    onClick={() => handleSelectEmpresa(empresa)}
                    style={{
                      backgroundColor: selectedEmpresa?.id === empresa.id ? '#eff6ff' : 'white',
                      border: selectedEmpresa?.id === empresa.id ? '2px solid #1e40af' : '1px solid #e5e7eb',
                      borderRadius: '8px',
                      padding: '1.5rem',
                      cursor: 'pointer',
                      transition: 'all 0.2s ease'
                    }}
                  >
                    <h5 style={{ 
                      margin: '0 0 0.5rem 0', 
                      color: '#1e293b',
                      fontSize: '1.1rem',
                      fontWeight: '600'
                    }}>
                      🏢 {empresa.nombre}
                    </h5>
                    <p style={{ 
                      margin: '0 0 0.5rem 0', 
                      color: '#6b7280',
                      fontSize: '0.9rem'
                    }}>
                      {empresa.descripcion}
                    </p>
                    <div style={{ fontSize: '0.8rem', color: '#9ca3af' }}>
                      Empleados: {empresa.cantidadEmpleados || 0}
                    </div>
                  </div>
                ))}
              </div>
              
              {empresas.length === 0 && (
                <div style={{
                  textAlign: 'center',
                  padding: '3rem',
                  backgroundColor: '#f9fafb',
                  borderRadius: '8px',
                  border: '1px solid #e5e7eb'
                }}>
                  <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>🏢</div>
                  <h3 style={{ margin: '0 0 0.5rem 0', color: '#374151' }}>
                    No hay empresas registradas
                  </h3>
                  <p style={{ margin: 0, color: '#6b7280' }}>
                    No se encontraron empresas en el sistema.
                  </p>
                </div>
              )}
            </div>

            {/* Plantillas disponibles para asignar */}
            {selectedEmpresa && (
              <div>
                <h4 style={{ margin: '0 0 1rem 0', color: '#374151' }}>
                  Plantillas Disponibles para {selectedEmpresa.nombre}
                </h4>
                <div style={{
                  display: 'grid',
                  gridTemplateColumns: 'repeat(auto-fill, minmax(350px, 1fr))',
                  gap: '1rem'
                }}>
                  {plantillas.filter(p => p.activa).map((plantilla) => (
                    <div
                      key={plantilla.id}
                      style={{
                        backgroundColor: 'white',
                        border: '1px solid #e5e7eb',
                        borderRadius: '8px',
                        padding: '1.5rem'
                      }}
                    >
                      <h5 style={{ 
                        margin: '0 0 1rem 0', 
                        color: '#1e293b',
                        fontSize: '1.1rem',
                        fontWeight: '600'
                      }}>
                        📋 {plantilla.nombre}
                      </h5>
                      <p style={{ 
                        margin: '0 0 1rem 0', 
                        color: '#6b7280',
                        fontSize: '0.9rem'
                      }}>
                        {plantilla.descripcion}
                      </p>
                      <div style={{ fontSize: '0.8rem', color: '#9ca3af', marginBottom: '1rem' }}>
                        Competencias: {plantilla.competenciasSeleccionadas?.length || 0}
                      </div>
                      <button
                        onClick={() => crearEvaluacionesSimple(plantilla)}
                        style={{
                          backgroundColor: '#10b981',
                          color: 'white',
                          border: 'none',
                          padding: '0.75rem 1rem',
                          borderRadius: '6px',
                          cursor: 'pointer',
                          fontSize: '14px',
                          fontWeight: '500',
                          width: '100%'
                        }}
                      >
                        � Evaluar Empleados
                      </button>
                      <button
                        onClick={() => actualizarEvaluacionesExistentes(plantilla)}
                        style={{
                          backgroundColor: '#f59e0b',
                          color: 'white',
                          border: 'none',
                          padding: '0.5rem 0.75rem',
                          borderRadius: '6px',
                          cursor: 'pointer',
                          fontSize: '12px',
                          fontWeight: '500',
                          width: '100%',
                          marginTop: '0.5rem'
                        }}
                      >
                        🔄 Actualizar Existentes
                      </button>
                    </div>
                  ))}
                </div>
                
                {/* Botón de limpieza de evaluaciones (sección separada) - SIEMPRE visible */}
                <div style={{
                  marginTop: '2rem',
                  padding: '1.5rem',
                  backgroundColor: '#fef2f2',
                  border: '1px solid #fca5a5',
                  borderRadius: '8px'
                }}>
                  <h4 style={{ 
                    margin: '0 0 1rem 0', 
                    color: '#991b1b',
                    fontSize: '1.1rem',
                    fontWeight: '600'
                  }}>
                    🚨 Zona de Peligro
                  </h4>
                  <p style={{ 
                    margin: '0 0 1rem 0', 
                    color: '#7f1d1d',
                    fontSize: '0.9rem'
                  }}>
                    Esta acción eliminará TODAS las evaluaciones asignadas de TODAS las empresas. No se puede deshacer.
                  </p>
                  <button
                    onClick={limpiarEvaluacionesAsignadas}
                    style={{
                      backgroundColor: '#dc2626',
                      color: 'white',
                      border: 'none',
                      padding: '0.75rem 1rem',
                      borderRadius: '6px',
                      cursor: 'pointer',
                      fontSize: '14px',
                      fontWeight: '600'
                    }}
                  >
                    🗑️ Limpiar Todas las Evaluaciones
                  </button>
                </div>
                
                {plantillas.filter(p => p.activa).length === 0 && (
                  <div style={{
                    textAlign: 'center',
                    padding: '2rem',
                    backgroundColor: '#fef3c7',
                    borderRadius: '8px',
                    border: '1px solid #fbbf24'
                  }}>
                    <div style={{ fontSize: '2rem', marginBottom: '1rem' }}>⚠️</div>
                    <h3 style={{ margin: '0 0 0.5rem 0', color: '#92400e' }}>
                      No hay plantillas activas
                    </h3>
                    <p style={{ margin: 0, color: '#92400e' }}>
                      Necesitas tener al menos una plantilla activa para asignar evaluaciones.
                    </p>
                  </div>
                )}
              </div>
            )}
          </div>
        )}

        {activeTab === 'activacion_evaluaciones' && (
          <div>
            <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginBottom: '2rem'
            }}>
              <h3 style={{ margin: 0, color: '#1e293b' }}>Activar Evaluaciones</h3>
            </div>

            <div style={{
              backgroundColor: 'white',
              border: '1px solid #e5e7eb',
              borderRadius: '8px',
              padding: '1.5rem',
              marginBottom: '2rem'
            }}>
              <h4 style={{ margin: '0 0 1rem 0', color: '#1e293b' }}>Resumen del Sistema</h4>
              <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))',
                gap: '1rem'
              }}>
                <div style={{
                  textAlign: 'center',
                  padding: '1rem',
                  backgroundColor: '#eff6ff',
                  borderRadius: '8px'
                }}>
                  <div style={{ fontSize: '2rem', fontWeight: 'bold', color: '#1e40af' }}>
                    {plantillas.length}
                  </div>
                  <div style={{ fontSize: '0.875rem', color: '#64748b' }}>Plantillas</div>
                </div>
                <div style={{
                  textAlign: 'center',
                  padding: '1rem',
                  backgroundColor: '#f0fdf4',
                  borderRadius: '8px'
                }}>
                  <div style={{ fontSize: '2rem', fontWeight: 'bold', color: '#16a34a' }}>
                    {competencias.length}
                  </div>
                  <div style={{ fontSize: '0.875rem', color: '#64748b' }}>Competencias</div>
                </div>
                <div style={{
                  textAlign: 'center',
                  padding: '1rem',
                  backgroundColor: '#fef3c7',
                  borderRadius: '8px'
                }}>
                  <div style={{ fontSize: '2rem', fontWeight: 'bold', color: '#d97706' }}>
                    {empleados.length}
                  </div>
                  <div style={{ fontSize: '0.875rem', color: '#64748b' }}>Empleados</div>
                </div>
                <div style={{
                  textAlign: 'center',
                  padding: '1rem',
                  backgroundColor: '#fce7f3',
                  borderRadius: '8px'
                }}>
                  <div style={{ fontSize: '2rem', fontWeight: 'bold', color: '#be185d' }}>
                    {evaluaciones.filter(e => e.estado === 'activa').length}
                  </div>
                  <div style={{ fontSize: '0.875rem', color: '#64748b' }}>Activas</div>
                </div>
              </div>
            </div>

            {evaluaciones.length === 0 ? (
              <div style={{
                textAlign: 'center',
                padding: '3rem',
                backgroundColor: 'white',
                borderRadius: '8px',
                border: '1px solid #e5e7eb'
              }}>
                <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>🚀</div>
                <h3 style={{ margin: '0 0 0.5rem 0', color: '#374151' }}>
                  No hay evaluaciones configuradas
                </h3>
                <p style={{ margin: '0 0 1.5rem 0', color: '#6b7280' }}>
                  Configura y activa evaluaciones para comenzar el proceso de evaluación 180°
                </p>
                <button
                  style={{
                    backgroundColor: '#10b981',
                    color: 'white',
                    border: 'none',
                    padding: '0.75rem 1.5rem',
                    borderRadius: '8px',
                    cursor: 'pointer',
                    fontSize: '14px',
                    fontWeight: '500'
                  }}
                >
                  🚀 Crear Primera Evaluación
                </button>
              </div>
            ) : (
              <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fill, minmax(350px, 1fr))',
                gap: '1.5rem'
              }}>
                {evaluaciones.map((evaluacion) => (
                  <div
                    key={evaluacion.id}
                    style={{
                      backgroundColor: 'white',
                      border: '1px solid #e5e7eb',
                      borderRadius: '8px',
                      padding: '1.5rem'
                    }}
                  >
                    <div style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'flex-start',
                      marginBottom: '1rem'
                    }}>
                      <h5 style={{ 
                        margin: 0, 
                        color: '#1e293b',
                        fontSize: '1.1rem',
                        fontWeight: '600'
                      }}>
                        {evaluacion.nombre}
                      </h5>
                      <span style={{
                        backgroundColor: evaluacion.estado === 'activa' ? '#dcfce7' : '#fee2e2',
                        color: evaluacion.estado === 'activa' ? '#166534' : '#dc2626',
                        padding: '0.25rem 0.5rem',
                        borderRadius: '4px',
                        fontSize: '0.75rem',
                        fontWeight: '500'
                      }}>
                        {evaluacion.estado || 'Inactiva'}
                      </span>
                    </div>
                    <p style={{ 
                      margin: '0 0 1rem 0', 
                      color: '#6b7280',
                      fontSize: '0.875rem'
                    }}>
                      Periodo: {evaluacion.fechaInicio} - {evaluacion.fechaFin}
                    </p>
                    <div style={{
                      display: 'flex',
                      gap: '0.5rem'
                    }}>
                      <button
                        onClick={() => {
                          console.log('Ver detalles evaluación:', evaluacion.id);
                          // Aquí implementarías la lógica para ver detalles
                        }}
                        style={{
                          backgroundColor: '#3b82f6',
                          color: 'white',
                          border: 'none',
                          padding: '0.5rem 0.75rem',
                          borderRadius: '6px',
                          cursor: 'pointer',
                          fontSize: '12px',
                          flex: 1
                        }}
                      >
                        👁️ Ver
                      </button>
                      <button
                        onClick={() => {
                          console.log('Cambiar estado evaluación:', evaluacion.id);
                          // Aquí implementarías la lógica para activar/pausar
                        }}
                        style={{
                          backgroundColor: evaluacion.estado === 'activa' ? '#ef4444' : '#10b981',
                          color: 'white',
                          border: 'none',
                          padding: '0.5rem 0.75rem',
                          borderRadius: '6px',
                          cursor: 'pointer',
                          fontSize: '12px',
                          flex: 1
                        }}
                      >
                        {evaluacion.estado === 'activa' ? '⏸️ Pausar' : '▶️ Activar'}
                      </button>
                      <button
                        onClick={() => {
                          console.log('Editar evaluación:', evaluacion.id);
                          // Aquí implementarías la lógica para editar
                        }}
                        style={{
                          backgroundColor: '#f59e0b',
                          color: 'white',
                          border: 'none',
                          padding: '0.5rem 0.75rem',
                          borderRadius: '6px',
                          cursor: 'pointer',
                          fontSize: '12px',
                          flex: 1
                        }}
                      >
                        ✏️ Editar
                      </button>
                      <button
                        onClick={() => {
                          if (window.confirm(`¿Estás seguro de eliminar la evaluación "${evaluacion.nombre}"?`)) {
                            console.log('Eliminar evaluación:', evaluacion.id);
                            // Aquí implementarías la lógica para eliminar
                          }
                        }}
                        style={{
                          backgroundColor: '#ef4444',
                          color: 'white',
                          border: 'none',
                          padding: '0.5rem 0.75rem',
                          borderRadius: '6px',
                          cursor: 'pointer',
                          fontSize: '12px'
                        }}
                      >
                        🗑️
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}
      </div>

      {/* Modal para Nueva Competencia */}
      {showNewCompetenciaModal && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 1000
        }}>
          <div style={{
            backgroundColor: 'white',
            borderRadius: '12px',
            padding: '2rem',
            width: '90%',
            maxWidth: '500px',
            maxHeight: '90vh',
            overflow: 'auto'
          }}>
            <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginBottom: '1.5rem'
            }}>
              <h3 style={{ margin: 0, color: '#1e293b' }}>
                {selectedCompetenciaForForm ? '✏️ Editar Competencia' : '🎯 Nueva Competencia'}
              </h3>
              <button
                onClick={() => {
                  setShowNewCompetenciaModal(false);
                  setNewCompetencia({
                    nombre: '',
                    descripcion: '',
                    categoria: '',
                    tipoCompetencia: '',
                    cargoEspecifico: '',
                    requiereLiderazgo: false,
                    esComportamental: false
                  });
                }}
                style={{
                  background: 'none',
                  border: 'none',
                  fontSize: '1.5rem',
                  cursor: 'pointer',
                  color: '#6b7280'
                }}
              >
                ✕
              </button>
            </div>

            <div style={{ marginBottom: '1rem' }}>
              <label style={{
                display: 'block',
                marginBottom: '0.5rem',
                fontWeight: '500',
                color: '#374151'
              }}>
                Nombre de la Competencia *
              </label>
              <input
                type="text"
                value={newCompetencia.nombre}
                onChange={(e) => setNewCompetencia({
                  ...newCompetencia,
                  nombre: e.target.value
                })}
                placeholder="Ej: Liderazgo, Comunicación efectiva..."
                style={{
                  width: '100%',
                  padding: '0.75rem',
                  border: '1px solid #d1d5db',
                  borderRadius: '6px',
                  fontSize: '14px'
                }}
              />
            </div>

            <div style={{ marginBottom: '1rem' }}>
              <label style={{
                display: 'block',
                marginBottom: '0.5rem',
                fontWeight: '500',
                color: '#374151'
              }}>
                Descripción *
              </label>
              <textarea
                value={newCompetencia.descripcion}
                onChange={(e) => setNewCompetencia({
                  ...newCompetencia,
                  descripcion: e.target.value
                })}
                placeholder="Describe en qué consiste esta competencia..."
                rows={3}
                style={{
                  width: '100%',
                  padding: '0.75rem',
                  border: '1px solid #d1d5db',
                  borderRadius: '6px',
                  fontSize: '14px',
                  resize: 'vertical'
                }}
              />
            </div>

            <div style={{ marginBottom: '1rem' }}>
              <label style={{
                display: 'block',
                marginBottom: '0.5rem',
                fontWeight: '500',
                color: '#374151'
              }}>
                Tipo de Competencia *
              </label>
              <select
                value={newCompetencia.tipoCompetencia}
                onChange={(e) => setNewCompetencia({
                  ...newCompetencia,
                  tipoCompetencia: e.target.value,
                  cargoEspecifico: e.target.value !== 'funcional' ? '' : newCompetencia.cargoEspecifico
                })}
                style={{
                  width: '100%',
                  padding: '0.75rem',
                  border: '1px solid #d1d5db',
                  borderRadius: '6px',
                  fontSize: '14px'
                }}
              >
                <option value="">Seleccionar tipo de competencia</option>
                <option value="comportamental">🧠 Comportamentales (Todos los empleados)</option>
                <option value="funcional">⚙️ Funcionales (Posición específica)</option>
                <option value="liderazgo">👑 Blandas - Liderazgo (Supervizados con personal a cargo)</option>
              </select>
              {newCompetencia.tipoCompetencia && (
                <div style={{
                  marginTop: '0.5rem',
                  padding: '0.75rem',
                  backgroundColor: '#f8fafc',
                  borderRadius: '6px',
                  fontSize: '0.875rem',
                  color: '#64748b'
                }}>
                  {newCompetencia.tipoCompetencia === 'comportamental' && (
                    <>🧠 <strong>Comportamentales:</strong> Se evalúa a todos los empleados sin excepción.</>
                  )}
                  {newCompetencia.tipoCompetencia === 'funcional' && (
                    <>⚙️ <strong>Funcionales:</strong> Solo se evalúa a empleados de la posición específica que selecciones.</>
                  )}
                  {newCompetencia.tipoCompetencia === 'liderazgo' && (
                    <>👑 <strong>Blandas - Liderazgo:</strong> Solo se evalúa a empleados que son supervizados y además tienen personal a cargo.</>
                  )}
                </div>
              )}
            </div>

            {newCompetencia.tipoCompetencia === 'funcional' && (
              <div style={{ marginBottom: '1rem' }}>
                <label style={{
                  display: 'block',
                  marginBottom: '0.5rem',
                  fontWeight: '500',
                  color: '#374151'
                }}>
                  Posición Específica *
                </label>
                <select
                  value={newCompetencia.cargoEspecifico}
                  onChange={(e) => setNewCompetencia({
                    ...newCompetencia,
                    cargoEspecifico: e.target.value
                  })}
                  style={{
                    width: '100%',
                    padding: '0.75rem',
                    border: '1px solid #d1d5db',
                    borderRadius: '6px',
                    fontSize: '14px'
                  }}
                >
                  <option value="">Seleccionar posición</option>
                  {cargos.map(cargo => (
                    <option key={cargo.id} value={cargo.id}>
                      {cargo.nombre}
                    </option>
                  ))}
                </select>
              </div>
            )}

            {newCompetencia.tipoCompetencia === 'funcional' && (
              <div style={{ marginBottom: '1rem' }}>
                <label style={{
                  display: 'block',
                  marginBottom: '0.5rem',
                  fontWeight: '500',
                  color: '#374151'
                }}>
                  Empresa *
                </label>
                <select
                  value={selectedEmpresa?.id || ''}
                  onChange={(e) => {
                    const empresaSeleccionada = empresas.find(emp => emp.id === e.target.value);
                    setSelectedEmpresa(empresaSeleccionada || null);
                    console.log('🏢 Empresa seleccionada:', empresaSeleccionada);
                  }}
                  style={{
                    width: '100%',
                    padding: '0.75rem',
                    border: '1px solid #d1d5db',
                    borderRadius: '6px',
                    fontSize: '14px',
                    backgroundColor: selectedEmpresa ? '#f0fdf4' : 'white'
                  }}
                >
                  <option value="">Seleccionar empresa</option>
                  {empresas.map(empresa => (
                    <option key={empresa.id} value={empresa.id}>
                      🏢 {empresa.nombre}
                    </option>
                  ))}
                </select>
                {selectedEmpresa && (
                  <div style={{
                    marginTop: '0.5rem',
                    padding: '0.5rem',
                    backgroundColor: '#f0fdf4',
                    borderRadius: '4px',
                    fontSize: '0.875rem',
                    color: '#16a34a',
                    border: '1px solid #bbf7d0'
                  }}>
                    ✅ Empresa seleccionada: <strong>{selectedEmpresa.nombre}</strong>
                  </div>
                )}
                {!selectedEmpresa && (
                  <div style={{
                    marginTop: '0.5rem',
                    padding: '0.5rem',
                    backgroundColor: '#fef3c7',
                    borderRadius: '4px',
                    fontSize: '0.875rem',
                    color: '#92400e'
                  }}>
                    ⚠️ Las competencias funcionales requieren una empresa específica
                  </div>
                )}
              </div>
            )}

            <div style={{ marginBottom: '2rem' }}>
              <label style={{
                display: 'block',
                marginBottom: '0.5rem',
                fontWeight: '500',
                color: '#374151'
              }}>
                Categoría
              </label>
              <select
                value={newCompetencia.categoria}
                onChange={(e) => setNewCompetencia({
                  ...newCompetencia,
                  categoria: e.target.value
                })}
                style={{
                  width: '100%',
                  padding: '0.75rem',
                  border: '1px solid #d1d5db',
                  borderRadius: '6px',
                  fontSize: '14px'
                }}
              >
                <option value="">Seleccionar categoría</option>
                <option value="Técnica">Técnica</option>
                <option value="Comportamental">Comportamental</option>
                <option value="Liderazgo">Liderazgo</option>
                <option value="Comunicación">Comunicación</option>
                <option value="Gestión">Gestión</option>
                <option value="General">General</option>
              </select>
            </div>

            <div style={{
              display: 'flex',
              gap: '1rem',
              justifyContent: 'flex-end'
            }}>
              <button
                onClick={() => {
                  setShowNewCompetenciaModal(false);
                  setNewCompetencia({
                    nombre: '',
                    descripcion: '',
                    categoria: '',
                    tipoCompetencia: '',
                    cargoEspecifico: '',
                    requiereLiderazgo: false,
                    esComportamental: false
                  });
                }}
                style={{
                  backgroundColor: '#6b7280',
                  color: 'white',
                  border: 'none',
                  padding: '0.75rem 1.5rem',
                  borderRadius: '6px',
                  cursor: 'pointer',
                  fontSize: '14px'
                }}
              >
                Cancelar
              </button>
              <button
                onClick={handleCreateCompetencia}
                disabled={!newCompetencia.nombre.trim() || 
                         !newCompetencia.descripcion.trim() || 
                         !newCompetencia.tipoCompetencia ||
                         (newCompetencia.tipoCompetencia === 'funcional' && !newCompetencia.cargoEspecifico)}
                style={{
                  backgroundColor: (!newCompetencia.nombre.trim() || 
                                  !newCompetencia.descripcion.trim() || 
                                  !newCompetencia.tipoCompetencia ||
                                  (newCompetencia.tipoCompetencia === 'funcional' && !newCompetencia.cargoEspecifico))
                    ? '#9ca3af' 
                    : '#3b82f6',
                  color: 'white',
                  border: 'none',
                  padding: '0.75rem 1.5rem',
                  borderRadius: '6px',
                  cursor: (!newCompetencia.nombre.trim() || 
                          !newCompetencia.descripcion.trim() || 
                          !newCompetencia.tipoCompetencia ||
                          (newCompetencia.tipoCompetencia === 'funcional' && !newCompetencia.cargoEspecifico))
                    ? 'not-allowed' 
                    : 'pointer',
                  fontSize: '14px'
                }}
              >
                {selectedCompetenciaForForm ? '🔄 Actualizar Competencia' : '🎯 Crear Competencia'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal para Crear Afirmaciones de Competencia */}
      {showCompetenciaFormModal && selectedCompetenciaForForm && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 1000
        }}>
          <div style={{
            backgroundColor: 'white',
            borderRadius: '12px',
            width: '90%',
            maxWidth: '800px',
            maxHeight: '90vh',
            overflow: 'auto',
            padding: '2rem'
          }}>
            <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginBottom: '2rem'
            }}>
              <h3 style={{ 
                margin: 0, 
                color: '#1e293b',
                fontSize: '1.5rem',
                fontWeight: 'bold'
              }}>
                ➕ Crear Afirmaciones para: {selectedCompetenciaForForm.nombre}
              </h3>
              <button
                onClick={() => setShowCompetenciaFormModal(false)}
                style={{
                  background: 'none',
                  border: 'none',
                  fontSize: '1.5rem',
                  cursor: 'pointer',
                  color: '#6b7280'
                }}
              >
                ✕
              </button>
            </div>

            {/* Información de la competencia */}
            <div style={{
              backgroundColor: '#f8fafc',
              padding: '1rem',
              borderRadius: '8px',
              marginBottom: '2rem',
              border: '1px solid #e2e8f0'
            }}>
              <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '0.5rem',
                marginBottom: '0.5rem'
              }}>
                <span style={{ fontSize: '1.5rem' }}>
                  {selectedCompetenciaForForm.tipo === 'Comportamental' ? '🧠' :
                   selectedCompetenciaForForm.tipo === 'Funcional' ? '⚙️' : '👑'}
                </span>
                <span style={{ fontWeight: '600', color: '#1e293b' }}>
                  {selectedCompetenciaForForm.tipo}
                </span>
              </div>
              <p style={{ color: '#6b7280', margin: '0 0 0.5rem 0' }}>
                {selectedCompetenciaForForm.descripcion}
              </p>
              {selectedCompetenciaForForm.cargo && (
                <p style={{ 
                  color: selectedCompetenciaForForm.tipo === 'Funcional' ? '#f59e0b' : '#8b5cf6',
                  margin: 0,
                  fontSize: '0.875rem',
                  fontWeight: '500'
                }}>
                  🎯 {selectedCompetenciaForForm.cargo}
                </p>
              )}
            </div>

            {/* Formulario para nueva afirmación */}
            <div style={{
              backgroundColor: 'white',
              border: '2px solid #e5e7eb',
              borderRadius: '8px',
              padding: '1.5rem',
              marginBottom: '2rem'
            }}>
              <h4 style={{ 
                color: '#1e293b',
                marginBottom: '1rem',
                fontSize: '1.125rem',
                fontWeight: '600'
              }}>
                ✍️ Nueva Afirmación
              </h4>
              
              <div style={{ marginBottom: '1rem' }}>
                <label style={{ 
                  display: 'block',
                  marginBottom: '0.5rem',
                  fontWeight: '500',
                  color: '#374151'
                }}>
                  👤 Afirmación en Primera Persona (Autoevaluación):
                </label>
                <textarea
                  value={currentPregunta.primera_persona}
                  onChange={(e) => handlePrimeraPersonaChange(e.target.value)}
                  placeholder="Ejemplo: Yo manejo situaciones difíciles con calma y profesionalismo..."
                  style={{
                    width: '100%',
                    minHeight: '80px',
                    padding: '0.75rem',
                    border: '1px solid #d1d5db',
                    borderRadius: '6px',
                    fontSize: '14px',
                    fontFamily: 'inherit',
                    resize: 'vertical'
                  }}
                />
              </div>

              <div style={{ marginBottom: '1rem' }}>
                <label style={{ 
                  display: 'block',
                  marginBottom: '0.5rem',
                  fontWeight: '500',
                  color: '#374151'
                }}>
                  👨‍💼 Afirmación en Tercera Persona (Evaluación del Supervisor):
                  <span style={{ 
                    color: '#10b981',
                    fontSize: '0.875rem',
                    marginLeft: '0.5rem'
                  }}>
                    (Generada automáticamente)
                  </span>
                </label>
                <textarea
                  value={currentPregunta.tercera_persona}
                  onChange={(e) => setCurrentPregunta({
                    ...currentPregunta,
                    tercera_persona: e.target.value,
                    editada: true
                  })}
                  placeholder="Se genera automáticamente, pero puedes editarla..."
                  style={{
                    width: '100%',
                    minHeight: '80px',
                    padding: '0.75rem',
                    border: '1px solid #d1d5db',
                    borderRadius: '6px',
                    fontSize: '14px',
                    fontFamily: 'inherit',
                    resize: 'vertical',
                    backgroundColor: currentPregunta.editada ? 'white' : '#f9fafb'
                  }}
                />
                {!currentPregunta.editada && (
                  <p style={{ 
                    fontSize: '0.75rem',
                    color: '#6b7280',
                    marginTop: '0.25rem',
                    margin: '0.25rem 0 0 0'
                  }}>
                    💡 Esta conversión es automática. Puedes editarla si necesitas ajustes.
                  </p>
                )}
              </div>

              <button
                onClick={addPreguntaToCompetencia}
                disabled={!currentPregunta.primera_persona.trim()}
                style={{
                  backgroundColor: currentPregunta.primera_persona.trim() ? '#10b981' : '#9ca3af',
                  color: 'white',
                  border: 'none',
                  padding: '0.75rem 1.5rem',
                  borderRadius: '6px',
                  cursor: currentPregunta.primera_persona.trim() ? 'pointer' : 'not-allowed',
                  fontSize: '14px',
                  fontWeight: '500',
                  width: '100%'
                }}
              >
                ➕ Agregar Afirmación
              </button>
            </div>

            {/* Lista de afirmaciones existentes */}
            {newPlantilla.competenciasDetalle[selectedCompetenciaForForm.id]?.preguntas?.length > 0 && (
              <div style={{
                backgroundColor: '#f8fafc',
                border: '1px solid #e2e8f0',
                borderRadius: '8px',
                padding: '1.5rem'
              }}>
                <h4 style={{ 
                  color: '#1e293b',
                  marginBottom: '1rem',
                  fontSize: '1.125rem',
                  fontWeight: '600'
                }}>
                  📝 Afirmaciones Creadas ({newPlantilla.competenciasDetalle[selectedCompetenciaForForm.id].preguntas.length})
                </h4>
                
                <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
                  {newPlantilla.competenciasDetalle[selectedCompetenciaForForm.id].preguntas.map((pregunta, index) => (
                    <div 
                      key={index}
                      style={{
                        backgroundColor: 'white',
                        border: '1px solid #e5e7eb',
                        borderRadius: '8px',
                        padding: '1rem',
                        marginBottom: '1rem'
                      }}
                    >
                      <div style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        marginBottom: '0.5rem'
                      }}>
                        <span style={{ 
                          fontWeight: '600',
                          color: '#1e293b',
                          fontSize: '0.875rem'
                        }}>
                          Afirmación #{index + 1}
                        </span>
                        <span style={{
                          backgroundColor: '#3b82f6',
                          color: 'white',
                          padding: '0.25rem 0.5rem',
                          borderRadius: '12px',
                          fontSize: '0.75rem',
                          fontWeight: '500'
                        }}>
                          {pregunta.porcentaje}%
                        </span>
                      </div>
                      
                      <div style={{ marginBottom: '0.75rem' }}>
                        <p style={{ 
                          margin: '0 0 0.25rem 0',
                          fontSize: '0.75rem',
                          color: '#6b7280',
                          fontWeight: '500'
                        }}>
                          👤 Autoevaluación:
                        </p>
                        <p style={{ 
                          margin: 0,
                          fontSize: '0.875rem',
                          color: '#374151'
                        }}>
                          {pregunta.primera_persona}
                        </p>
                      </div>
                      
                      <div>
                        <p style={{ 
                          margin: '0 0 0.25rem 0',
                          fontSize: '0.75rem',
                          color: '#6b7280',
                          fontWeight: '500'
                        }}>
                          👨‍💼 Evaluación del Supervisor:
                        </p>
                        <p style={{ 
                          margin: 0,
                          fontSize: '0.875rem',
                          color: '#374151'
                        }}>
                          {pregunta.tercera_persona}
                        </p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* Botones de acción */}
            <div style={{
              display: 'flex',
              gap: '1rem',
              justifyContent: 'flex-end',
              marginTop: '2rem'
            }}>
              <button
                onClick={() => setShowCompetenciaFormModal(false)}
                style={{
                  backgroundColor: '#f3f4f6',
                  color: '#374151',
                  border: 'none',
                  padding: '0.75rem 1.5rem',
                  borderRadius: '6px',
                  cursor: 'pointer',
                  fontSize: '14px',
                  fontWeight: '500'
                }}
              >
                ✅ Finalizar
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal para Nueva Plantilla */}
      {showNewPlantillaModal && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 1000
        }}>
          <div style={{
            backgroundColor: 'white',
            borderRadius: '12px',
            padding: '2rem',
            width: '90%',
            maxWidth: '600px',
            maxHeight: '90vh',
            overflow: 'auto'
          }}>
            <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginBottom: '1.5rem'
            }}>
              <h3 style={{ margin: 0, color: '#1e293b' }}>
                {selectedPlantilla ? 'Editar Plantilla de Evaluación' : 'Nueva Plantilla de Evaluación'}
              </h3>
              <button
                onClick={() => {
                  setShowNewPlantillaModal(false);
                  setNewPlantilla({
                    nombre: '',
                    descripcion: '',
                    competenciasSeleccionadas: [],
                    escalaLikert: '',
                    activa: false
                  });
                }}
                style={{
                  background: 'none',
                  border: 'none',
                  fontSize: '1.5rem',
                  cursor: 'pointer',
                  color: '#6b7280'
                }}
              >
                ✕
              </button>
            </div>

            <div style={{ marginBottom: '1rem' }}>
              <label style={{
                display: 'block',
                marginBottom: '0.5rem',
                fontWeight: '500',
                color: '#374151'
              }}>
                Nombre de la Plantilla *
              </label>
              <input
                type="text"
                value={newPlantilla.nombre}
                onChange={(e) => setNewPlantilla({
                  ...newPlantilla,
                  nombre: e.target.value
                })}
                placeholder="Ej: Evaluación Anual 2025, Evaluación Trimestral..."
                style={{
                  width: '100%',
                  padding: '0.75rem',
                  border: '1px solid #d1d5db',
                  borderRadius: '6px',
                  fontSize: '14px'
                }}
              />
            </div>

            <div style={{ marginBottom: '1rem' }}>
              <label style={{
                display: 'block',
                marginBottom: '0.5rem',
                fontWeight: '500',
                color: '#374151'
              }}>
                Descripción *
              </label>
              <textarea
                value={newPlantilla.descripcion}
                onChange={(e) => setNewPlantilla({
                  ...newPlantilla,
                  descripcion: e.target.value
                })}
                placeholder="Describe el propósito y alcance de esta plantilla..."
                rows={3}
                style={{
                  width: '100%',
                  padding: '0.75rem',
                  border: '1px solid #d1d5db',
                  borderRadius: '6px',
                  fontSize: '14px',
                  resize: 'vertical'
                }}
              />
            </div>

            <div style={{ marginBottom: '1rem' }}>
              <label style={{
                display: 'block',
                marginBottom: '0.5rem',
                fontWeight: '500',
                color: '#374151'
              }}>
                Escala de Calificación *
              </label>
              <select
                value={newPlantilla.escalaLikert}
                onChange={(e) => setNewPlantilla({
                  ...newPlantilla,
                  escalaLikert: e.target.value
                })}
                style={{
                  width: '100%',
                  padding: '0.75rem',
                  border: '1px solid #d1d5db',
                  borderRadius: '6px',
                  fontSize: '14px'
                }}
              >
                <option value="">Seleccionar escala de calificación</option>
                {escalasLikert.map(escala => (
                  <option key={escala.id} value={escala.id}>
                    {escala.nombre} ({escala.niveles} niveles)
                  </option>
                ))}
              </select>
            </div>

            <div style={{ marginBottom: '1rem' }}>
              <label style={{
                display: 'block',
                marginBottom: '0.5rem',
                fontWeight: '500',
                color: '#374151'
              }}>
                Competencias a Evaluar *
              </label>
              <div style={{
                border: '1px solid #d1d5db',
                borderRadius: '6px',
                maxHeight: '200px',
                overflow: 'auto',
                padding: '0.5rem'
              }}>
                {competencias.length === 0 ? (
                  <div style={{
                    textAlign: 'center',
                    padding: '2rem',
                    color: '#6b7280'
                  }}>
                    <p>No hay competencias disponibles.</p>
                    <p style={{ fontSize: '0.875rem' }}>
                      Crea competencias primero en la pestaña de Competencias.
                    </p>
                  </div>
                ) : (
                  competencias.map(competencia => (
                    <div
                      key={competencia.id}
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        padding: '0.5rem',
                        margin: '0.25rem 0',
                        backgroundColor: newPlantilla.competenciasSeleccionadas.includes(competencia.id) 
                          ? '#eff6ff' : 'transparent',
                        borderRadius: '4px',
                        cursor: 'pointer'
                      }}
                      onClick={() => {
                        const isSelected = newPlantilla.competenciasSeleccionadas.includes(competencia.id);
                        setNewPlantilla({
                          ...newPlantilla,
                          competenciasSeleccionadas: isSelected
                            ? newPlantilla.competenciasSeleccionadas.filter(id => id !== competencia.id)
                            : [...newPlantilla.competenciasSeleccionadas, competencia.id]
                        });
                      }}
                    >
                      <input
                        type="checkbox"
                        checked={newPlantilla.competenciasSeleccionadas.includes(competencia.id)}
                        onChange={() => {}} // Controlado por el onClick del div
                        style={{ marginRight: '0.5rem' }}
                      />
                      <div style={{ flex: 1 }}>
                        <div style={{ fontWeight: '500', fontSize: '0.875rem' }}>
                          {competencia.nombre}
                        </div>
                        <div style={{ 
                          fontSize: '0.75rem', 
                          color: '#6b7280',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '0.5rem'
                        }}>
                          <span style={{
                            backgroundColor: competencia.esComportamental ? '#dbeafe' : 
                                           competencia.esFuncional ? '#dcfce7' : 
                                           competencia.esLiderazgo ? '#fef3c7' : '#f3f4f6',
                            color: competencia.esComportamental ? '#1e40af' : 
                                  competencia.esFuncional ? '#166534' : 
                                  competencia.esLiderazgo ? '#d97706' : '#6b7280',
                            padding: '0.125rem 0.375rem',
                            borderRadius: '3px',
                            fontSize: '0.625rem'
                          }}>
                            {competencia.esComportamental ? '🧠 Comportamental' : 
                             competencia.esFuncional ? '⚙️ Funcional' : 
                             competencia.esLiderazgo ? '👑 Liderazgo' : 'General'}
                          </span>
                          {competencia.descripcion && (
                            <span>{competencia.descripcion.substring(0, 50)}{competencia.descripcion.length > 50 ? '...' : ''}</span>
                          )}
                        </div>
                      </div>
                    </div>
                  ))
                )}
              </div>
              <div style={{
                marginTop: '0.5rem',
                fontSize: '0.75rem',
                color: '#6b7280'
              }}>
                {newPlantilla.competenciasSeleccionadas.length} competencia(s) seleccionada(s)
              </div>
            </div>

            <div style={{ marginBottom: '2rem' }}>
              <label style={{
                display: 'flex',
                alignItems: 'center',
                cursor: 'pointer',
                fontSize: '0.875rem',
                color: '#374151'
              }}>
                <input
                  type="checkbox"
                  checked={newPlantilla.activa}
                  onChange={(e) => setNewPlantilla({
                    ...newPlantilla,
                    activa: e.target.checked
                  })}
                  style={{ marginRight: '0.5rem' }}
                />
                Activar plantilla inmediatamente
              </label>
              <div style={{
                marginTop: '0.5rem',
                fontSize: '0.75rem',
                color: '#6b7280'
              }}>
                Si está marcado, la plantilla estará disponible para crear evaluaciones inmediatamente.
              </div>
            </div>

            <div style={{
              display: 'flex',
              gap: '1rem',
              justifyContent: 'flex-end'
            }}>
              <button
                onClick={() => {
                  setShowNewPlantillaModal(false);
                  setNewPlantilla({
                    nombre: '',
                    descripcion: '',
                    competenciasSeleccionadas: [],
                    escalaLikert: '',
                    activa: false
                  });
                }}
                style={{
                  backgroundColor: '#6b7280',
                  color: 'white',
                  border: 'none',
                  padding: '0.75rem 1.5rem',
                  borderRadius: '6px',
                  cursor: 'pointer',
                  fontSize: '14px'
                }}
              >
                Cancelar
              </button>
              <button
                onClick={handleCreatePlantilla}
                disabled={!newPlantilla.nombre.trim() || 
                         !newPlantilla.descripcion.trim() || 
                         newPlantilla.competenciasSeleccionadas.length === 0 ||
                         !newPlantilla.escalaLikert}
                style={{
                  backgroundColor: (!newPlantilla.nombre.trim() || 
                                  !newPlantilla.descripcion.trim() || 
                                  newPlantilla.competenciasSeleccionadas.length === 0 ||
                                  !newPlantilla.escalaLikert)
                    ? '#9ca3af' 
                    : '#10b981',
                  color: 'white',
                  border: 'none',
                  padding: '0.75rem 1.5rem',
                  borderRadius: '6px',
                  cursor: (!newPlantilla.nombre.trim() || 
                          !newPlantilla.descripcion.trim() || 
                          newPlantilla.competenciasSeleccionadas.length === 0 ||
                          !newPlantilla.escalaLikert)
                    ? 'not-allowed' 
                    : 'pointer',
                  fontSize: '14px'
                }}
              >
                📋 Crear Plantilla
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal para Ver Plantilla */}
      {showViewPlantillaModal && selectedPlantilla && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 1000
        }}>
          <div style={{
            backgroundColor: 'white',
            borderRadius: '12px',
            padding: '2rem',
            width: '90%',
            maxWidth: '600px',
            maxHeight: '90vh',
            overflow: 'auto'
          }}>
            <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginBottom: '1.5rem'
            }}>
              <h3 style={{ margin: 0, color: '#1e293b' }}>Detalles de la Plantilla</h3>
              <button
                onClick={() => {
                  setShowViewPlantillaModal(false);
                  setSelectedPlantilla(null);
                }}
                style={{
                  background: 'none',
                  border: 'none',
                  fontSize: '1.5rem',
                  cursor: 'pointer',
                  color: '#6b7280'
                }}
              >
                ✕
              </button>
            </div>

            <div style={{ marginBottom: '1rem' }}>
              <label style={{
                display: 'block',
                marginBottom: '0.5rem',
                fontWeight: '500',
                color: '#374151'
              }}>
                Nombre
              </label>
              <div style={{
                padding: '0.75rem',
                backgroundColor: '#f8fafc',
                border: '1px solid #e5e7eb',
                borderRadius: '6px',
                fontSize: '14px'
              }}>
                {selectedPlantilla.nombre}
              </div>
            </div>

            <div style={{ marginBottom: '1rem' }}>
              <label style={{
                display: 'block',
                marginBottom: '0.5rem',
                fontWeight: '500',
                color: '#374151'
              }}>
                Descripción
              </label>
              <div style={{
                padding: '0.75rem',
                backgroundColor: '#f8fafc',
                border: '1px solid #e5e7eb',
                borderRadius: '6px',
                fontSize: '14px',
                minHeight: '80px'
              }}>
                {selectedPlantilla.descripcion}
              </div>
            </div>

            <div style={{ marginBottom: '1rem' }}>
              <label style={{
                display: 'block',
                marginBottom: '0.5rem',
                fontWeight: '500',
                color: '#374151'
              }}>
                Escala de Calificación
              </label>
              <div style={{
                padding: '0.75rem',
                backgroundColor: '#f8fafc',
                border: '1px solid #e5e7eb',
                borderRadius: '6px',
                fontSize: '14px'
              }}>
                {escalasLikert.find(e => e.id === selectedPlantilla.escalaLikert)?.nombre || 'No especificada'}
              </div>
            </div>

            <div style={{ marginBottom: '1rem' }}>
              <label style={{
                display: 'block',
                marginBottom: '0.5rem',
                fontWeight: '500',
                color: '#374151'
              }}>
                Estado
              </label>
              <div style={{
                padding: '0.75rem',
                backgroundColor: '#f8fafc',
                border: '1px solid #e5e7eb',
                borderRadius: '6px',
                fontSize: '14px'
              }}>
                <span style={{
                  backgroundColor: selectedPlantilla.activa ? '#dcfce7' : '#fee2e2',
                  color: selectedPlantilla.activa ? '#166534' : '#dc2626',
                  padding: '0.25rem 0.5rem',
                  borderRadius: '4px',
                  fontSize: '0.75rem',
                  fontWeight: '500'
                }}>
                  {selectedPlantilla.activa ? 'Activa' : 'Inactiva'}
                </span>
              </div>
            </div>

            <div style={{ marginBottom: '1rem' }}>
              <label style={{
                display: 'block',
                marginBottom: '0.5rem',
                fontWeight: '500',
                color: '#374151'
              }}>
                Competencias Incluidas
              </label>
              <div style={{
                border: '1px solid #e5e7eb',
                borderRadius: '6px',
                maxHeight: '200px',
                overflow: 'auto',
                backgroundColor: '#f8fafc'
              }}>
                {selectedPlantilla.competenciasSeleccionadas && selectedPlantilla.competenciasSeleccionadas.length > 0 ? (
                  selectedPlantilla.competenciasSeleccionadas.map(competenciaId => {
                    const competencia = competencias.find(c => c.id === competenciaId);
                    return competencia ? (
                      <div
                        key={competencia.id}
                        style={{
                          padding: '0.75rem',
                          borderBottom: '1px solid #e5e7eb'
                        }}
                      >
                        <div style={{ fontWeight: '500', fontSize: '0.875rem', marginBottom: '0.25rem' }}>
                          {competencia.nombre}
                        </div>
                        <div style={{ 
                          fontSize: '0.75rem', 
                          color: '#6b7280',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '0.5rem'
                        }}>
                          <span style={{
                            backgroundColor: competencia.esComportamental ? '#dbeafe' : 
                                           competencia.esFuncional ? '#dcfce7' : 
                                           competencia.esLiderazgo ? '#fef3c7' : '#f3f4f6',
                            color: competencia.esComportamental ? '#1e40af' : 
                                  competencia.esFuncional ? '#166534' : 
                                  competencia.esLiderazgo ? '#d97706' : '#6b7280',
                            padding: '0.125rem 0.375rem',
                            borderRadius: '3px',
                            fontSize: '0.625rem'
                          }}>
                            {competencia.esComportamental ? '🧠 Comportamental' : 
                             competencia.esFuncional ? '⚙️ Funcional' : 
                             competencia.esLiderazgo ? '👑 Liderazgo' : 'General'}
                          </span>
                          {competencia.descripcion}
                        </div>
                      </div>
                    ) : null;
                  })
                ) : (
                  <div style={{ padding: '1rem', textAlign: 'center', color: '#6b7280' }}>
                    No hay competencias seleccionadas
                  </div>
                )}
              </div>
            </div>

            <div style={{ marginBottom: '1rem', fontSize: '0.75rem', color: '#6b7280' }}>
              <div>Creada: {selectedPlantilla.fechaCreacion?.seconds ? 
                new Date(selectedPlantilla.fechaCreacion.seconds * 1000).toLocaleDateString() : 'No disponible'}</div>
              {selectedPlantilla.fechaModificacion && (
                <div>Última modificación: {new Date(selectedPlantilla.fechaModificacion.seconds * 1000).toLocaleDateString()}</div>
              )}
            </div>

            <div style={{
              display: 'flex',
              gap: '1rem',
              justifyContent: 'flex-end'
            }}>
              <button
                onClick={() => {
                  setShowViewPlantillaModal(false);
                  handleEditPlantilla(selectedPlantilla);
                }}
                style={{
                  backgroundColor: '#f59e0b',
                  color: 'white',
                  border: 'none',
                  padding: '0.75rem 1.5rem',
                  borderRadius: '6px',
                  cursor: 'pointer',
                  fontSize: '14px'
                }}
              >
                ✏️ Editar
              </button>
              <button
                onClick={() => {
                  setShowViewPlantillaModal(false);
                  setSelectedPlantilla(null);
                }}
                style={{
                  backgroundColor: '#6b7280',
                  color: 'white',
                  border: 'none',
                  padding: '0.75rem 1.5rem',
                  borderRadius: '6px',
                  cursor: 'pointer',
                  fontSize: '14px'
                }}
              >
                Cerrar
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal para Editar Plantilla */}
      {showEditPlantillaModal && selectedPlantilla && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 1000
        }}>
          <div style={{
            backgroundColor: 'white',
            borderRadius: '12px',
            padding: '2rem',
            width: '90%',
            maxWidth: '600px',
            maxHeight: '90vh',
            overflow: 'auto'
          }}>
            <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginBottom: '1.5rem'
            }}>
              <h3 style={{ margin: 0, color: '#1e293b' }}>Editar Plantilla de Evaluación</h3>
              <button
                onClick={() => {
                  setShowEditPlantillaModal(false);
                  setSelectedPlantilla(null);
                }}
                style={{
                  background: 'none',
                  border: 'none',
                  fontSize: '1.5rem',
                  cursor: 'pointer',
                  color: '#6b7280'
                }}
              >
                ✕
              </button>
            </div>

            <div style={{ marginBottom: '1rem' }}>
              <label style={{
                display: 'block',
                marginBottom: '0.5rem',
                fontWeight: '500',
                color: '#374151'
              }}>
                Nombre de la Plantilla *
              </label>
              <input
                type="text"
                value={editPlantilla.nombre}
                onChange={(e) => setEditPlantilla({
                  ...editPlantilla,
                  nombre: e.target.value
                })}
                placeholder="Ej: Evaluación Anual 2025, Evaluación Trimestral..."
                style={{
                  width: '100%',
                  padding: '0.75rem',
                  border: '1px solid #d1d5db',
                  borderRadius: '6px',
                  fontSize: '14px'
                }}
              />
            </div>

            <div style={{ marginBottom: '1rem' }}>
              <label style={{
                display: 'block',
                marginBottom: '0.5rem',
                fontWeight: '500',
                color: '#374151'
              }}>
                Descripción *
              </label>
              <textarea
                value={editPlantilla.descripcion}
                onChange={(e) => setEditPlantilla({
                  ...editPlantilla,
                  descripcion: e.target.value
                })}
                placeholder="Describe el propósito y alcance de esta plantilla..."
                rows={3}
                style={{
                  width: '100%',
                  padding: '0.75rem',
                  border: '1px solid #d1d5db',
                  borderRadius: '6px',
                  fontSize: '14px',
                  resize: 'vertical'
                }}
              />
            </div>

            <div style={{ marginBottom: '1rem' }}>
              <label style={{
                display: 'block',
                marginBottom: '0.5rem',
                fontWeight: '500',
                color: '#374151'
              }}>
                Escala de Calificación *
              </label>
              <select
                value={editPlantilla.escalaLikert}
                onChange={(e) => setEditPlantilla({
                  ...editPlantilla,
                  escalaLikert: e.target.value
                })}
                style={{
                  width: '100%',
                  padding: '0.75rem',
                  border: '1px solid #d1d5db',
                  borderRadius: '6px',
                  fontSize: '14px'
                }}
              >
                <option value="">Seleccionar escala de calificación</option>
                {escalasLikert.map(escala => (
                  <option key={escala.id} value={escala.id}>
                    {escala.nombre} ({escala.niveles} niveles)
                  </option>
                ))}
              </select>
            </div>

            <div style={{ marginBottom: '1rem' }}>
              <label style={{
                display: 'block',
                marginBottom: '0.5rem',
                fontWeight: '500',
                color: '#374151'
              }}>
                Competencias a Evaluar *
              </label>
              <div style={{
                border: '1px solid #d1d5db',
                borderRadius: '6px',
                maxHeight: '200px',
                overflow: 'auto',
                padding: '0.5rem'
              }}>
                {competencias.length === 0 ? (
                  <div style={{
                    textAlign: 'center',
                    padding: '2rem',
                    color: '#6b7280'
                  }}>
                    <p>No hay competencias disponibles.</p>
                    <p style={{ fontSize: '0.875rem' }}>
                      Crea competencias primero en la pestaña de Competencias.
                    </p>
                  </div>
                ) : (
                  competencias.map(competencia => (
                    <div
                      key={competencia.id}
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        padding: '0.5rem',
                        margin: '0.25rem 0',
                        backgroundColor: editPlantilla.competenciasSeleccionadas.includes(competencia.id) 
                          ? '#eff6ff' : 'transparent',
                        borderRadius: '4px',
                        cursor: 'pointer'
                      }}
                      onClick={() => {
                        const isSelected = editPlantilla.competenciasSeleccionadas.includes(competencia.id);
                        setEditPlantilla({
                          ...editPlantilla,
                          competenciasSeleccionadas: isSelected
                            ? editPlantilla.competenciasSeleccionadas.filter(id => id !== competencia.id)
                            : [...editPlantilla.competenciasSeleccionadas, competencia.id]
                        });
                      }}
                    >
                      <input
                        type="checkbox"
                        checked={editPlantilla.competenciasSeleccionadas.includes(competencia.id)}
                        onChange={() => {}} // Controlado por el onClick del div
                        style={{ marginRight: '0.5rem' }}
                      />
                      <div style={{ flex: 1 }}>
                        <div style={{ fontWeight: '500', fontSize: '0.875rem' }}>
                          {competencia.nombre}
                        </div>
                        <div style={{ 
                          fontSize: '0.75rem', 
                          color: '#6b7280',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '0.5rem'
                        }}>
                          <span style={{
                            backgroundColor: competencia.esComportamental ? '#dbeafe' : 
                                           competencia.esFuncional ? '#dcfce7' : 
                                           competencia.esLiderazgo ? '#fef3c7' : '#f3f4f6',
                            color: competencia.esComportamental ? '#1e40af' : 
                                  competencia.esFuncional ? '#166534' : 
                                  competencia.esLiderazgo ? '#d97706' : '#6b7280',
                            padding: '0.125rem 0.375rem',
                            borderRadius: '3px',
                            fontSize: '0.625rem'
                          }}>
                            {competencia.esComportamental ? '🧠 Comportamental' : 
                             competencia.esFuncional ? '⚙️ Funcional' : 
                             competencia.esLiderazgo ? '👑 Liderazgo' : 'General'}
                          </span>
                          {competencia.descripcion && (
                            <span>{competencia.descripcion.substring(0, 50)}{competencia.descripcion.length > 50 ? '...' : ''}</span>
                          )}
                        </div>
                      </div>
                    </div>
                  ))
                )}
              </div>
              <div style={{
                marginTop: '0.5rem',
                fontSize: '0.75rem',
                color: '#6b7280'
              }}>
                {editPlantilla.competenciasSeleccionadas.length} competencia(s) seleccionada(s)
              </div>
            </div>

            <div style={{ marginBottom: '2rem' }}>
              <label style={{
                display: 'flex',
                alignItems: 'center',
                cursor: 'pointer',
                fontSize: '0.875rem',
                color: '#374151'
              }}>
                <input
                  type="checkbox"
                  checked={editPlantilla.activa}
                  onChange={(e) => setEditPlantilla({
                    ...editPlantilla,
                    activa: e.target.checked
                  })}
                  style={{ marginRight: '0.5rem' }}
                />
                Plantilla activa
              </label>
              <div style={{
                marginTop: '0.5rem',
                fontSize: '0.75rem',
                color: '#6b7280'
              }}>
                Las plantillas activas están disponibles para crear evaluaciones.
              </div>
            </div>

            <div style={{
              display: 'flex',
              gap: '1rem',
              justifyContent: 'flex-end'
            }}>
              <button
                onClick={() => {
                  setShowEditPlantillaModal(false);
                  setSelectedPlantilla(null);
                }}
                style={{
                  backgroundColor: '#6b7280',
                  color: 'white',
                  border: 'none',
                  padding: '0.75rem 1.5rem',
                  borderRadius: '6px',
                  cursor: 'pointer',
                  fontSize: '14px'
                }}
              >
                Cancelar
              </button>
              <button
                onClick={handleUpdatePlantilla}
                disabled={!editPlantilla.nombre.trim() || 
                         !editPlantilla.descripcion.trim() || 
                         editPlantilla.competenciasSeleccionadas.length === 0 ||
                         !editPlantilla.escalaLikert}
                style={{
                  backgroundColor: (!editPlantilla.nombre.trim() || 
                                  !editPlantilla.descripcion.trim() || 
                                  editPlantilla.competenciasSeleccionadas.length === 0 ||
                                  !editPlantilla.escalaLikert)
                    ? '#9ca3af' 
                    : '#f59e0b',
                  color: 'white',
                  border: 'none',
                  padding: '0.75rem 1.5rem',
                  borderRadius: '6px',
                  cursor: (!editPlantilla.nombre.trim() || 
                          !editPlantilla.descripcion.trim() || 
                          editPlantilla.competenciasSeleccionadas.length === 0 ||
                          !editPlantilla.escalaLikert)
                    ? 'not-allowed' 
                    : 'pointer',
                  fontSize: '14px'
                }}
              >
                💾 Guardar Cambios
              </button>
            </div>
          </div>
        </div>
      )}

        {/* Tab de Debug */}
        {activeTab === 'debug' && (
          <div>
            <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginBottom: '2rem'
            }}>
              <h3 style={{ margin: 0, color: '#1e293b' }}>Herramientas de Debug</h3>
            </div>

            <div style={{
              backgroundColor: 'white',
              border: '1px solid #e5e7eb',
              borderRadius: '8px',
              padding: '1.5rem',
              marginBottom: '2rem'
            }}>
              <h4 style={{ margin: '0 0 1rem 0', color: '#1e293b' }}>Corrección de Evaluaciones</h4>
              <p style={{ color: '#6b7280', marginBottom: '1rem' }}>
                Esta herramienta corrige evaluaciones que no tienen el campo evaluadorCedula configurado correctamente.
                Esto es necesario para que los supervisores puedan ver las evaluaciones que deben completar para sus subordinados.
              </p>
              
              <button
                onClick={corregirEvaluadorCedulaFaltantes}
                style={{
                  backgroundColor: '#dc2626',
                  color: 'white',
                  border: 'none',
                  padding: '0.75rem 1.5rem',
                  borderRadius: '8px',
                  cursor: 'pointer',
                  fontSize: '14px',
                  fontWeight: '500',
                  marginRight: '1rem'
                }}
              >
                🔧 Corregir EvaluadorCedula Faltantes
              </button>
              
              <div style={{
                marginTop: '1rem',
                padding: '1rem',
                backgroundColor: '#fef3c7',
                borderRadius: '8px',
                fontSize: '0.875rem',
                color: '#92400e'
              }}>
                <strong>⚠️ Precaución:</strong> Esta operación modificará registros en la base de datos. 
                Asegúrate de que las relaciones supervisor-subordinado estén correctamente configuradas en la colección de empleados.
              </div>
            </div>

            <div style={{
              backgroundColor: 'white',
              border: '1px solid #e5e7eb',
              borderRadius: '8px',
              padding: '1.5rem',
              marginBottom: '2rem'
            }}> {/* eslint-disable-line */}
              <h4 style={{ margin: '0 0 1rem 0', color: '#1e293b' }}>Crear Evaluaciones de Prueba</h4>
              <p style={{ color: '#6b7280', marginBottom: '1rem' }}>
                Crea evaluaciones de prueba usando las plantillas y empleados existentes. 
                Esto es útil para probar el sistema de evaluaciones.
              </p>
              
              <button
                onClick={crearEvaluacionesPrueba}
                style={{
                  backgroundColor: '#16a34a',
                  color: 'white',
                  border: 'none',
                  padding: '0.75rem 1.5rem',
                  borderRadius: '8px',
                  cursor: 'pointer',
                  fontSize: '14px',
                  fontWeight: '500',
                  marginRight: '1rem'
                }}
              >
                🚀 Crear Evaluaciones de Prueba
              </button>
              
              <div style={{
                marginTop: '1rem',
                padding: '1rem',
                backgroundColor: '#dcfce7',
                borderRadius: '8px',
                fontSize: '0.875rem',
                color: '#166534'
              }}>
                <strong>ℹ️ Información:</strong> Se crearán autoevaluaciones y evaluaciones por supervisor 
                para los primeros empleados usando la primera plantilla disponible.
              </div>
            </div>

            <div style={{
              backgroundColor: 'white',
              border: '1px solid #e5e7eb',
              borderRadius: '8px',
              padding: '1.5rem',
              marginBottom: '2rem'
            }}>
              <h4 style={{ margin: '0 0 1rem 0', color: '#1e293b' }}>Información del Sistema</h4>
              <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
                gap: '1rem'
              }}>
                <div style={{
                  textAlign: 'center',
                  padding: '1rem',
                  backgroundColor: '#eff6ff',
                  borderRadius: '8px'
                }}>
                  <div style={{ fontSize: '2rem', fontWeight: 'bold', color: '#1e40af' }}>
                    {empleados.length}
                  </div>
                  <div style={{ fontSize: '0.875rem', color: '#64748b' }}>Empleados</div>
                </div>
                <div style={{
                  textAlign: 'center',
                  padding: '1rem',
                  backgroundColor: '#f0fdf4',
                  borderRadius: '8px'
                }}>
                  <div style={{ fontSize: '2rem', fontWeight: 'bold', color: '#16a34a' }}>
                    {evaluaciones.length}
                  </div>
                  <div style={{ fontSize: '0.875rem', color: '#64748b' }}>Evaluaciones Asignadas</div>
                </div>
              </div>
            </div>
          </div>
        )}

      {/* Modal de Asignación de Evaluación */}
      {showAsignacionModal && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 1000
        }}>
          <div style={{
            backgroundColor: 'white',
            borderRadius: '12px',
            padding: '2rem',
            maxWidth: '600px',
            width: '90%',
            maxHeight: '90vh',
            overflowY: 'auto',
            boxShadow: '0 20px 40px rgba(0,0,0,0.15)'
          }}>
            <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginBottom: '1.5rem',
              paddingBottom: '1rem',
              borderBottom: '2px solid #e5e7eb'
            }}>
              <h3 style={{ margin: 0, color: '#1e293b', fontSize: '1.5rem' }}>
                🚀 Asignar Evaluación
              </h3>
              <button
                onClick={() => setShowAsignacionModal(false)}
                style={{
                  background: 'none',
                  border: 'none',
                  fontSize: '24px',
                  cursor: 'pointer',
                  color: '#6b7280',
                  padding: '0',
                  width: '30px',
                  height: '30px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
              >
                ✕
              </button>
            </div>

            <form onSubmit={(e) => {
              e.preventDefault();
              const formData = new FormData(e.target);
              
              const evaluacionData = {
                plantillaId: asignacionData.plantillaId,
                nombre: formData.get('nombre'),
                descripcion: formData.get('descripcion'),
                tipoAsignacion: formData.get('tipoAsignacion'),
                fechaInicio: formData.get('fechaInicio'),
                fechaFin: formData.get('fechaFin'),
                empresaId: asignacionData.empresaId,
                empresaNombre: asignacionData.empresaNombre,
                departamentoId: formData.get('departamentoId') || '',
                departamentoNombre: '',
                empleadosSeleccionados: asignacionData.empleadosSeleccionados || []
              };

              // Validaciones básicas
              if (!evaluacionData.nombre.trim()) {
                alert('Por favor, ingresa el nombre de la evaluación');
                return;
              }
              
              if (!evaluacionData.descripcion.trim()) {
                alert('Por favor, ingresa la descripción de la evaluación');
                return;
              }
              
              if (!evaluacionData.fechaInicio || !evaluacionData.fechaFin) {
                alert('Por favor, selecciona las fechas de inicio y fin');
                return;
              }
              
              if (new Date(evaluacionData.fechaInicio) >= new Date(evaluacionData.fechaFin)) {
                alert('La fecha de inicio debe ser anterior a la fecha de fin');
                return;
              }

              // Simplemente usar la plantilla del modal para crear evaluaciones
              const plantillaParaEvaluacion = {
                id: asignacionData.plantillaId,
                nombre: asignacionData.plantillaNombre,
                competenciasDetalle: {}, // Se obtendrá de la base de datos
                escalaLikert: 'escala_5_puntos'
              };
              
              crearEvaluacionesSimple(plantillaParaEvaluacion);
              setShowAsignacionModal(false);
            }}>
              
              {/* Información de la plantilla */}
              <div style={{
                backgroundColor: '#f8fafc',
                padding: '1rem',
                borderRadius: '8px',
                marginBottom: '1.5rem',
                border: '1px solid #e2e8f0'
              }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '0.5rem' }}>
                  <span style={{ fontWeight: '600', color: '#6b7280' }}>Plantilla:</span>
                  <span style={{ color: '#374151' }}>{asignacionData.plantillaNombre}</span>
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <span style={{ fontWeight: '600', color: '#6b7280' }}>Empresa:</span>
                  <span style={{ color: '#374151' }}>{asignacionData.empresaNombre}</span>
                </div>
              </div>

              {/* Nombre de la evaluación */}
              <div style={{ marginBottom: '1.5rem' }}>
                <label style={{
                  display: 'block',
                  marginBottom: '0.5rem',
                  fontWeight: '600',
                  color: '#374151'
                }}>
                  Nombre de la Evaluación:
                </label>
                <input
                  type="text"
                  name="nombre"
                  defaultValue={asignacionData.nombre}
                  required
                  style={{
                    width: '100%',
                    padding: '0.75rem',
                    border: '2px solid #e5e7eb',
                    borderRadius: '8px',
                    fontSize: '14px',
                    boxSizing: 'border-box'
                  }}
                />
              </div>

              {/* Descripción */}
              <div style={{ marginBottom: '1.5rem' }}>
                <label style={{
                  display: 'block',
                  marginBottom: '0.5rem',
                  fontWeight: '600',
                  color: '#374151'
                }}>
                  Descripción:
                </label>
                <textarea
                  name="descripcion"
                  defaultValue={asignacionData.descripcion}
                  required
                  style={{
                    width: '100%',
                    padding: '0.75rem',
                    border: '2px solid #e5e7eb',
                    borderRadius: '8px',
                    fontSize: '14px',
                    minHeight: '80px',
                    resize: 'vertical',
                    boxSizing: 'border-box'
                  }}
                />
              </div>

              {/* Tipo de asignación */}
              <div style={{ marginBottom: '1.5rem' }}>
                <label style={{
                  display: 'block',
                  marginBottom: '0.5rem',
                  fontWeight: '600',
                  color: '#374151'
                }}>
                  Tipo de Asignación:
                </label>
                <select
                  name="tipoAsignacion"
                  defaultValue={asignacionData.tipoAsignacion}
                  onChange={(e) => {
                    setAsignacionData({
                      ...asignacionData,
                      tipoAsignacion: e.target.value
                    });
                  }}
                  style={{
                    width: '100%',
                    padding: '0.75rem',
                    border: '2px solid #e5e7eb',
                    borderRadius: '8px',
                    fontSize: '14px',
                    boxSizing: 'border-box'
                  }}
                >
                  <option value="empresa">Toda la empresa</option>
                  <option value="departamento">Por departamento</option>
                  <option value="empleados">Empleados específicos</option>
                </select>
              </div>

              {/* Selector de departamento (solo si es tipo departamento) */}
              {asignacionData.tipoAsignacion === 'departamento' && (
                <div style={{ marginBottom: '1.5rem' }}>
                  <label style={{
                    display: 'block',
                    marginBottom: '0.5rem',
                    fontWeight: '600',
                    color: '#374151'
                  }}>
                    Seleccionar Departamento:
                  </label>
                  <select
                    name="departamentoId"
                    required
                    style={{
                      width: '100%',
                      padding: '0.75rem',
                      border: '2px solid #e5e7eb',
                      borderRadius: '8px',
                      fontSize: '14px',
                      boxSizing: 'border-box'
                    }}
                  >
                    <option value="">Selecciona un departamento</option>
                    {departamentos
                      .filter(dept => dept.empresaId === asignacionData.empresaId)
                      .map(dept => (
                      <option key={dept.id} value={dept.id}>
                        {dept.nombre}
                      </option>
                    ))}
                  </select>
                </div>
              )}

              {/* Empleados específicos (solo si es tipo empleados) */}
              {asignacionData.tipoAsignacion === 'empleados' && (
                <div style={{ marginBottom: '1.5rem' }}>
                  <label style={{
                    display: 'block',
                    marginBottom: '0.5rem',
                    fontWeight: '600',
                    color: '#374151'
                  }}>
                    Seleccionar Empleados:
                  </label>
                  <div style={{
                    maxHeight: '200px',
                    overflowY: 'auto',
                    border: '2px solid #e5e7eb',
                    borderRadius: '8px',
                    padding: '0.75rem'
                  }}>
                    {empleados
                      .filter(emp => emp.empresa_id === asignacionData.empresaId)
                      .map(emp => (
                      <label key={emp.id} style={{
                        display: 'block',
                        marginBottom: '0.5rem',
                        cursor: 'pointer'
                      }}>
                        <input
                          type="checkbox"
                          value={emp.id}
                          style={{ marginRight: '0.5rem' }}
                          onChange={(e) => {
                            const empleadosSeleccionados = asignacionData.empleadosSeleccionados || [];
                            if (e.target.checked) {
                              setAsignacionData({
                                ...asignacionData,
                                empleadosSeleccionados: [...empleadosSeleccionados, emp]
                              });
                            } else {
                              setAsignacionData({
                                ...asignacionData,
                                empleadosSeleccionados: empleadosSeleccionados.filter(e => e.id !== emp.id)
                              });
                            }
                          }}
                        />
                        {emp.nombres || emp.nombre} {emp.apellidos || ''} - {emp.email || ''}
                      </label>
                    ))}
                  </div>
                </div>
              )}

              {/* Fechas */}
              <div style={{
                display: 'grid',
                gridTemplateColumns: '1fr 1fr',
                gap: '1rem',
                marginBottom: '1.5rem'
              }}>
                <div>
                  <label style={{
                    display: 'block',
                    marginBottom: '0.5rem',
                    fontWeight: '600',
                    color: '#374151'
                  }}>
                    Fecha de Inicio:
                  </label>
                  <input
                    type="date"
                    name="fechaInicio"
                    defaultValue={asignacionData.fechaInicio}
                    min={new Date().toISOString().split('T')[0]}
                    required
                    style={{
                      width: '100%',
                      padding: '0.75rem',
                      border: '2px solid #e5e7eb',
                      borderRadius: '8px',
                      fontSize: '14px',
                      boxSizing: 'border-box'
                    }}
                  />
                </div>
                <div>
                  <label style={{
                    display: 'block',
                    marginBottom: '0.5rem',
                    fontWeight: '600',
                    color: '#374151'
                  }}>
                    Fecha de Fin:
                  </label>
                  <input
                    type="date"
                    name="fechaFin"
                    defaultValue={asignacionData.fechaFin}
                    min={new Date().toISOString().split('T')[0]}
                    required
                    style={{
                      width: '100%',
                      padding: '0.75rem',
                      border: '2px solid #e5e7eb',
                      borderRadius: '8px',
                      fontSize: '14px',
                      boxSizing: 'border-box'
                    }}
                  />
                </div>
              </div>

              {/* Botones */}
              <div style={{
                display: 'flex',
                gap: '1rem',
                justifyContent: 'flex-end'
              }}>
                <button
                  type="button"
                  onClick={() => setShowAsignacionModal(false)}
                  style={{
                    backgroundColor: '#6b7280',
                    color: 'white',
                    border: 'none',
                    padding: '0.75rem 1.5rem',
                    borderRadius: '8px',
                    cursor: 'pointer',
                    fontSize: '14px',
                    fontWeight: '500'
                  }}
                >
                  Cancelar
                </button>
                <button
                  type="submit"
                  style={{
                    backgroundColor: '#10b981',
                    color: 'white',
                    border: 'none',
                    padding: '0.75rem 1.5rem',
                    borderRadius: '8px',
                    cursor: 'pointer',
                    fontSize: '14px',
                    fontWeight: '500'
                  }}
                >
                  ✅ Crear Asignación
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </DashboardBase>
  );
};

export default EvaluacionesManager;
